
// 12 версия пока кроме отмен с бара не вижу проблем в логике и подсчете ходов
import React, { useEffect, useState, useCallback,useRef,useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import { useParams, useLocation } from 'react-router-dom';
// Важно: используем "tournamentSocket" (namespace '/tournament'), а НЕ обычный "socket".
import socket from './socket';
import ShortTimerController from './ShortTimerController';
import GnuAnalysisViewer from './components/GnuAnalysisViewer';

import { useGame } from './context/GameContext';
import BoardDisplay from './BoardDisplay';
import { useNavigate } from 'react-router-dom';
const ShortBackgammonBoard = () => {
  const { t: translate } = useTranslation();

  const location = useLocation();
  const { tableId } = useParams();
  // 🔒 Флаг «партия завершена» (нужен, чтобы после F5 оставалась кнопка «Выйти», а не «Сдаться»)
  const finishedKey = useMemo(() => `short:gameFinished:${String(tableId ?? '')}`, [tableId]);
  const [board, setBoard] = useState(Array(24).fill().map(() => []));
  const shortBackgammonBoardUsername = localStorage.getItem('username') || '';

  const {
    // Board / color / turn

    // Off-board
    whiteOffBoard,    setWhiteOffBoard,
    blackOffBoard,    setBlackOffBoard,

    // Captured, rolled dice, game, ...
    
    // tournamentGame,             setTournamentGame,
    firstRollComplete, setFirstRollComplete, 
    firstRolls, setFirstRolls,
    rollEnabled, setRollEnabled,
    readyStatus,      setReadyStatus,
    updateReadyStatus, 
    boardState, setBoardState,
    playerColor, setPlayerColor,
     capturedCheckers, setCapturedCheckers,
    rolledDice, setRolledDice,usedRolls, setUsedRolls,
    // Прочее
   
  } = useGame();


  //////////////////////////////////////////////////////////////////////////
  // Локальные состояния
  //////////////////////////////////////////////////////////////////////////
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const justConfirmedRef = useRef(false);
  // const [currentTurn,setCurrentTurn]   = useState([null]);
// ✅ просто null, ты дальше сравниваешь со строками
const [currentTurn, setCurrentTurn] = useState(null);

  const [player1Name,  setPlayer1Name]  = useState(null);
  const [player2Name,  setPlayer2Name]  = useState(null);
  const [player1Dice,  setPlayer1Dice]  = useState(null);
  const [player2Dice,  setplayer2Dice]  = useState(null);
  const [firstMoveComplete,  setFirstMoveComplete]  = useState(false);
  const [opponentRolledDice,  setOpponentRolledDice]  = useState(false);
  const [opponentColor, setOpponentColor] = useState(null);
  const [showUndoButton, setShowUndoButton] = useState(false); // Отображение кнопки "Отменить ход"
  const [matchId, setMatchId] = useState(null);
  const [leaving, setLeaving] = React.useState(false);


  const [isTie, setIsTie] = useState(false);
  const [showFirstRollButton, setShowFirstRollButton] = useState(true);
  const [numberMove, setNumberMove] = useState(2);
  const [myUserId, setMyUserId] = useState(null);
  const [showReadyButton, setShowReadyButton] = useState(false);
  const params    = new URLSearchParams(location.search);


  const [countdown, setCountdown] = useState(null);
  const [rollButtonEnabled, setRollButtonEnabled] = useState(false);
  const [countdownMessage, setCountdownMessage] = useState('');
 const spectate = new URLSearchParams(location.search).get('spectator') === '1';

 const [confirmedTurns, setConfirmedTurns] = useState([]);



 // ✅ Нужно, чтобы обработчики socket-событий всегда видели актуальную длину confirmedTurns
const confirmedTurnsRef = useRef([]);
useEffect(() => {
  confirmedTurnsRef.current = confirmedTurns;
}, [confirmedTurns]);


 const [cubeEvents, setCubeEvents] = useState([]);

/**
 * Пишем события куба в лог (offer/take/drop/nodouble etc)
 */
function pushCubeEvent(ev) {
  setCubeEvents((prev) => {
    const now = Date.now();

    // BoardDisplay группирует события по moveNum.
    // Если moveNum не положить — событие выкидывается и куб не показывается в тексте партии.
    const explicitMoveNum =
      ev?.moveNum ??
      ev?.move_num ??
      ev?.moveNumber ??
      ev?.move_number;

    // Для take/drop часто удобнее привязаться к последнему offer:
    const offerMoveNum =
      lastDoubleOfferRef.current?.moveNum ??
      lastDoubleOfferRef.current?.move_num ??
      null;

    // Финальный фолбэк: «следующий ход» = кол-во подтверждённых ходов + 1
    const nextMoveNum =
      (Array.isArray(confirmedTurnsRef.current) ? confirmedTurnsRef.current.length : 0) + 1;

    const moveNum = Number(explicitMoveNum ?? offerMoveNum ?? nextMoveNum) || nextMoveNum;

    const next = [
      ...prev,
      {
        id: `${now}-${Math.random().toString(16).slice(2)}`,
        ts: now,
        ...ev,
        moveNum,
      },
    ];
    return next.slice(-120); // не раздуваем
  });
}





function normalizeMoveGame(payload) {
  const raw = payload?.moveGame ?? payload?.move_game ?? [];

  // если уже массив — ок
  if (Array.isArray(raw)) return raw;

  // если строка — пробуем распарсить (иногда бывает "строка в строке")
  if (typeof raw === "string" && raw.trim() !== "") {
    try {
      const once = JSON.parse(raw);
      if (Array.isArray(once)) return once;
      if (typeof once === "string") {
        const twice = JSON.parse(once);
        return Array.isArray(twice) ? twice : [];
      }
    } catch (e) {
      console.error("[moveGame] parse error:", e);
    }
  }

  return [];
}


/**
 * Добавляет в confirmedTurns служебную строку под куб (без костей/ходов),
 * чтобы событие Double сразу печаталось в списке ходов.
 *
 * ВАЖНО:
 * - добавляем только если это действительно следующий ход (moveNum === prev.length + 1),
 *   иначе мы сломаем нумерацию ходов.
 * - если строка уже есть (последняя строка — isCubeTurn) — второй раз не добавляем.
 */
function ensureCubePlaceholderTurn({ moveNum, byName }) {
  const wantMoveNum = Number(moveNum);
  if (!wantMoveNum || wantMoveNum < 1) return;

  setConfirmedTurns((prev) => {
    const arr = Array.isArray(prev) ? prev : [];

    // Уже есть этот ход (или даже дальше) — ничего не делаем.
    if (arr.length >= wantMoveNum) return arr;

    // Мы умеем добавить только «следующий» ход, иначе появится дырка в нумерации.
    if (arr.length + 1 !== wantMoveNum) return arr;

    const last = arr.length ? arr[arr.length - 1] : null;
    if (last && last.isCubeTurn === true && last.cubeMoveNum === wantMoveNum) return arr;

    const nowTs = Date.now();
    const who = byName || shortBackgammonBoardUsername || 'Cube';

    const next = [
      ...arr,
      {
        ts: nowTs,
        player: who,
        dice: [],
        moves: [],
        // служебные поля — на игровую логику не влияют
        isCubeTurn: true,
        cubeAction: 'double_offer',
        cubeMoveNum: wantMoveNum,
      },
    ];

    return next;
  });
}


const [lastMoveType, setLastMoveType] = useState(null); // 'click' или 'drag'
const [lastMoveRoll, setLastMoveRoll] = useState(null); // Добавляем состояние для последнего значения кубика
const [moveHistory, setMoveHistory] = useState([]); // Добавляем состояние для последнего значения кубика
const [undoCooldown, setUndoCooldown] = useState(false);


 const [hasRolledDice, setHasRolledDice] = useState(false)
 const [disableBoardClicks, setDisableBoardClicks] = useState(false);
 const [isMoveConfirmed, setIsMoveConfirmed] = useState(false);
 const [initialRollPhase, setInitialRollPhase] = useState(false);
 const [mustUseTwoMoves, setMustUseTwoMoves] = useState(false);
 const [gameResult, setGameResult] = useState(null);
 const [showResultModal, setShowResultModal] = useState(false);
 const [gameFinished, setGameFinished] = useState(false);

// 🔒 Нужно, чтобы сокет-обработчики знали актуальное состояние (идёт партия или уже закончилась)
const gameFinishedRef = useRef(gameFinished);
useEffect(() => {
  gameFinishedRef.current = gameFinished;
}, [gameFinished]);


  // restore gameFinished from localStorage (после обновления страницы)
  useEffect(() => {
    if (!tableId) return;
    try {
      if (localStorage.getItem(finishedKey) === '1') {
        setGameFinished(true);
      }
    } catch (e) {}
  }, [tableId, finishedKey]);

 const confirmInProgressRef = useRef(false);
  const [confirmInProgressUi, setConfirmInProgressUi] = useState(false);

//  const [player1Time, setPlayer1Time] = useState(300);
//  const [player2Time, setPlayer2Time] = useState(300);
const player1TimeRef = useRef(null);
const player2TimeRef = useRef(null);

// ref на время в мобильном HUD
const mobilePlayer1TimeRef = useRef(null);
const mobilePlayer2TimeRef = useRef(null);

 const [betMultiplier, setBetMultiplier] = useState(1);
 const [cubeOwner, setCubeOwner] = useState(null);
 const [showDoubleDialog, setShowDoubleDialog] = useState(false);
 const [doubleOffer, setDoubleOffer] = useState(null); // { from, proposedMultiplier }
 const [tableMaxBet, setTableMaxBet] = useState(0);
 const [isCrawford, setIsCrawford] = useState(false);
 const [isSpectator] = useState(spectate); // ← сразу подставляем значение из URL
// === [AVATARS] локальные состояния ===
const [player1Avatar, setPlayer1Avatar] = useState(null);
const [player2Avatar, setPlayer2Avatar] = useState(null);
const [player1Rating, setPlayer1Rating] = useState(null);
const [player2Rating, setPlayer2Rating] = useState(null);

const [autoRoll, setAutoRoll] = useState(false);
const [autoConfirm, setAutoConfirm] = useState(false);


const [isConnected, setIsConnected] = useState(socket.connected);






// const canConfirmMove =
//   !isSpectator &&
//   !gameFinished &&
//   isConnected &&
//   moveHistory.length > 0 &&          // есть локальные ходы
//   numberMove === 0 &&                // все кубики отыграны
//   (
//     (playerColor === 'white' && currentTurn === 'player1') ||
//     (playerColor === 'black' && currentTurn === 'player2')
//   );

// показываем кнопку "Подтвердить" и для пасса,
// главное чтобы кубики были брошены и ходов не осталось

const remainingForUi = hasRolledDice
  ? calculateRemainingRolls(rolledDice, usedRolls)
  : [];

  
const canConfirmMove =
  !isSpectator &&
  !gameFinished &&
  isConnected &&
  hasRolledDice &&                   // ← важно: бросок уже был
  numberMove === 0 &&                // ← нет ходов (в т.ч. из-за блока с бара)
  (
    (playerColor === 'white' && currentTurn === 'player1') ||
    (playerColor === 'black' && currentTurn === 'player2')
  );


// маленькая пауза между авто-действиями (подбери по вкусу)
const AUTO_DELAY_MS = 350;

// таймеры для отложенного старта 
const autoRollTimerRef = useRef(null);
const autoConfirmTimerRef = useRef(null);
const cubeBlockedRef = useRef(false);
const previousAutoRollRef = useRef(false);

// универсальная метка «когда в последний раз сработала авто-кнопка»
const lastAutoActionAtRef = useRef(0);


const lastDoubleOfferRef = useRef(null);

// ⚠️ таймер, чтобы сбрасывать lastDoubleOfferRef НЕ мгновенно (иначе late-события куба могут прилетать уже в новую партию)
const clearLastOfferTimerRef = useRef(null);



// уже есть, но используем как «антидубль» подтверждения
// const justConfirmedRef = useRef(false);

// полезно иметь рефы на актуальные значения
const currentTurnRef = useRef(currentTurn);
// Защита от запоздалого снапшота, сделанного до автоматического первого броска.
const shortLiveOpeningRef = useRef(null);





const currentTurnMetaRef = useRef(currentTurn);
useEffect(() => { currentTurnMetaRef.current = currentTurn; }, [currentTurn]);

const betMultiplierRef = useRef(betMultiplier);
useEffect(() => { betMultiplierRef.current = betMultiplier; }, [betMultiplier]);

const cubeOwnerRef = useRef(cubeOwner);
useEffect(() => { cubeOwnerRef.current = cubeOwner; }, [cubeOwner]);



const [scoreP1, setScoreP1] = useState(0);
const [scoreP2, setScoreP2] = useState(0);
const [targetPoints, setTargetPoints] = useState(1);
const closingRef = useRef(false);
// где-то рядом с остальными ref
const playerColorRef = useRef(null);
useEffect(() => { playerColorRef.current = playerColor; }, [playerColor]);


 

 const navigate = useNavigate();
  
 function deepCopyBoard(board) {
  return board.map(point => point.map(checker => ({ ...checker })));
}


useEffect(() => { currentTurnRef.current = currentTurn; }, [currentTurn]);

const hasRolledDiceRef = useRef(hasRolledDice);
useEffect(() => { hasRolledDiceRef.current = hasRolledDice; }, [hasRolledDice]);

const numberMoveRef = useRef(numberMove);
useEffect(() => { numberMoveRef.current = numberMove; }, [numberMove]);

// маленький helper для безопасного планирования одного таймера
function scheduleOnce(timerRef, fn, delay = AUTO_DELAY_MS) {
  if (timerRef.current) return;
  timerRef.current = setTimeout(() => {
    timerRef.current = null;
    fn();
  }, delay);
}


// === [AVATARS] helper: нормализация URL ===
const API_ORIGIN =
  (import.meta?.env?.VITE_API_ORIGIN) ||
  (process.env.REACT_APP_API_ORIGIN) ||
  'http://localhost:5000';

function normalizeAvatar(url) {
  if (!url) return '/img/default-avatar.png';
  if (/^https?:\/\//i.test(url)) return url;
  return `${API_ORIGIN}${url}`;
}








useEffect(() => {
  const handleConnect = () => setIsConnected(true);
  const handleDisconnect = () => setIsConnected(false);

  socket.on('connect', handleConnect);
  socket.on('disconnect', handleDisconnect);

  return () => {
    socket.off('connect', handleConnect);
    socket.off('disconnect', handleDisconnect);
  };
}, []);

// рядом с другими import/useEffect
const CLIENT_VER = 'short-12.0';

function quickHash(obj) {
  try {
    const s = JSON.stringify(obj);
    // простенький хеш без зависимостей
    let h = 0;
    for (let i = 0; i < s.length; i++) { h = (h*31 + s.charCodeAt(i)) | 0; }
    return String(h);
  } catch { return '0'; }
}


// Роль привязываем к КОНКРЕТНОМУ столу, а не к устаревшему localStorage.
// Это важно для player1: он открывает доску раньше, чем присоединится player2.
const shortRoleForTableRef = useRef({ tableId: null, role: null });

// ← ДОБАВИТЬ: подписка на "short:youAre" от сервера
useEffect(() => {
  function handleYouAre({ tableId: id, role, color }) {
    // игнорируем чужие столы
    if (String(id) !== String(tableId)) return;

    // Сервер подтвердил роль именно на текущем столе. Сохраняем синхронно в ref:
    // React setState может примениться уже ПОСЛЕ события первого броска.
    shortRoleForTableRef.current = {
      tableId: String(id),
      role: role === 'player1' || role === 'player2' ? role : null,
    };

    // сохраняем в localStorage (используется при leaveTable и реjoin)
    localStorage.setItem('currentTableId', String(id));
    localStorage.setItem('gameType', 'short');
    if (role) {
      localStorage.setItem('role', role); // 'player1' | 'player2'
    } else {
      localStorage.removeItem('role');     // зритель
    }

    // цвет для этого стола от сервера — используем как «истину»
    if (color === 'white' || color === 'black') {
      playerColorRef.current = color; // доступно сразу, не дожидаясь нового render
      setPlayerColor(color);
      setOpponentColor(color === 'white' ? 'black' : 'white');
    }
  }

  socket.on('short:youAre', handleYouAre);
  return () => socket.off('short:youAre', handleYouAre);
}, [tableId, setPlayerColor, setOpponentColor]);




useEffect(() => {
  if (!tableId) return;

  const requestedTableId = Number(tableId);

  if (
    !Number.isInteger(requestedTableId) ||
    requestedTableId <= 0
  ) {
    window.location.replace('/');
    return;
  }

  if (!isConnected) {
    confirmInProgressRef.current = false;
    justConfirmedRef.current = false;

    setDisableBoardClicks(true);
    setShowUndoButton(false);

    setMoveHistory([]);
    setLastMoveType(null);
    setUsedRolls([]);
    setIsMoveConfirmed(false);

    setRollEnabled(false);
    setHasRolledDice(false);
    setRolledDice([]);
    setNumberMove(0);

    return;
  }

  let cancelled = false;

  /*
   * Пока сервер не подтвердил, что URL соответствует
   * активному столу пользователя, доску блокируем.
   */
  setDisableBoardClicks(true);

  socket.emit('short_getMyActiveTable', (resp) => {
    if (cancelled) return;

    const activeTableId = Number(resp?.tableId);

    /*
     * Пользователь открыл прямую ссылку другого cash-стола,
     * хотя у него уже есть собственная незавершённая игра.
     */
    if (
      resp?.ok &&
      Number.isInteger(activeTableId) &&
      activeTableId > 0 &&
      activeTableId !== requestedTableId
    ) {
      console.warn(
        '[SHORT BOARD] неверный URL стола, возвращаем в активный:',
        {
          requestedTableId,
          activeTableId
        }
      );

      window.location.replace(
        `/ShortBackgammonBoard/${activeTableId}`
      );

      return;
    }

    /*
     * Другой активный стол не найден либо URL уже правильный.
     * Теперь разрешаем join и запрашиваем состояние.
     */
    socket.emit('joinTable', {
      tableId: requestedTableId
    });

    socket.emit(
      'backgammonFetchData',
      requestedTableId
    );

    socket.emit('short_requestTimerSync', {
      tableId: requestedTableId
    });

    socket.emit('short_requestCubeState', {
      tableId: requestedTableId
    });

    setDisableBoardClicks(false);
  });

  return () => {
    cancelled = true;
  };
}, [isConnected, tableId]);






function blockAutoRollNow() {
  cubeBlockedRef.current = true;             // мгновенный блок без ожидания рендера
  if (autoRollTimerRef.current) {            // снять уже запланированный таймер
    clearTimeout(autoRollTimerRef.current);
    autoRollTimerRef.current = null;
  }
}

// ───────────────────  ДОБАВЬТЕ ниже остальных useEffect‑подписок  ───────────────────
useEffect(() => {
  


  function handleDoubleOffered({ tableId: id, from, proposedMultiplier }) {
  if (String(id) !== String(tableId)) return;

  // Если сервер прислал эхо МОЕГО же предложения куба — игнорируем,
  // чтобы не сдвигать moveNum (мы уже залогировали это в handleOfferDouble).
  if (from === shortBackgammonBoardUsername) return;

  const moveNum =
    (Array.isArray(confirmedTurnsRef.current) ? confirmedTurnsRef.current.length : 0) + 1;

  // ✅ запоминаем последнее предложение + к какому ходу оно относится
  lastDoubleOfferRef.current = { from, proposedMultiplier, ts: Date.now(), moveNum };

  // ✅ ЛОГ: соперник предложил куб
  pushCubeEvent({
    type: 'offer',
    by: from,
    fromMult: Number(betMultiplierRef.current) || 1,
    toMult: Number(proposedMultiplier) || ((Number(betMultiplierRef.current) || 1) * 2),
    moveNum,
  });

  // ✅ печатаем куб СРАЗУ (ещё до броска) — добавляем служебную строку в confirmedTurns
  ensureCubePlaceholderTurn({ moveNum, byName: from });

  previousAutoRollRef.current = autoRoll;
  blockAutoRollNow();
  setAutoRoll(false);
  setDoubleOffer({ from, proposedMultiplier });
  setShowDoubleDialog(true);
}



//   function handleDoubleOffered({ tableId: id, from, proposedMultiplier }) {
//   if (String(id) !== String(tableId)) return;

// const moveNum = (Array.isArray(confirmedTurnsRef.current) ? confirmedTurnsRef.current.length : 0) + 1;

//    // ✅ запоминаем последнее предложение
//   // ✅ запоминаем последнее предложение + КАКОМУ ХОДУ оно принадлежит
// lastDoubleOfferRef.current = { from, proposedMultiplier, ts: Date.now(), moveNum };


//   // ✅ ЛОГ: соперник предложил куб
//   pushCubeEvent({
//     type: 'offer',
//     by: from,
//     fromMult: Number(betMultiplierRef.current) || 1,
//     toMult: Number(proposedMultiplier) || ((Number(betMultiplierRef.current) || 1) * 2),
//     moveNum
//   });


//   previousAutoRollRef.current = autoRoll;  // <- что было до диалога
//   blockAutoRollNow();
//   setAutoRoll(false);                      // <- временно OFF
//   setDoubleOffer({ from, proposedMultiplier });
//   setShowDoubleDialog(true);
// }


  /* (б) «куб подсвечён» (видят оба) → можно, например, показать анимацию */
  function handleDoubleProposed({ tableId: id, by, newMultiplier }) {
    if (String(id) !== String(tableId)) return;
    // … здесь любая визуализация, напр. setHighlightCube(true);
  
  }

 

  function handleDoubleAccepted({ tableId: id, multiplier, cubeOwner }) {
  if (String(id) !== String(tableId)) return;

   // ✅ ЛОГ: куб принят
  const offer = lastDoubleOfferRef.current;


const moveNum = offer?.moveNum;

  pushCubeEvent({
    type: 'take',
    response: 'take',
    by: (offer?.from && offer.from === shortBackgammonBoardUsername)
      ? (player1Name === shortBackgammonBoardUsername ? player2Name : player1Name) // кто принял
      : shortBackgammonBoardUsername, // запасной вариант
    newMult: Number(multiplier) || null,
    ownerAfter: cubeOwner || null,
    moveNum,
  });



  setBetMultiplier(multiplier);
  setCubeOwner(cubeOwner);
  setShowDoubleDialog(false);
  setDoubleOffer(null);  
  cubeBlockedRef.current = false;                  // <- важно, чтобы снялся блок
  setAutoRoll(previousAutoRollRef.current);// <- вернуть то, что хотел юзер
}

function handleDoubleRejected({ tableId: id }) {
  if (String(id) !== String(tableId)) return;

  const offer = lastDoubleOfferRef.current;
  const moveNum = offer?.moveNum;

  pushCubeEvent({
    type: 'drop',
    response: 'pass',
    by: (offer?.from && offer.from === shortBackgammonBoardUsername)
      ? (player1Name === shortBackgammonBoardUsername ? player2Name : player1Name)
      : shortBackgammonBoardUsername,
    moveNum,
  });

  // ✅ Страховка: если строка под куб ещё не создана (например, из-за гонки событий),
  // то создаём её сейчас.
  //
  // Важно: используем offer.moveNum (а НЕ prev.length+1), чтобы куб НЕ переезжал
  // на первый ход следующей партии в матче.
  if (offer?.moveNum) {
    ensureCubePlaceholderTurn({ moveNum: offer.moveNum, byName: offer.from });
  }

  setShowDoubleDialog(false);
  setDoubleOffer(null);
  cubeBlockedRef.current = false;
  setAutoRoll(previousAutoRollRef.current);
}

  /* (г) отклонено → партия закончится отдельным событием game_over_result */
  // function handleDoubleRejected({ tableId: id }) {
  //   if (String(id) !== String(tableId)) return;
  //   setShowDoubleDialog(false);
  // }
//   function handleDoubleRejected({ tableId: id }) {
//   if (String(id) !== String(tableId)) return;

//    // ✅ ЛОГ: куб отклонён (PASS / DROP)
//   const offer = lastDoubleOfferRef.current;

//   const moveNum = offer?.moveNum;

//   pushCubeEvent({
//     type: 'drop',
//     response: 'pass', // ✅ ДОБАВИТЬ
//     by: (offer?.from && offer.from === shortBackgammonBoardUsername)
//       ? (player1Name === shortBackgammonBoardUsername ? player2Name : player1Name)
//       : shortBackgammonBoardUsername,
//     moveNum, 
//   });

//     // ✅ ВАЖНО ДЛЯ ПЕЧАТИ КУБА В ТЕКСТЕ ПАРТИИ:
//   // При PASS/DROP ход с костями НЕ происходит, поэтому confirmedTurns НЕ увеличивается,
//   // а cubeEvents привязаны к (confirmedTurns.length + 1). Из-за этого куб «не на что повесить»
//   // и он не рисуется в списке ходов.
//   // Решение: добавляем в confirmedTurns ПУСТОЙ (без костей/ходов) служебный ход,
//   // чтобы появился ряд в списке и по нему можно было кликнуть и открыть анализ куба.
//   setConfirmedTurns((prev) => {
//     const wantIndex = (Array.isArray(prev) ? prev.length : 0) + 1; // тот самый moveNum

//     // Если вдруг уже добавляли такой служебный ход — второй раз не добавляем.
//     const last = Array.isArray(prev) && prev.length > 0 ? prev[prev.length - 1] : null;
//     if (last && last?.isCubeTurn === true) return prev;

//     const nowTs = Date.now();
//     // Нам нужен игрок, который ДАЛ куб (чтобы строка выглядела “правильно” по цвету/имени)
//     const who = offer?.from || shortBackgammonBoardUsername || 'Cube';

//     const next = [
//       ...(Array.isArray(prev) ? prev : []),
//       {
//         ts: nowTs,
//         player: who,
//         dice: [],
//         moves: [],
//         // служебные поля — на игровую логику не влияют
//         isCubeTurn: true,
//         cubeAction: 'double_drop',
//         cubeMoveNum: wantIndex,
//       },
//     ];

//     return next.slice(-60);
//   });


//   setShowDoubleDialog(false);
//   setDoubleOffer(null);                    // <- важно, чтобы снялся блок
//   cubeBlockedRef.current = false;   
//   setAutoRoll(previousAutoRollRef.current);
// }

  socket.on('short_doubleOffered',  handleDoubleOffered);
  socket.on('short_doubleProposed', handleDoubleProposed);
  socket.on('short_doubleAccepted', handleDoubleAccepted);
  socket.on('short_doubleRejected', handleDoubleRejected);

  return () => {
    socket.off('short_doubleOffered',  handleDoubleOffered);
    socket.off('short_doubleProposed', handleDoubleProposed);
    socket.off('short_doubleAccepted', handleDoubleAccepted);
    socket.off('short_doubleRejected', handleDoubleRejected);
  };
}, [tableId, gameFinished]);



useEffect(() => {
  if (!autoRoll) return;
  if (cubeBlockedRef.current) return;
  if (gameFinished) return;
  if (showDoubleDialog) return;

  // ждём, пока точно известны цвет и чей ход
  if (playerColor !== 'white' && playerColor !== 'black') return;
  if (currentTurn !== 'player1' && currentTurn !== 'player2') return;

  const myRole = (playerColor === 'white') ? 'player1' : 'player2';
  const isMyTurn = (currentTurn === myRole);

  if (isMyTurn && !hasRolledDice) {
    scheduleOnce(autoRollTimerRef, () => {
      const stillMyTurn = (currentTurnRef.current === myRole);
      if (!stillMyTurn || hasRolledDiceRef.current) return;

      // 🔸 ДОПОЛНИТЕЛЬНАЯ НЕБОЛЬШАЯ ПАУЗА ДЛЯ АВТОБРОСКА
      setTimeout(() => {
        const stillMyTurnNow = (currentTurnRef.current === myRole);
        if (!stillMyTurnNow || hasRolledDiceRef.current) return;

        const now = Date.now();
        if (now - lastAutoActionAtRef.current < AUTO_DELAY_MS) return;
        lastAutoActionAtRef.current = now;

        handleRollDiceClick();
      }, 400); // ← тут задержка автоброска (можешь потом изменить)
    });
  }
}, [autoRoll, currentTurn, playerColor, hasRolledDice, gameFinished, showDoubleDialog]);

// useEffect(() => {
//   if (!autoRoll) return;
//   if (cubeBlockedRef.current) return;
//   if (gameFinished) return;
//   if (showDoubleDialog) return;

//   const myRole = (playerColor === 'white') ? 'player1' : 'player2';
//   const isMyTurn = (currentTurn === myRole);

//   if (isMyTurn && !hasRolledDice) {
//     scheduleOnce(autoRollTimerRef, () => {
//       // повторная проверка в момент срабатывания таймера (на случай, что состояние изменилось)
//       const stillMyTurn = (currentTurnRef.current === myRole);
//       if (!stillMyTurn || hasRolledDiceRef.current) return;

//       // мягкий троттлинг, чтобы два авто-события не наложились
//       const now = Date.now();
//       if (now - lastAutoActionAtRef.current < AUTO_DELAY_MS) return;
//       lastAutoActionAtRef.current = now;

//       handleRollDiceClick();
//     });
//   }
// }, [autoRoll, currentTurn, playerColor, hasRolledDice, gameFinished, showDoubleDialog]);


useEffect(() => {
  if (!autoConfirm) return;
  if (gameFinished || showDoubleDialog) return;

  // опять ждём, пока цвет и ход уже известны
  if (playerColor !== 'white' && playerColor !== 'black') return;
  if (currentTurn !== 'player1' && currentTurn !== 'player2') return;

  const myRole = (playerColor === 'white') ? 'player1' : 'player2';
  const isMyTurn = (currentTurn === myRole);

  if (!isMyTurn) return;
  // ⚠️ ВАЖНО: авто-подтверждение можно делать ТОЛЬКО после броска кубиков.
  // Иначе при включённом автоходе и выключенном автоброске (autoRoll=false)
  // ход может «подтвердиться» сразу в начале твоего хода, без броска.
  if (!hasRolledDice) return;
  if (numberMove !== 0) return;
  if (confirmInProgressRef.current || justConfirmedRef.current) return;

  const remaining = calculateRemainingRolls(rolledDice, usedRolls);
  const barCount = capturedCheckers[playerColor] || 0;

// ✅ Багфикс (бар + автоход):
// Если шашки на баре и есть НЕиспользованные кубики, но входа нет (все пункты входа закрыты),
// то НЕ подтверждаем ход автоматически.
// Вместо этого выключаем автоход, чтобы появилась кнопка "ОК" и игрок сам завершил ход.
//
// Важно: проверяем именно remaining.length > 0.
// Если remaining пустой — это нормальное окончание хода (кубики уже потрачены), там автоход можно оставлять.
if (barCount > 0 && remaining.length > 0) {
  const barBlocked = checkBarMoveAvailability(
    remaining,
    board,
    capturedCheckers,
    playerColor
  );

  if (barBlocked) {
    // на всякий случай снимаем уже запланированный авто-подтверждающий таймер
    if (autoConfirmTimerRef.current) {
      clearTimeout(autoConfirmTimerRef.current);
      autoConfirmTimerRef.current = null;
    }

    // 🔥 ключевой момент: выключаем автоход → появится кнопка "ОК" для ручного пасса
    setAutoConfirm(false);
    return;
  }

  // Если бар НЕ заблокирован, а numberMove почему-то 0 — восстанавливаем количество ходов.
  // (Иначе игрок может «залипнуть» без возможности сделать вход с бара.)
  setNumberMove(remaining.length);
  return;
}

  // const barCount = capturedCheckers[playerColor] || 0;
  // if (barCount > 0) {
  //   const barBlocked = checkBarMoveAvailability(
  //     remaining,
  //     board,
  //     capturedCheckers,
  //     playerColor
  //   );
  //   if (!barBlocked) return;
  // }

  scheduleOnce(autoConfirmTimerRef, () => {
    const stillMyTurn = (currentTurnRef.current === myRole);
    if (!stillMyTurn) return;
    if (!hasRolledDiceRef.current) return;
    if (numberMoveRef.current !== 0) return;
    if (confirmInProgressRef.current || justConfirmedRef.current) return;

    // 🔸 ДОПОЛНИТЕЛЬНАЯ ПАУЗА ПЕРЕД АВТОХОДОМ
    setTimeout(() => {
      const stillMyTurnNow = (currentTurnRef.current === myRole);
      if (!stillMyTurnNow) return;
      if (!hasRolledDiceRef.current) return;
      if (numberMoveRef.current !== 0) return;
      if (confirmInProgressRef.current || justConfirmedRef.current) return;

      const now = Date.now();
      if (now - lastAutoActionAtRef.current < AUTO_DELAY_MS) return;
      lastAutoActionAtRef.current = now;

      justConfirmedRef.current = true;
      confirmMove();
      setTimeout(() => { justConfirmedRef.current = false; }, AUTO_DELAY_MS);
    }, 400); // ← задержка автохода (можно подкрутить)
  });
}, [
  autoConfirm,
  currentTurn,
  hasRolledDice,
  numberMove,
  playerColor,
  gameFinished,
  showDoubleDialog,
  rolledDice,
  usedRolls,
  board,
  capturedCheckers
]);




function acceptDouble() {
  if (!doubleOffer) return;
  socket.emit('short_respondDouble', {
    tableId: parseInt(tableId, 10),
    accepted: true
  });
  // ожидание ответа от сервера закроет мод‑окно
}

function declineDouble() {
  if (!doubleOffer) return;
  socket.emit('short_respondDouble', {
    tableId: parseInt(tableId, 10),
    accepted: false
  });
  setShowDoubleDialog(false);   // сразу закрываем
}


// function toggleAutoRoll() {
//   setAutoRoll(v => !v);
// }
function toggleAutoRoll() {
  setAutoRoll(v => {
    const nv = !v;
    previousAutoRollRef.current = nv;  // <- запомнили предпочитаемое состояние
    return nv;
  });
}





function addConfirmedTurnSafe(turn) {
  setConfirmedTurns((prev) => {
    const arr = Array.isArray(prev) ? prev : [];
    const last = arr.length ? arr[arr.length - 1] : null;

    // ✅ Если прямо перед этим мы добавили служебную строку под куб (без костей/ходов),
    // то настоящий подтверждённый ход должен ЗАМЕНИТЬ эту строку, а не добавляться новым.
    // Иначе нумерация ходов сдвинется на +1.
    const lastIsCubePlaceholder =
      !!last &&
      last.isCubeTurn === true &&
      (Array.isArray(last.dice) ? last.dice.length === 0 : true) &&
      (Array.isArray(last.moves) ? last.moves.length === 0 : true);

    if (lastIsCubePlaceholder && last.player === turn.player) {
      const merged = {
        ...turn,
        mergedFromCubePlaceholder: true,
      };
      return [...arr.slice(0, -1), merged];
    }

    // простая защита от дубля
    const same =
      last &&
      last.player === turn.player &&
      JSON.stringify(last.dice || []) === JSON.stringify(turn.dice || []) &&
      (last.moves?.length || 0) === (turn.moves?.length || 0);

    if (same) return arr;
    return [...arr, turn];
  });
}


// function addConfirmedTurnSafe(turn) {
//   setConfirmedTurns((prev) => {
//     const last = prev[prev.length - 1];
//     // простая защита от дубля: игрок + кости + длина moves
//     const same =
//       last &&
//       last.player === turn.player &&
//       JSON.stringify(last.dice || []) === JSON.stringify(turn.dice || []) &&
//       (last.moves?.length || 0) === (turn.moves?.length || 0);

//     if (same) return prev;
//     return [...prev, turn].slice(-60);
//   });
// }


// useEffect(() => {
//   const handleShortTimer = ({ player1_time_left, player2_time_left, currentTurn }) => {
//     setPlayer1Time(player1_time_left ?? 300);
//     setPlayer2Time(player2_time_left ?? 300);
//     setCurrentTurn(currentTurn); // обновим ход
//   };

//   socket.on('short_timerStarted', handleShortTimer);
//   return () => socket.off('short_timerStarted', handleShortTimer);
// }, []);


// useEffect(() => {
//   const handleShortTimerSync = ({ player1, player2, currentTurn, turn_started_at }) => {
//     setPlayer1Time(player1 ?? 300);
//     setPlayer2Time(player2 ?? 300);
//     setCurrentTurn(currentTurn);
//   };

//   socket.on('short_timerSync', handleShortTimerSync);
//   return () => socket.off('short_timerSync', handleShortTimerSync);
// }, []);





// useEffect(() => {
//   const intervalId = setInterval(() => {
//     setPlayer1Time((prev) => currentTurn === 'player1' ? Math.max(prev - 1, 0) : prev);
//     setPlayer2Time((prev) => currentTurn === 'player2' ? Math.max(prev - 1, 0) : prev);
//   }, 1000);

//   return () => clearInterval(intervalId);
// }, [currentTurn]);



useEffect(() => {
  const id = Number(tableId);
  if (!id) {
    setError('tableId отсутствует');
    setLoading(false);
    return;
  }

  if (!isSpectator && !shortBackgammonBoardUsername) {
    setError('Нет username');
    setLoading(false);
    return;
  }

  setLoading(false); // всё ок
}, [tableId, isSpectator, shortBackgammonBoardUsername]);



// const [tournamentBoard, setTournamentBoard] = useState(initialBoardSetup(playerColor, initialBoardState));






useEffect(() => {
  function handleBoardStateUpdated(data) {

    const {
      tableId: eventTableId,
      boardState,
      player,
      currentTurn: incomingTurn,
      whiteOffBoard,
      blackOffBoard,
      updatedCapturedCheckers,
      numberMovePlayer1,
      numberMovePlayer2,
      player1Roll,
      player2Roll,
    } = data;

    // Если пришло обновление не для нашего стола => игнорируем
    if (String(eventTableId) !== String(tableId)) {
      return;
    }
    const localPlayer = (playerColor === 'white') ? 'player1' : 'player2';
    if (player === localPlayer) {
     
      return;
    }


    // 1) boardState, capturedCheckers, offBoard
    //    Просто берём «как есть» и ставим в стейт:
    setBoard(() => [...boardState]); // создаём новую ссылку массива

    // Если updatedCapturedCheckers отсутствует, подставляем пустой объект
    setCapturedCheckers(updatedCapturedCheckers || { white: 0, black: 0 });

    // Обновляем массивы снятых шашек
    // setWhiteOffBoard(whiteOffBoard || []);
    // setBlackOffBoard(blackOffBoard || []);
if (Array.isArray(whiteOffBoard)) setWhiteOffBoard(whiteOffBoard);
 if (Array.isArray(blackOffBoard)) setBlackOffBoard(blackOffBoard);

    // === ВАЖНО: используем incomingTurn, а не стейт currentTurn
  if (incomingTurn !== currentTurn) {
    setCurrentTurn(incomingTurn);
    setHasRolledDice(false);

    if (incomingTurn === 'player1') {
      setNumberMove(numberMovePlayer1 || 0);
    } else {
      setNumberMove(numberMovePlayer2 || 0);
    }
  }



  }

  socket.on('shortBackgammonBoard_boardStateUpdated', handleBoardStateUpdated);

  return () => {
    socket.off('shortBackgammonBoard_boardStateUpdated', handleBoardStateUpdated);
  };
}, [
  tableId,
  currentTurn,
  // ... можно добавить tournamentBoard, tournamentPlayerColor и т.д. —
  // но обычно подписка достаточно один раз при монтировании компонента.
]);




useEffect(() => {
  if (!gameFinished &&
      canConfirmMove &&
      !autoConfirm &&
      currentTurn === (playerColor === 'white' ? 'player1' : 'player2') &&
      hasRolledDice &&
      numberMove === 0) {

    console.log('[DEBUG OK BUTTON] ',
      { 
        moveHistoryLength: moveHistory.length,
        numberMove,
        hasRolledDice,
        isConnected,
        currentTurn,
        playerColor,
      }
    );
  }
}, [gameFinished, canConfirmMove, autoConfirm, currentTurn, playerColor, hasRolledDice, numberMove, moveHistory.length, isConnected]);



useEffect(() => {
  function handleShortBackgammonGameUpdated(game) {
    /*
     * Серверное событие может прийти от предыдущей комнаты
     * во время реконнекта или переключения URL.
     *
     * Не позволяем данным одного стола отображаться
     * на странице другого стола.
     */
    const incomingTableId = Number(
      game?.table_id ?? game?.tableId
    );

    const currentUrlTableId = Number(tableId);

    if (
      Number.isInteger(incomingTableId) &&
      Number.isInteger(currentUrlTableId) &&
      incomingTableId !== currentUrlTableId
    ) {
      console.warn(
        '[SHORT BOARD] проигнорировано событие чужого стола:',
        {
          incomingTableId,
          currentUrlTableId
        }
      );

      return;
    }

    // joinTable мог отправить до броска снимок game.current_turn=null.
    // Если он пришёл ПОСЛЕ autoFirstRoll, не разрешаем ему стереть первый ход.
    const liveOpening = shortLiveOpeningRef.current;
    if (
      liveOpening?.tableId === String(tableId) &&
      (game?.firstRollComplete === false || !game?.current_turn)
    ) {
      console.warn('[SHORT FIRST ROLL] ignored stale gameUpdated', {
        tableId, currentTurn: game?.current_turn,
        firstRollComplete: game?.firstRollComplete,
      });
      return;
    }
    if (game?.firstMoveComplete === true) shortLiveOpeningRef.current = null;

    confirmInProgressRef.current = false;
  justConfirmedRef.current = false;

  setMoveHistory([]);
  setLastMoveType(null);
  setUsedRolls([]);
  setIsMoveConfirmed(false);
  setShowUndoButton(false);

  if (game.match_id || game.id) {
    setMatchId(game.match_id ?? game.id);
  }

  // board_state — только если пришёл
  if (typeof game.board_state === 'string' && game.board_state.trim()) {
    try {
      setBoard(JSON.parse(game.board_state));
    } catch (err) {
      console.warn('Ошибка парсинга board_state:', err);
    }
  }

  // Имена — обновляем ТОЛЬКО если сервер прислал строки
  const hasP1Name = typeof game.player1_name === 'string';
  const hasP2Name = typeof game.player2_name === 'string';
  if (hasP1Name) setPlayer1Name(game.player1_name);
  if (hasP2Name) setPlayer2Name(game.player2_name);
console.log('234234234',player1Name,player2Name);

  // Цвет — меняем ТОЛЬКО если пришло хотя бы одно имя
  if (hasP1Name || hasP2Name) {
    const me = localStorage.getItem('username') || '';
    if (game.player1_name === me) {
      setPlayerColor('white');
      setOpponentColor('black');
    } else if (game.player2_name === me) {
      setPlayerColor('black');
      setOpponentColor('white');
    }
    // если ни одно имя не совпало — НЕ трогаем текущие цвета
  }

  // Аватары — обновляем, только если пришли непустые строки
  const p1New = game.player1_avatar ?? game.shortPlayer1Avatar ?? game.longPlayer1Avatar;
  const p2New = game.player2_avatar ?? game.shortPlayer2Avatar ?? game.longPlayer2Avatar;
  if (typeof p1New === 'string' && p1New.trim()) {
    setPlayer1Avatar(normalizeAvatar(p1New));
  }
  if (typeof p2New === 'string' && p2New.trim()) {
    setPlayer2Avatar(normalizeAvatar(p2New));
  }

  // Счёт/длина матча — они как раз приходят
  if (Number.isFinite(Number(game.score_player1))) setScoreP1(Number(game.score_player1));
  if (Number.isFinite(Number(game.score_player2))) setScoreP2(Number(game.score_player2));
  if (Number.isFinite(Number(game.target_points))) setTargetPoints(Number(game.target_points));

  // Рейтинг — не перетираем null'ом
  if (Number.isFinite(Number(game.player1_rating))) setPlayer1Rating(Number(game.player1_rating));
  if (Number.isFinite(Number(game.player2_rating))) setPlayer2Rating(Number(game.player2_rating));

  // Max bet / cube — можно безусловно
  if (game.Table && Number.isFinite(Number(game.Table.max_bet))) {
    setTableMaxBet(Number(game.Table.max_bet));
  }
  if (Number.isFinite(Number(game.bet_multiplier))) setBetMultiplier(Number(game.bet_multiplier));
  if ('cube_owner' in game) setCubeOwner(game.cube_owner || null);





  // Доп. поля — только если прислали
  if (typeof game.captured_checkers === 'string') {
    try { setCapturedCheckers(JSON.parse(game.captured_checkers)); } catch {}
  }
  if (typeof game.off_board === 'string') {
    try {
      const off = JSON.parse(game.off_board);
      setWhiteOffBoard(off.white || []);
      setBlackOffBoard(off.black || []);
    } catch {}
  }

  // Первому игроку gameUpdated иногда приходит раньше, чем короткое событие
  // shortBackgammon_autoFirstRoll. В предыдущей версии этот обработчик НЕ
  // восстанавливал currentTurn, а player1_rolls/player2_rolls (JSON-строки)
  // ошибочно проверялись как готовые массивы внутри условия про off_board.
  // Синхронизируем первый ход из полного серверного снимка для ОБОИХ цветов.
  const openingRolls = (raw) => {
    if (Array.isArray(raw)) return raw;
    if (typeof raw !== 'string') return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  if (
    game?.firstRollComplete === true &&
    game?.firstMoveComplete === false &&
    (game?.current_turn === 'player1' || game?.current_turn === 'player2')
  ) {
    const p1Rolls = openingRolls(game.player1_rolls);
    const p2Rolls = openingRolls(game.player2_rolls);
    const p1 = Number(p1Rolls[0]);
    const p2 = Number(p2Rolls[0]);

    // Только два одиночных стартовых кубика, НЕ история обычных ходов.
    if (
      p1Rolls.length === 1 && p2Rolls.length === 1 &&
      Number.isInteger(p1) && p1 >= 1 && p1 <= 6 &&
      Number.isInteger(p2) && p2 >= 1 && p2 <= 6 && p1 !== p2
    ) {
      const username = localStorage.getItem('username') || '';
      const roleByNames = username && game.player1_name === username
        ? 'player1'
        : username && game.player2_name === username
          ? 'player2'
          : null;
      const roleFromServer = shortRoleForTableRef.current;
      const roleBySeat = roleFromServer.tableId === String(tableId)
        ? roleFromServer.role
        : null;
      const roleByColor = playerColorRef.current === 'white'
        ? 'player1'
        : playerColorRef.current === 'black'
          ? 'player2'
          : null;
      const ownRole = roleByNames || roleBySeat || roleByColor;
      const isMyFirstTurn = ownRole === game.current_turn;

      shortLiveOpeningRef.current = {
        tableId: String(tableId),
        currentTurn: game.current_turn,
      };
      setCurrentTurn(game.current_turn);
      setFirstRollComplete(true);
      setFirstMoveComplete(false);
      setFirstRolls({ player1Roll: p1, player2Roll: p2 });
      setRolledDice(game.current_turn === 'player1' ? [p1, p2] : [p2, p1]);
      setHasRolledDice(isMyFirstTurn);
      setRollEnabled(false);
      setNumberMove(isMyFirstTurn ? 2 : 0);
      setDisableBoardClicks(!isMyFirstTurn);
    }
  } else if (game?.firstMoveComplete === true) {
    setFirstRolls({ player1Roll: null, player2Roll: null });
  }
}


  // Подписываемся
  socket.on('shortBackgammon_gameUpdated', handleShortBackgammonGameUpdated);

  // Отписываемся при размонтировании
  return () => {
    socket.off('shortBackgammon_gameUpdated', handleShortBackgammonGameUpdated);
  };
}, [tableId]);



const canOfferDouble = useMemo(() => {
  const myRole = playerColor === 'white' ? 'player1' : 'player2';
  const isMyTurn = currentTurn === myRole;
  const isCubeOwner = !cubeOwner || cubeOwner === shortBackgammonBoardUsername;
  // const tableHasMaxBet = tableMaxBet && tableMaxBet > 0;
  // return isMyTurn && isCubeOwner && !gameFinished && tableHasMaxBet;
  const betOk = !tableMaxBet || (betMultiplier * 2) <= tableMaxBet;

  // В партии Кроуфорда удвоение запрещено независимо от остальных условий.
  return !isCrawford && isMyTurn && isCubeOwner && !gameFinished && betOk;
}, [
  isCrawford,
  currentTurn,
  playerColor,
  cubeOwner,
  shortBackgammonBoardUsername,
  gameFinished,
  tableMaxBet,
  betMultiplier,
]);



useEffect(() => {
  cubeBlockedRef.current = Boolean(showDoubleDialog || doubleOffer);
}, [showDoubleDialog, doubleOffer]);




const toggleAutoConfirm = () =>
  setAutoConfirm(v => {
    const nv = !v;
    
    return nv;
  });



const onSurrenderClick = () => {
  const confirm = window.confirm(translate('game.short.resignQuestion'));
  if (!confirm) return;

  socket.emit('short_surrender', { tableId: parseInt(tableId, 10) });

};



const handleOfferDouble = () => {
  if (!tableId) return;

  // Дополнительная защита: в партии Кроуфорда не отправляем событие удвоения на сервер.
  if (isCrawford) return;

  blockAutoRollNow();

  const proposed = (Number(betMultiplierRef.current) || 1) * 2;

  const moveNum =
    (Array.isArray(confirmedTurnsRef.current) ? confirmedTurnsRef.current.length : 0) + 1;

  lastDoubleOfferRef.current = {
    from: shortBackgammonBoardUsername,
    proposedMultiplier: proposed,
    ts: Date.now(),
    moveNum,
  };

  pushCubeEvent({
    type: 'offer',
    by: shortBackgammonBoardUsername,
    fromMult: Number(betMultiplierRef.current) || 1,
    toMult: proposed,
    moveNum,
  });

  // ✅ печатаем куб СРАЗУ (ещё до броска)
  ensureCubePlaceholderTurn({ moveNum, byName: shortBackgammonBoardUsername });

  socket.emit('short_offerDouble', { tableId: parseInt(tableId, 10) });

  setTimeout(() => {
    if (!showDoubleDialog && !doubleOffer) {
      cubeBlockedRef.current = false;
    }
  }, 2000);
};

// const handleOfferDouble = () => {
//   if (!tableId) return;
//    blockAutoRollNow();


//     const proposed = (Number(betMultiplierRef.current) || 1) * 2;

//   // ✅ ЛОГ: я предложил куб
//   const moveNum =
//   (Array.isArray(confirmedTurnsRef.current) ? confirmedTurnsRef.current.length : 0) + 1;

// lastDoubleOfferRef.current = {
//   from: shortBackgammonBoardUsername,
//   proposedMultiplier: proposed,
//   ts: Date.now(),
//   moveNum
// };

//   pushCubeEvent({
//     type: 'offer',
//     by: shortBackgammonBoardUsername,
//     fromMult: Number(betMultiplierRef.current) || 1,
//     toMult: proposed,
//   });


//   socket.emit('short_offerDouble', { tableId: parseInt(tableId, 10) });

//   setTimeout(() => {
//    if (!showDoubleDialog && !doubleOffer) {
//      cubeBlockedRef.current = false;
//    }
//  }, 2000);
// };


const [gnuAnalysis, setGnuAnalysis] = useState({
  status: 'idle',   // idle | waiting | ready | error
  text: '',
  error: '',
  stderr: '',
  gameId: null,
  // 'game' | 'match' (сервер может прислать анализ всего матча)
  analysisMode: 'game',
  pr: null,        // ✅ PR/Luck для обоих
  equity: null,    // ✅ Equity (total EMG) для обоих
  cubeMoves: [],
  // для матч-анализа:
  prByGame: null,
  move_game: null,
});

// =========================
// MATCH NAV (перелистывание партий матча в анализе)
// =========================
const [matchGames, setMatchGames] = useState(null); // [{ idx, scoreAfterStr, offset, startGlobal, endGlobal, turns, analysisText, pr, cubeMoves }]
const [selectedMatchGameIndex, setSelectedMatchGameIndex] = useState(0);
const matchGamesRef = useRef(null);
useEffect(() => { matchGamesRef.current = matchGames; }, [matchGames]);

// --- helpers (внутри клиента, ничего на сервере менять не надо) ---
const safeJsonParse = (str, fallback) => {
  try {
    if (!str) return fallback;
    return JSON.parse(str);
  } catch {
    return fallback;
  }
};

// Сервер добавляет маркер { type: 'round_end', scoreBefore, scoreAfter, ... } после каждой партии матча
const splitMovesIntoRoundsClient = (moves) => {
  const rounds = [];
  let cur = [];

  for (const e of (moves || [])) {
    if (e && typeof e === 'object' && e.type === 'round_end') {
      rounds.push({ events: cur, end: e });
      cur = [];
      continue;
    }
    cur.push(e);
  }

  // ✅ ДОБАВЛЯЕМ ХВОСТ (последняя партия без round_end)
  if (cur.length > 0) {
    rounds.push({ events: cur, end: null });
  }

  return rounds;
};


const countDiceTurnsClient = (events) => {
  return (events || []).filter(e => e && Array.isArray(e.dice) && e.dice.length >= 2).length;
};


// В матче есть особый случай: дали куб и соперник сразу Pass/Drop.
// Тогда у GNUbg появляется «ход» (Move number N) с куб-решением, но БЕЗ броска костей.
// Если считать границы партии только по diceTurns, этот последний куб-ход:
//   1) вылетает из cubeMoves / cubeEvents
//   2) ломает offset для следующих партий
// В одиночной партии этого не видно, потому что «следующей партии» нет.
const needsEndCubeOnlyTurnClient = (events, endMarker) => {
  const evs = Array.isArray(events) ? events : [];

  // 1) Есть ли вообще куб-экшены в этой партии?
  let lastCubeIdx = -1;
  let sawDropAction = false;
  for (let i = evs.length - 1; i >= 0; i--) {
    const act = String(evs[i]?.cubeAction ?? evs[i]?.action ?? '').toLowerCase();
    if (act) lastCubeIdx = i;
    if (act === 'drop' || act === 'pass' || act === 'reject' || act === 'decline') {
      sawDropAction = true;
    }
    if (lastCubeIdx >= 0) break;
  }
  if (lastCubeIdx < 0) return false;

  // 2) После последнего куб-экшена были ли реальные броски костей?
  const hasDiceAfterLastCube = evs
    .slice(lastCubeIdx + 1)
    .some(e => e && Array.isArray(e.dice) && e.dice.length >= 2);

  if (hasDiceAfterLastCube) return false; // куб был «внутри» партии (take и дальше пошли ходы)

  // 3) Понять, что партия реально закончилась именно «пасом по кубу».
  //    (если reason нет — полагаемся на сам cubeAction: drop/pass)
  const reason = String(
    endMarker?.reason ??
    endMarker?.endReason ??
    endMarker?.finishReason ??
    ''
  ).toLowerCase();

  const reasonSaysDrop = /drop|pass|reject|declin|refus|double/.test(reason);
  return Boolean(sawDropAction || reasonSaysDrop);
};

// GNU для матча склеивается в один текст с разделителями:
// ====================
// GAME 1
// ====================
// ...
const splitAnalysisIntoGamesClient = (analysisText) => {
  const text = String(analysisText || '');
  const re = /^====================\nGAME\s+(\d+)\n====================\n/mg;
  const marks = [];
  let m;
  while ((m = re.exec(text)) !== null) {
    marks.push({ idx: Number(m[1]) || null, start: m.index, end: re.lastIndex });
  }
  if (!marks.length) return [text];

  const parts = [];
  for (let i = 0; i < marks.length; i++) {
    const from = marks[i].end;
    const to = (i + 1 < marks.length) ? marks[i + 1].start : text.length;
    parts.push(text.slice(from, to));
  }
  return parts;
};

const getMoveNumAny = (obj, fallback) => {
  const raw =
    obj?.moveNum ??
    obj?.move_number ??
    obj?.moveNumber ??
    obj?.moveNo ??
    obj?.ply ??
    obj?.turn ??
    obj?.move ??
    fallback;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

const buildMatchGamesFromPayload = (payload, cubeMovesAll) => {
  const movesAll = safeJsonParse(payload?.move_game, []);
  const rounds = splitMovesIntoRoundsClient(movesAll);
  const analysisParts = splitAnalysisIntoGamesClient(payload?.analysis || '');
  const prByGameArr = Array.isArray(payload?.prByGame) ? payload.prByGame : [];

  // 👇 вспомогательная функция для проверки, закончилась ли партия пасом по кубу
  const needsEndCubeOnlyTurnClient = (events, endMarker) => {
    const evs = Array.isArray(events) ? events : [];

    let lastCubeIdx = -1;
    let sawDropAction = false;
    for (let i = evs.length - 1; i >= 0; i--) {
      const act = String(evs[i]?.cubeAction ?? evs[i]?.action ?? '').toLowerCase();
      if (act) lastCubeIdx = i;
      if (act === 'drop' || act === 'pass' || act === 'reject' || act === 'decline') {
        sawDropAction = true;
      }
      if (lastCubeIdx >= 0) break;
    }
    if (lastCubeIdx < 0) return false;

    const hasDiceAfterLastCube = evs
      .slice(lastCubeIdx + 1)
      .some(e => e && Array.isArray(e.dice) && e.dice.length >= 2);

    if (hasDiceAfterLastCube) return false;

    const reason = String(
      endMarker?.reason ??
      endMarker?.endReason ??
      endMarker?.finishReason ??
      ''
    ).toLowerCase();

    const reasonSaysDrop = /drop|pass|reject|declin|refus|double/.test(reason);
    return Boolean(sawDropAction || reasonSaysDrop);
  };

  // 👇 теперь основная часть
  let offset = 0;
  const games = rounds.map((r, idx) => {
    const diceTurns = countDiceTurnsClient(r.events);
    const extraCubeOnly = needsEndCubeOnlyTurnClient(r.events, r.end) ? 1 : 0;
    const turnSlots = Math.max(0, diceTurns) + extraCubeOnly;

    const startGlobal = offset + 1;
    const endGlobal = offset + turnSlots;

    const sb = r?.end?.scoreBefore || {};
    const sa = r?.end?.scoreAfter || {};
    const p1After = Number(sa.player1 || 0);
    const p2After = Number(sa.player2 || 0);
    const scoreAfterStr = `${p1After}-${p2After}`;

    // 🎯 реальные ходы с костями
    const turns = (r.events || [])
      .filter(e => e && Array.isArray(e.dice) && e.dice.length >= 2)
      .map(e => ({
        player: e.player,
        dice: e.dice,
        moves:
          Array.isArray(e.moves) ? e.moves :
          Array.isArray(e.moveHistory) ? e.moveHistory :
          Array.isArray(e.history) ? e.history :
          Array.isArray(e.pairs) ? e.pairs :
          [],
      }));

    // 🎯 если партия кончилась пасом по кубу — добавляем фиктивный “кубовый” ход
    if (extraCubeOnly) {
      const lastDice = turns.length ? turns[turns.length - 1] : null;
      const nextPlayerRole =
        lastDice?.player === 'player1' ? 'player2'
        : lastDice?.player === 'player2' ? 'player1'
        : (r?.end?.winnerRole || 'player1');

      turns.push({
        player: nextPlayerRole,
        dice: [],
        moves: [],
        isCubeTurn: true,
        isCubeOnly: true,
      });
    }

    // 🎯 корректно подбираем cubeMoves
    const cubeMovesForGame = (Array.isArray(cubeMovesAll) ? cubeMovesAll : [])
      .map((cm, i2) => ({ cm, n: getMoveNumAny(cm, i2 + 1) }))
      .filter(({ n }) => Number.isFinite(n) && n >= startGlobal && n <= endGlobal)
      .map(({ cm, n }) => ({
        ...cm,
        moveNum: (Number(n) - offset),
      }));

    const analysisText = String(analysisParts[idx] || '').trim();
    const pr = prByGameArr[idx] ?? null;

    const out = {
      idx,
      offset,
      startGlobal,
      endGlobal,
      diceTurns,
      turnSlots,
      scoreBefore: sb,
      scoreAfter: sa,
      scoreAfterStr,
      turns,
      analysisText,
      pr,
      cubeMoves: cubeMovesForGame,
    };

    offset += turnSlots;
    return out;
  });

  return games;
};

// const buildMatchGamesFromPayload = (payload, cubeMovesAll) => {
//   const movesAll = safeJsonParse(payload?.move_game, []);
//   const rounds = splitMovesIntoRoundsClient(movesAll);
//   const analysisParts = splitAnalysisIntoGamesClient(payload?.analysis || '');
//   const prByGameArr = Array.isArray(payload?.prByGame) ? payload.prByGame : [];

//   let offset = 0;
//   const games = rounds.map((r, idx) => {
//     const diceTurns = countDiceTurnsClient(r.events);
//     const startGlobal = offset + 1;
//     const endGlobal = offset + Math.max(0, diceTurns);

//     const sb = r?.end?.scoreBefore || {};
//     const sa = r?.end?.scoreAfter || {};
//     const p1After = Number(sa.player1 || 0);
//     const p2After = Number(sa.player2 || 0);
//     const scoreAfterStr = `${p1After}-${p2After}`;

//     // turns: только реальные ходы с костями
//     const turns = (r.events || [])
//       .filter(e => e && Array.isArray(e.dice) && e.dice.length >= 2)
//       .map(e => ({
//         // BoardDisplay использует только player/dice/moves
//         player: e.player,
//         dice: e.dice,
//         moves:
//           Array.isArray(e.moves) ? e.moves :
//           Array.isArray(e.moveHistory) ? e.moveHistory :
//           Array.isArray(e.history) ? e.history :
//           Array.isArray(e.pairs) ? e.pairs :
//           [],
//       }));

//     // cubeMoves: фильтруем по глобальному номеру и сдвигаем в локальные 1..diceTurns
//     const cubeMovesForGame = (Array.isArray(cubeMovesAll) ? cubeMovesAll : [])
//       .map((cm, i2) => ({ cm, n: getMoveNumAny(cm, i2 + 1) }))
//       .filter(({ n }) => Number.isFinite(n) && n >= startGlobal && n <= endGlobal)
//       .map(({ cm, n }) => ({
//         ...cm,
//         moveNum: (Number(n) - offset),
//       }));

//     const analysisText = String(analysisParts[idx] || '').trim();
//     const pr = prByGameArr[idx] ?? null;

//     const out = {
//       idx,
//       offset,
//       startGlobal,
//       endGlobal,
//       diceTurns,
//       scoreBefore: sb,
//       scoreAfter: sa,
//       scoreAfterStr,
//       turns,
//       analysisText,
//       pr,
//       cubeMoves: cubeMovesForGame,
//     };

//     offset += Math.max(0, diceTurns);
//     return out;
//   });

//   return games;
// };

const sliceAndShiftCubeEventsForGame = (allEvents, game) => {
  if (!game) return allEvents;
  const start = Number(game.startGlobal);
  const end = Number(game.endGlobal);
  const off = Number(game.offset) || 0;

  return (Array.isArray(allEvents) ? allEvents : [])
    .map((ev, i) => ({ ev, n: getMoveNumAny(ev, i + 1) }))
    .filter(({ n }) => Number.isFinite(n) && n >= start && n <= end)
    .map(({ ev, n }) => ({
      ...ev,
      moveNum: (Number(n) - off),
    }));
};

 // Приём события game_over_result от сервера
 useEffect(() => {
  socket.on('game_over_result', (data) => {

if (data.matchId || data.match_id) {
     setMatchId(data.matchId ?? data.match_id);
   }
   confirmInProgressRef.current = false;   // ← точно снять замок
    setConfirmInProgressUi(false);

    // Сбрасываем флаги, чтобы компонент подготовился к следующему гейму
    setFirstRollComplete(false);
    setFirstMoveComplete(false);
    setHasRolledDice(false);
    setRolledDice([]);
    setUsedRolls([]);
    setGameFinished(true);
    // ✅ помним, что партия завершена (нужно, чтобы после F5 UI не показывал «Сдаться»)
    try { localStorage.setItem(finishedKey, '1'); } catch (e) {}


    // Обновляем аватарки
    data.winnerAvatar = data.winnerAvatar
      ? `http://localhost:5000${data.winnerAvatar}`
      : '/img/default-avatar.png';
    data.loserAvatar = data.loserAvatar
      ? `http://localhost:5000${data.loserAvatar}`
      : '/img/default-avatar.png';

    setGameResult(data);
    setShowResultModal(true);

    setGnuAnalysis({
  status: 'waiting',
  text: '',
  error: '',
  stderr: '',
  gameId: null,
  analysisMode: 'game',
  pr: null,
  equity: null,
  cubeMoves: [],
  prByGame: null,
  move_game: null,
});


  });

  return () => {
    socket.off('game_over_result');
  };
}, []);







useEffect(() => {
  const handler = (payload) => {
    console.log('234234',payload);
    
    const myTableId = Number(tableId);
    if (payload?.tableId != null && Number(payload.tableId) !== myTableId) return;


    // 🔒 Анализ запрещён до окончания партии (иначе это подсказка во время игры)
    if (!gameFinishedRef.current) return;

  // ✅ нормализуем cubeMoves на всякий случай
    const cubeMovesNormalized =
      Array.isArray(payload?.cubeMoves) ? payload.cubeMoves
      : payload?.cubeMoves ? [payload.cubeMoves]
      : [];


      console.log('[GNU READY]', {
  ok: payload?.ok,
  pr: payload?.pr,
  equity: payload?.equity,
  cubeMoves: payload?.cubeMoves,
});


    const analysisMode = String(payload?.analysisMode || 'game');

    if (payload?.ok) {
      // Анализ GNU построен именно по серверному moveGame.
// Поэтому и список ходов для анализа должен быть из того же источника.
const authoritativeTurns = normalizeMoveGame(payload);

if (authoritativeTurns.length > 0) {
  setConfirmedTurns(authoritativeTurns);
  confirmedTurnsRef.current = authoritativeTurns;
}
      // 1) Сохраняем «сырые» данные, которые пришли с сервера
      setGnuAnalysis({
        status: 'ready',
        text: payload.analysis || '',
        error: '',
        stderr: '',
        gameId: payload.gameId ?? null,
        analysisMode,
        pr: payload.pr ?? null,
        equity: payload.equity ?? null,
        cubeMoves: cubeMovesNormalized,
        prByGame: Array.isArray(payload?.prByGame) ? payload.prByGame : null,
        move_game: payload.move_game ?? null,
      });




      const cubeEventsNormalized =
  Array.isArray(payload?.cubeEvents) ? payload.cubeEvents
  : payload?.cubeEvents ? [payload.cubeEvents]
  : [];

if (cubeEventsNormalized.length) {
  setCubeEvents(cubeEventsNormalized);
}





      // 2) Если это матч — строим список партий для перелистывания
      if (analysisMode === 'match') {
        const games = buildMatchGamesFromPayload(payload, cubeMovesNormalized);
        setMatchGames(games);

        // если пользователь смотрел последнюю партию — переключаемся на новую последнюю
        setSelectedMatchGameIndex((prevIdx) => {
          const prevLen = Array.isArray(matchGamesRef.current) ? matchGamesRef.current.length : 0;
          const wasOnLast = prevLen > 0 && prevIdx === (prevLen - 1);
          const nextIdx = wasOnLast ? (games.length - 1) : Math.min(prevIdx, games.length - 1);
          return Math.max(0, nextIdx);
        });
      } else {
        setMatchGames(null);
        setSelectedMatchGameIndex(0);
      }
    } else {
      setGnuAnalysis({
        status: 'error',
        text: '',
        error: payload.error || i18n.t('game.analysis.failed'),
        stderr: payload.stderr || '',
        gameId: payload.gameId ?? null,
        analysisMode: 'game',
        pr: null,
        equity: null,
        cubeMoves: [],
        prByGame: null,
        move_game: null,
      });

      setMatchGames(null);
      setSelectedMatchGameIndex(0);
    }
  };

  socket.on('short_game_analysis_ready', handler);
  return () => socket.off('short_game_analysis_ready', handler);
}, [tableId]);




// ✅ при обновлении страницы просим сервер снова прислать GNU-анализ
useEffect(() => {
  if (!socket) return;


  // во время партии анализ запрещён
  if (!gameFinished) return;

  const requestGnu = () => {
    // чтобы не улетало строкой
    const id = Number(tableId);
    if (!Number.isFinite(id)) return;

    // попросить сервер переслать (или пересчитать) анализ
    socket.emit('short_request_gnu_analysis', { tableId: id });
  };

  if (socket.connected) {
    requestGnu();
  } else {
    socket.on('connect', requestGnu);
  }

  return () => {
    socket.off('connect', requestGnu);
  };
}, [tableId, gameFinished]);



const API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : '/api';



 const handleCloseResultModal = async () => {
  if (closingRef.current) return;
  closingRef.current = true;

  setShowResultModal(false);
  setGameResult(null);
  // уходим со стола → можно очистить флаг «партия завершена»
  try { localStorage.removeItem(finishedKey); } catch (e) {}

  const id = parseInt(tableId, 10);
  const username = localStorage.getItem('username') || '';

  if (!Number.isNaN(id) && shortBackgammonBoardUsername) {
    socket.emit('leaveTable', { tableId: id, player: shortBackgammonBoardUsername });
  }

  const cashBar = { tableId: Number(tableId), gameKind: 'short' };
  if (matchId) cashBar.matchId = matchId;

  // ↓↓↓ Я — ПРОИГРАВШИЙ?
  const iAmLoser =
    !isSpectator && !!gameResult && (
      (gameResult.loserName && gameResult.loserName === username) ||
      (gameResult.loserId && myUserId && Number(gameResult.loserId) === Number(myUserId)) ||
      (gameResult.winner && (
         (gameResult.winner === 'white' && playerColor === 'black') ||
         (gameResult.winner === 'black' && playerColor === 'white')
       )) ||
      (gameResult.winnerColor && (
         (gameResult.winnerColor === 'white' && playerColor === 'black') ||
         (gameResult.winnerColor === 'black' && playerColor === 'white')
       ))
    );

  // pending только проигравшему
  if (iAmLoser) {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        await fetch(`${API_BASE}/fortuneGame/pending`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ gameType: 'short' }),
        });
      }
    } catch (e) {
      console.warn('[CASH] pending mark failed', e);
    }
  }



   try {
    localStorage.removeItem('currentTableId');
    localStorage.removeItem('gameType');
    localStorage.removeItem('sessionRole');

  } catch (e) {
    console.warn('[short] cannot clear local redirect keys', e);
  }

  // В лобби cashBar передаём ТОЛЬКО проигравшему,
  // победителю — обычный navigate без state, чтобы колесо не открылось.
  const navState = iAmLoser ? { cashBar } : undefined;
  navigate('/', { replace: true, state: navState });
};


// useEffect(() => {
//   if (!showResultModal) return;
//   const t = setTimeout(() => { void handleCloseResultModal(); }, 15000);
//   return () => clearTimeout(t);
// }, [showResultModal]);




useEffect(() => {
  // 1) This event comes from: io.to(`table-${table.id}`).emit('shortBackgammon_autoFirstRoll', {...})
  function handleAutoFirstRoll(data) {

    const { tableId: eventTableId, player1Roll, player2Roll, currentTurn } = data;
    if (String(eventTableId) !== String(tableId)) return;
    if (currentTurn !== 'player1' && currentTurn !== 'player2') return;
    if (![player1Roll, player2Roll].every(n => Number.isInteger(Number(n)) && Number(n) >= 1 && Number(n) <= 6)) return;

    shortLiveOpeningRef.current = {
      tableId: String(tableId),
      currentTurn,
    };

    // началась новая партия → точно снимаем «партия завершена»
    setGameFinished(false);
    setConfirmInProgressUi(false);
    confirmInProgressRef.current = false;

    try { localStorage.removeItem(finishedKey); } catch (e) {}

    // началась новая партия → анализ снова запрещён до конца партии
    setGnuAnalysis({
      status: 'idle',
      text: '',
      error: '',
      stderr: '',
      gameId: null,
      analysisMode: 'game',
      pr: null,
      equity: null,
      cubeMoves: [],
      prByGame: null,
      move_game: null,
    });
    setMatchGames(null);
    setSelectedMatchGameIndex(0);

    // 2) Store them in local state
    setFirstRolls({ player1Roll, player2Roll });
    setCurrentTurn(currentTurn);

    if (currentTurn === 'player1') {
      setRolledDice([player1Roll, player2Roll]);   // ходит белый
    } else {
      setRolledDice([player2Roll, player1Roll]);   // ходит чёрный
    }

    /*
     * Автобросок уже является первым игровым броском победителя.
     *
     * Важно: при первом монтировании сокет может кратко быть disconnected,
     * и эффект реконнекта выше успевает сделать setNumberMove(0).
     * Раньше autoFirstRoll восстанавливал кубики и hasRolledDice, но НЕ
     * восстанавливал numberMove. В результате кубики были видны, однако
     * onPointClick / onCheckerClick сразу выходили по numberMove <= 0
     * до F5, после которого снапшот сервера возвращал значение 2.
     */
    setFirstRollComplete(true);
    setFirstMoveComplete(false);
    setUsedRolls([]);

    // Свой цвет может ещё не успеть обновиться в React, но short:youAre
    // уже сохраняет role в localStorage до начала автоматического броска.
    const roleFromColor = playerColorRef.current === 'white'
      ? 'player1'
      : playerColorRef.current === 'black'
        ? 'player2'
        : null;
    const serverSeat = shortRoleForTableRef.current;
    const confirmedRole = serverSeat.tableId === String(tableId)
      ? serverSeat.role
      : null;
    // Роль из прошлой партии в localStorage больше не может перекрыть
    // подтверждённую сервером роль или уже полученный цвет текущего стола.
    const savedRole = localStorage.getItem('currentTableId') === String(tableId)
      ? localStorage.getItem('role')
      : null;
    const ownRole = confirmedRole || roleFromColor || (
      savedRole === 'player1' || savedRole === 'player2' ? savedRole : null
    );
    const myOpeningTurn = ownRole === currentTurn;

    setHasRolledDice(myOpeningTurn);
    setRollEnabled(false);
    setDisableBoardClicks(!myOpeningTurn);

    const openingMovesFromServer =
      currentTurn === 'player1'
        ? Number(data.numberMovePlayer1)
        : currentTurn === 'player2'
          ? Number(data.numberMovePlayer2)
          : 0;

    setNumberMove(
      myOpeningTurn
        ? Number.isFinite(openingMovesFromServer) && openingMovesFromServer > 0
          ? openingMovesFromServer
          : 2
        : 0
    );

    //  setFirstRollComplete(true) 
    // If you want, also set a flag that says "firstRollComplete" = true
    // or any other logic, such as deciding which player color you are, etc. 
    // e.g. setFirstRollComplete(true);
  }

  // 3) Listen for the event once component mounts
  socket.on('shortBackgammon_autoFirstRoll', handleAutoFirstRoll);

  // 4) Cleanup
  return () => {
    socket.off('shortBackgammon_autoFirstRoll', handleAutoFirstRoll);
  };
}, [tableId, finishedKey]);




function canMakeAnyMove(board, myColor, diceValues) {
  // 0) Если кубиков нет — нет ходов
  if (!diceValues || diceValues.length === 0) {
    return false;
  }

  // 1) Проходим по всем точкам доски
  for (let fromIndex = 0; fromIndex < 24; fromIndex++) {
    // Если в этой точке есть шашки нашего цвета
    const point = board[fromIndex];
    if (point.length > 0 && point[0].color === myColor) {
      // 2) Проверяем каждый кубик
      for (const die of diceValues) {
        // Для белых ход: targetIndex = fromIndex - die
        // Для чёрных:    targetIndex = fromIndex + die
        const targetIndex =
          (myColor === 'white')
            ? fromIndex - die
            : fromIndex + die;

        // Если вышли за границы — пропускаем
        if (targetIndex < 0 || targetIndex >= 24) {
          continue;
        }

        // Смотрим, что на целевой точке
        const targetPoint = board[targetIndex] || [];

        // Можно встать, если:
        //  - пункт пуст (length === 0),
        //  - там только наши шашки (каждый checker.color === myColor),
        //  - там ровно 1 чужая (для битья).
        const canPlace =
          targetPoint.length === 0 ||
          targetPoint.every(ch => ch.color === myColor) ||
          (targetPoint.length === 1 && targetPoint[0].color !== myColor);

        if (canPlace) {
          return true; // Нашли ход => сразу выходим
        }
      }
    }
  }

  // Если перебрали всё и не нашли ни одного допустимого хода
  return false;
}



// ВАЖНО: учитываем бар и используем оставшиеся кубики (remainingRolls)
useEffect(() => {
  if (!rolledDice || rolledDice.length === 0) return;

  // 1) Какие кубики реально остались к использованию
  const remaining = calculateRemainingRolls(rolledDice, usedRolls);

  // 2) Если на баре есть шашки моего цвета — ходы возможны ТОЛЬКО с бара
  const barCount = capturedCheckers[playerColor] || 0;
  if (barCount > 0) {
    // true = заблокирован (входа нет), false = можно войти
    const barBlocked = checkBarMoveAvailability(
      remaining,
      board,
      capturedCheckers,
      playerColor
    );
    if (barBlocked) {
      setNumberMove(0);     // входа нет → пас/подтверждение уместны
    }
    return; // с баром обычные ходы нельзя, дальше не считаем
  }

  // 3) Обычные и bear-off ходы (когда бара нет)
  const canNormal = canMakeAnyNormalMove(remaining, board, playerColor);
  const canBear   = canBearOffAny(board, remaining, playerColor);

  if (!canNormal && !canBear) {
    setNumberMove(0);
  }
}, [rolledDice, usedRolls, board, capturedCheckers, playerColor]);

// useEffect(() => {
//   if (!rolledDice || rolledDice.length === 0) {
//     // Кубики не брошены или нечего проверять
//     return;
//   }

//   const possible = canMakeAnyMove(board, playerColor, rolledDice);

//   const canBear = canBearOffAny(
//        board,
//       rolledDice,
//       playerColor
//      )



//   // if (!possible) {
//     if (!possible && !canBear) {
//     // Ходов нет
//     setNumberMove(0);
//   } 
  
// }, [rolledDice, board]);

  //////////////////////////////////////////////////////////////////////////
  //  Считываем userId из localStorage (если нужно)
  //////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    const uid = parseInt(localStorage.getItem('userId'), 10);
    // console.log('[shortBackgammon] Мой userId:', uid);
    if (!Number.isNaN(uid)) {
      setMyUserId(uid);
    } else {
      console.warn('[shortBackgammon] userId не найден в localStorage');
    }
  }, []);

 




 



useEffect(() => {
  return () => {
    if (autoRollTimerRef.current) clearTimeout(autoRollTimerRef.current);
    if (autoConfirmTimerRef.current) clearTimeout(autoConfirmTimerRef.current);
  };
}, []);




  useEffect(() => {
  const handleConfirmed = (data) => {
   

    const {
      tableId: eventTableId,          // <-- не затеняем внешний tableId
      boardState,
      newCurrentTurn,
      capturedCheckers,
      whiteOffBoard,
      blackOffBoard,
      hasRolledDice,
      numberMove,
      firstMoveComplete,

       movedBy,
  turnDice,
  turnMoves,
  moveGameLen,
    } = data;

    // 1) Проверяем, что это именно наш стол
    if (String(eventTableId) !== String(tableId)) {
      console.warn('[Tournament] Получено событие не для нашего tableId:', tableId);
      return;
    }

    // ✅ пишем подтверждённый ход в лог для рендера
    if (Array.isArray(turnDice)) {
  addConfirmedTurnSafe({
    ts: Date.now(),
    player: movedBy,
    dice: turnDice,
    moves: Array.isArray(turnMoves) ? turnMoves : [],
    n: Number(moveGameLen) || undefined,
  });
} else {
  console.warn('[moveLog] confirmed без turnDice', { eventTableId, movedBy });
}

// if (Array.isArray(turnDice)) {
//   setConfirmedTurns((prev) =>
//     [...prev, {
//       ts: Date.now(),
//       player: movedBy,
//       dice: turnDice,
//       moves: Array.isArray(turnMoves) ? turnMoves : [],
//       n: Number(moveGameLen) || undefined,
//     }].slice(-60)
//   );
// } else {
//   console.warn('[moveLog] confirmed без turnDice', { eventTableId, movedBy });
// }


   // ✅ сбрасываем «идёт подтверждение»
    confirmInProgressRef.current = false;
    setConfirmInProgressUi(false);
    // 2) Разблокируем доску (если блокировали перед confirmMove)
    // justConfirmedRef.current = false;
    setDisableBoardClicks(false);

    // 2.1) 💡 Сброс истории текущего хода — чтобы Undo не залезал в прошлый ход
    setMoveHistory([]);               // <-- добавили
    setLastMoveType(null);            // <-- добавили

    // 3) Обновляем состояние
    setBoard(JSON.parse(boardState));
    setCurrentTurn(newCurrentTurn);
    setCapturedCheckers(capturedCheckers || { white: 0, black: 0 });
    setHasRolledDice(false);
    setFirstRolls({});
    setRolledDice([]);
    setNumberMove(numberMove || 0);
    setFirstRollComplete(firstMoveComplete); // (проверь, не перепутан ли флаг)
    setFirstMoveComplete(true);

    // 4) КТО теперь ходит?
    const myRole = (playerColor === 'white') ? 'player1' : 'player2';
    if (newCurrentTurn === myRole) {
      
      setHasRolledDice(false);
      // setRollEnabled(true); // если нужно показывать кнопку сразу
    } else {
      // setRollEnabled(false);
    }
  };

  socket.on('shortBackgammonBoard_confirmed', handleConfirmed);

  return () => {
    socket.off('shortBackgammonBoard_confirmed', handleConfirmed);
  };
}, [
  tableId,            // <-- зависимость по id стола
  playerColor,        // чтобы корректно высчитывать myRole при смене цвета
  // убрали board из зависимостей, чтобы не перевешивать слушатель на каждый апдейт доски
]);




useEffect(() => {
  function handleShortRoundReset(data) {
    

    if (String(data.tableId) !== String(tableId)) return;

    // Начало новой партии: предыдущее событие autobроска больше не актуально.
    shortLiveOpeningRef.current = null;
    // новая партия/раунд → снимаем флаг «партия завершена»
    setGameFinished(false);
    try { localStorage.removeItem(finishedKey); } catch (e) {}

      // ✅ ВАЖНО: новая партия должна стартовать с чистых логов
  setConfirmedTurns([]);
  confirmedTurnsRef.current = []; // чтобы pushCubeEvent сразу видел 0
  setCubeEvents([]);

  // новая партия → анализ снова запрещён до конца партии
  setGnuAnalysis({
    status: 'idle',
    text: '',
    error: '',
    stderr: '',
    gameId: null,
    analysisMode: 'game',
    pr: null,
    equity: null,
    cubeMoves: [],
    prByGame: null,
    move_game: null,
  });
  setMatchGames(null);
  setSelectedMatchGameIndex(0);

  // lastDoubleOfferRef.current = null;
const offerSnapshot = lastDoubleOfferRef.current;
if (clearLastOfferTimerRef.current) clearTimeout(clearLastOfferTimerRef.current);
clearLastOfferTimerRef.current = setTimeout(() => {
  if (lastDoubleOfferRef.current === offerSnapshot) {
    lastDoubleOfferRef.current = null;
  }
}, 2500);

confirmInProgressRef.current = false;   // ← сбросить замок
 setIsMoveConfirmed(false);
 setMoveHistory([]);
 setLastMoveType(null); 
 setShowUndoButton(false);
    // 💠 Обновляем состояние доски
    setBoard(data.board_state || []);
    setWhiteOffBoard(data.white_off_board || []);
    setBlackOffBoard(data.black_off_board || []);
    setCapturedCheckers({ white: 0, black: 0 });

    // 💠 Сбрасываем ход и броски
    setFirstRollComplete(false);
    setFirstMoveComplete(false);
    setUsedRolls([]);
    setRolledDice([]);
    setHasRolledDice(false);
    setCurrentTurn(null);
    setNumberMove(2);
    setIsMoveConfirmed(false);
    setInitialRollPhase(true);

 setMoveHistory([]);        // ← очистить историю хода
 setLastMoveType(null);     // ← забыть, как ходили
 setShowUndoButton(false);  // ← на всякий случай скрыть кнопку



    // 💠 Ставки и куб
    setCubeOwner(null);
    setBetMultiplier(data.bet_multiplier || 1);

    // 💠 Блокировка интерфейса до autoFirstRoll
    setDisableBoardClicks(true);    // ❌ нельзя кликать
    setShowUndoButton(false);       // ❌ скрываем «Отменить»
    setRollEnabled(false);          // ❌ кнопка «Бросить» отключена

    // 💠 Кроуфорд
    setIsCrawford(data.is_crawford || false);



    // если сервер прислал имена — сохраняем их и корректируем мой цвет
if ('player1_name' in data || 'player2_name' in data) {
  setPlayer1Name(prev => data.player1_name ?? prev);
  setPlayer2Name(prev => data.player2_name ?? prev);

  const me = localStorage.getItem('username') || '';
  if (data.player1_name === me) {
    setPlayerColor('white');
    setOpponentColor('black');
  } else if (data.player2_name === me) {
    setPlayerColor('black');
    setOpponentColor('white');
  }
}

// обновим счёт/длину матча, если пришли
if (Array.isArray(data.score)) {
  const [s1, s2] = data.score;
  setScoreP1(Number(s1) || 0);
  setScoreP2(Number(s2) || 0);
}
if ('targetPoints' in data) {
  setTargetPoints(Number(data.targetPoints) || 1);
}


if (autoRollTimerRef.current) { clearTimeout(autoRollTimerRef.current); autoRollTimerRef.current = null; }
if (autoConfirmTimerRef.current) { clearTimeout(autoConfirmTimerRef.current); autoConfirmTimerRef.current = null; }
lastAutoActionAtRef.current = 0;
justConfirmedRef.current = false;




 setMoveHistory([]);        // локальная история ходов
  setLastMoveType(null);     // тип последнего хода (click/drag)
  setUsedRolls([]);          // уже использованные кубики
  setIsMoveConfirmed(false); // флаг «ход подтверждён»
  setShowUndoButton(false);  // сразу прячем кнопку "Отмена"
  // setDisableBoardClicks(false); // на всякий случай разблокируем доску

    // 💠 (необязательное) Очки матча
    if (Array.isArray(data.score)) {
   
      // если есть setScore — вызови
      // setScore(data.score)
    }
  }

  socket.on('short_roundReset', handleShortRoundReset);
  return () => {
    socket.off('short_roundReset', handleShortRoundReset);
  };
}, [tableId, gameFinished]);






async function handleLeaveTable() {
  if (leaving) return;          // защита от повторного клика
  setLeaving(true);

  // Небольшая пауза, чтобы сервер успевал обработать предыдущее действие/движение
  await new Promise(r => setTimeout(r, 700)); // можно 700–1000 мс

  const ok = window.confirm(translate('game.short.leaveConfirm'));
  if (!ok) { setLeaving(false); return; }

  const username = localStorage.getItem('username');

  // очищаем локалстор
  localStorage.removeItem('currentTableId');
  localStorage.removeItem('role');
  localStorage.removeItem('gameType');
  localStorage.removeItem('lobby.typeGame');
  localStorage.removeItem(`stake:short:${tableId}`);

  const payload = { tableId: parseInt(tableId, 10), player: username };
  let acked = false;

  socket.emit('leaveTable', payload, (ack) => {
    acked = true;
    console.log('[leaveTable] сервер ответил:', ack);
    navigate('/');
  });

  // даём серверу чуть больше времени на уборку
  setTimeout(() => {
    if (!acked) {
      console.warn('[leaveTable] ACK не пришёл, делаем fallback navigate');
      navigate('/');
    }
  }, 900); // было 300, стало 900
}



  

function canMakeAnyNormalMove(remainingRolls, board, playerColor) {
  // Проходим по всей доске
  for (let fromIndex = 0; fromIndex < board.length; fromIndex++) {
    const point = board[fromIndex];
    // Если в point лежат наши шашки
    if (point.length > 0 && point[0].color === playerColor) {
      // Для каждого броска check roll
      for (let roll of remainingRolls) {
        // Вычисляем targetIndex
        const targetIndex = (playerColor === 'white')
          ? fromIndex - roll
          : fromIndex + roll;

        // Если вышли за границы
        if (targetIndex < 0 || targetIndex >= board.length) continue;

        // Смотрим, что на целевой точке
        const targetPoint = board[targetIndex];
        // Условия: пусто, или все свои, или ровно 1 чужая (сбитие)
        if (
          !targetPoint || 
          targetPoint.length === 0 ||
          targetPoint.every(ch => ch.color === playerColor) ||
          (targetPoint.length === 1 && targetPoint[0].color !== playerColor)
        ) {
          // нашли хотя бы 1 ход => возвращаем true
          return true;
        }
      }
    }
  }
  // Если перебрали всё и не нашли ни одного варианта => false
  return false;
}



function declareWinner(winnerColor) {
  const loserColor = winnerColor === 'white' ? 'black' : 'white';

  // Проверяем, остались ли шашки проигравшего в доме победителя
  const homeIndices =
    winnerColor === 'white'
      ? [0, 1, 2, 3, 4, 5]
      : [18, 19, 20, 21, 22, 23];

  const hasOpponentInHome = homeIndices.some(index =>
    board[index]?.some(ch => ch.color === loserColor)
  );



  socket.emit('game_over', { 
    tableId: parseInt(tableId, 10),
    winner: winnerColor,
    loser: loserColor,
    hasOpponentInHome  // 👈 ПЕРЕДАЁМ на сервер
  });
}



function checkBarMoveAvailability(
  remainingRolls,
  board,
  capturedCheckers,
  playerColor
)



{
 if (!Array.isArray(remainingRolls) || remainingRolls.length === 0) {

  
    return false;
  }
  // 1) Сколько шашек на баре у текущего игрока?
  const barCount = capturedCheckers[playerColor] || 0;

  // Если на баре нет шашек => нет блока, возвращаем false
  if (barCount === 0) {
    return false; 
  }

  // 2) Вспомогательная функция: можно ли поставить ОДНУ шашку с бара, имея `roll`
  function canEnterWithRoll(roll) {
    const targetIndex = (playerColor === 'white')
      ? (24 - roll)
      : (roll - 1);

    // Выход за границы
    if (targetIndex < 0 || targetIndex >= 24) {
      return false;
    }

    const targetPoint = board[targetIndex] || [];
    // Пусто => можно
    if (targetPoint.length === 0) {
      return true;
    }
    // Все свои => можно
    if (targetPoint.every(ch => ch.color === playerColor)) {
      return true;
    }
    // Ровно 1 чужая => можно сбить
    if (targetPoint.length === 1 && targetPoint[0].color !== playerColor) {
      return true;
    }

    return false;
  }

  // 3) Проверяем, можем ли мы ввести ХОТЯ БЫ ОДНУ шашку
  //    (не пытаемся «скопом» ввести все barCount)
  for (let roll of remainingRolls) {
    if (canEnterWithRoll(roll)) {
      // Как только нашли один roll, который позволяет ввести ОДНУ шашку,
      // значит «не заблокировано», можно ходить
      return false; 
    }
  }

  // Если ни один roll не подошёл => «блок» (true)
  return true;
}



 
  const handleCheckerEntry = () => {
    
  };






function onCheckerClick(checkerIndex, checkerColor) {
  //////////////////////////////////////////////////
  // 1) Проверка условий хода
  //////////////////////////////////////////////////
  const isMyTurn =
    (currentTurn === (playerColor === 'white' ? 'player1' : 'player2'));

  if (!isMyTurn) return;
  if (!isConnected) return;
  // Кубики брошены?  (если !tournamentFirstRollComplete — значит это самый первый ход)
  if (!hasRolledDice && firstRollComplete) {
    return;
  }

  if (numberMove <= 0) {
    return;
  }

  // Смотрим, есть ли шашки на баре нашего цвета
  const barCount = capturedCheckers[playerColor] || 0;
  if (barCount === 0) {
    return; // Нет шашек на баре => нечего «вводить»
  }

  // Помечаем, что ход сделан кликом (для Undo)
  setLastMoveType('click');


  //////////////////////////////////////////////////
  // 2) Собираем «оставшиеся» кубики (remainingRolls)
  //////////////////////////////////////////////////
  let remainingRolls;
  if (!firstRollComplete && !firstMoveComplete) {
    // Самый первый ход (до confirm первого)
    const firstMoveRolls = [
      (playerColor === 'white')
        ? firstRolls.player1Roll
        : firstRolls.player2Roll,
      (playerColor === 'white')
        ? firstRolls.player2Roll
        : firstRolls.player1Roll,
    ];
    remainingRolls = firstMoveRolls.filter(r => !usedRolls.includes(r));
  } else {
    // Обычный ход
    remainingRolls = rolledDice.filter(r => !usedRolls.includes(r));
  }

  // Если дубль, расширяем до 4
  if (rolledDice[0] === rolledDice[1]) {
    const dieVal = rolledDice[0];
    const usedTimes = usedRolls.filter(x => x === dieVal).length;
    const total = 4 - usedTimes;
    for (let i = 0; i < total; i++) {
      remainingRolls.push(dieVal);
    }
  }

  // Сортируем по убыванию (обычно удобнее)
  remainingRolls.sort((a, b) => b - a);


  //////////////////////////////////////////////////
  // 3) Готовим доску / захваченных для реального хода
  //////////////////////////////////////////////////
  // (!) Обратите внимание: если вы используете "simulateOneMove",
  //    можно здесь вызывать. Но ниже — «вручную»:
  const newBoard = deepCopyBoard(board);
  const newCaptured = { ...capturedCheckers };

  // fromIndex = 25 (бар) — универсальный для белых/чёрных
  const fromIndex = 25;
  let foundMove = false;
  let usedRollValue = null;
  let targetIndex = null;
  let capturedChecker = null;

  //////////////////////////////////////////////////
  // 4) Перебираем кубики: ищем «подходящий»
  //////////////////////////////////////////////////
  for (let dieVal of remainingRolls) {
    // Запрещаем «сливать» — если dieVal > 6, пропускаем
    if (dieVal < 1 || dieVal > 6) {
      continue; 
    }

    // Для белых: targetIndex = 24 - dieVal
    // Для чёрных: targetIndex = dieVal - 1
    if (playerColor === 'white') {
      targetIndex = 24 - dieVal;
    } else {
      targetIndex = dieVal - 1;
    }

    // Выход за границы
    if (targetIndex < 0 || targetIndex >= 24) {
      continue;
    }

    // Проверяем, нет ли 2+ чужих
    if (
      newBoard[targetIndex]?.length > 1 &&
      newBoard[targetIndex][0].color !== playerColor
    ) {
      continue;
    }

    // Есть ли у нас вообще шашка на баре?
    if (newCaptured[playerColor] <= 0) {
      // уже нет
      break;
    }

    // === Если дошли сюда => ход valid: снимаем с бара, сбиваем если надо, ставим
    newCaptured[playerColor]--;

    // Сбиваем чужую, если 1 враг
    if (
      newBoard[targetIndex]?.length === 1 &&
      newBoard[targetIndex][0].color !== playerColor
    ) {
      capturedChecker = newBoard[targetIndex].pop();
      const oppColor = capturedChecker.color;
      newCaptured[oppColor] = (newCaptured[oppColor] || 0) + 1;
    } else {
      capturedChecker = null;
    }

    // Кладём нашу
    const myChecker = { color: playerColor };
    newBoard[targetIndex] = newBoard[targetIndex] || [];
    newBoard[targetIndex].push(myChecker);

    foundMove = true;
    usedRollValue = dieVal;
    break; // прекращаем перебор
  }

  // Если не нашли подходящий кубик
  if (!foundMove) {
    // Можно обнулить ход:
    setNumberMove(0);
    return;
  }


  const [d1, d2] = rolledDice;
  const sumRoll = d1 + d2;
  let movesUsed = 1;
  let diceValuesUsed = [usedRollValue];

  // Если вдруг у вас логика "если usedRollValue === sumRoll, значит потратили оба"
  if (usedRollValue === sumRoll) {
    movesUsed = 2;
    diceValuesUsed = [d1, d2];
  }

  // Обновляем usedRolls, numberMove
  setUsedRolls(prev => [...prev, ...diceValuesUsed]);
  setNumberMove(prev => prev - movesUsed);

  // Запись хода в историю
  const currentNM = numberMove;
  setMoveHistory(prev => [
    ...prev,
    {
      board: deepCopyBoard(newBoard),
      from: 25, // «25» мы трактуем как бар
      to: targetIndex,
      checker: { color: playerColor },
      capturedChecker: capturedChecker,   // если сбили
      diceValuesUsed,
      numberMove: currentNM,
      updatedCapturedCheckers: { ...newCaptured },
    },
  ]);

  //////////////////////////////////////////////////
  // 6) Применяем новые стейты
  //////////////////////////////////////////////////
  setBoard(newBoard);
  setCapturedCheckers(newCaptured);

  // Если нужно для отображения последнего кубика
  // setTournamentLastMoveRoll(usedRollValue);
  setLastMoveType('click'); // уже стоит

  console.log('45345345',{
    tableId: parseInt(tableId, 10),
    boardState: newBoard,
    whiteOffBoard: whiteOffBoard,
    blackOffBoard: blackOffBoard,
    updatedCapturedCheckers: newCaptured,
  });
  
  // Оповещаем оппонента
  socket.emit('shortBackgammon_updateBoardState', {
    tableId: parseInt(tableId, 10),
    boardState: newBoard,
    whiteOffBoard: whiteOffBoard,
    blackOffBoard: blackOffBoard,
    updatedCapturedCheckers: newCaptured,
  });
}

//     // Вызов handleCheckerEntry после успешного ввода шашки
    handleCheckerEntry();
  
  
  useEffect(() => {
    // 1) Если кубики не брошены — не проверяем
    if (!hasRolledDice) return;
  
    // 2) Считаем оставшиеся броски
    const remainingRolls = calculateRemainingRolls(rolledDice, usedRolls);
  

  }, [
    board,
    rolledDice,
    usedRolls,
    hasRolledDice,
    capturedCheckers
  ]);
  

  const handleUndoMove = () => {
   
    
    if (lastMoveType === 'click') {
      handleUndoMoveForClick();  // Если ход был сделан кликом
      
    } else if (lastMoveType === 'drag') {
 
      handleUndoMoveForDrag();   // Если ход был сделан перетаскиванием
    }
   
  };

const confirmMove = useCallback(() => {
  if (!tableId) return;
  if (!isConnected) return;
  if (!currentTurn) return;


  // 🔒 косметика: после Confirm не даём на мгновение появляться кнопке «Бросить кубики»
  if (confirmInProgressRef.current) return;
  confirmInProgressRef.current = true;
  setConfirmInProgressUi(true);

  // 1) Кубики текущего хода (для записи)
  const turnDice = Array.isArray(rolledDice) ? [...rolledDice] : [];

  // 2) Ходы текущего хода (может быть ПУСТО — это пасс!)
  const turnMoves = Array.isArray(moveHistory)
    ? moveHistory.map((m) => ({
        from: m.from,                       // 0..23 или 25 (бар)
        to: m.to,                           // 0..23 или 'off'
        diceUsed: m.diceValuesUsed ?? null, // полезно для отладки
      }))
    : [];

  // 3) payload — используем только то, что У ТЕБЯ ЕСТЬ в компоненте
  const payload = {
    tableId: parseInt(tableId, 10),
    player: currentTurn,                   // 'player1' | 'player2'
    boardState: JSON.stringify(board),     // как у тебя уже принято
    capturedCheckers,                      // объект {white, black}
    whiteOffBoard,                         // массив
    blackOffBoard,                         // массив

    // Новое для записи партии:
    turnDice,
    turnMoves,                             // может быть [] — это нормально
  };

  // ✅ локально добавляем свой подтверждаемый ход (себе broadcast не прилетает)
addConfirmedTurnSafe({
  ts: Date.now(),
  player: currentTurn,
  dice: Array.isArray(payload?.turnDice) ? payload.turnDice : [],
  moves: Array.isArray(payload?.turnMoves) ? payload.turnMoves : [],
});
  // ✅ если это был самый первый ход — обязаны локально закрыть first-move фазу,
  // иначе "кубики первого хода" будут висеть до прихода server confirmed,
  // а его мы себе не получаем
  setFirstRolls({});            // 🔥 это уберёт “кубики” первого хода из UI
  setFirstMoveComplete(true);   // 🔥 закрываем фазу первого хода
  setFirstRollComplete(true);   // на всякий случай фиксируем, что первый бросок уже был
  setInitialRollPhase(false);   // если у тебя UI завязан на этот флаг


  // 4) Локальная очистка текущего хода
  setMoveHistory([]);
  setUsedRolls([]);
  setRolledDice([]);
  setNumberMove(2);            // можно оставить, сервер потом пришлёт точное
  setShowUndoButton(false);
  setHasRolledDice(false);

  // 5) отправка
  socket.emit("shortBackgammonBoard_confirmMove", payload, (response) => {
    if (response?.status === "ok") {
      console.log("confirmMove ok");
    } else {
      console.error("confirmMove error:", response);
      // если сервер вернул ошибку — снимем замок, чтобы UI не завис
      confirmInProgressRef.current = false;
      setConfirmInProgressUi(false);

    }
  });
}, [
  tableId,
  isConnected,
  currentTurn,
  board,
  capturedCheckers,
  whiteOffBoard,
  blackOffBoard,
  rolledDice,
  moveHistory,
  setMoveHistory,
  setUsedRolls,
  setRolledDice,
  setNumberMove,
  setShowUndoButton,
  setHasRolledDice,
]);


//   const confirmMove = useCallback(() => {

// if (!isConnected) return;

//     if (numberMove > 0 && moveHistory.length === 0) {
//     console.warn('[confirmMove] нет локальных ходов, подтверждать нечего');
//     return;
//   }
//     // антидубль: если только что подтверждали — выходим
//   if (justConfirmedRef.current) return;

//   // троттлинг: не давать два «confirm» подряд мгновенно
//   const now = Date.now();
//   if (now - lastAutoActionAtRef.current < AUTO_DELAY_MS) return;
//   lastAutoActionAtRef.current = now;


//   // не даём «двойной клик»
//   if (confirmInProgressRef.current) {
//     console.warn('Ход уже подтверждается — пропуск');
//     return;
//   }

//   // ВАЛИДАЦИЯ — до установки замка
//   if (!tableId) {
//     console.error('tableId не определён');
//     return;
//   }
//   if (!currentTurn) {
//     console.error('currentTurn не определён');
//     return;
//   }
//   if (!board) {
//     console.error('board пустой/undefined');
//     return;
//   }

//   // если хочешь — запрет подтверждения, пока остались ходы по кубам
//   // if (numberMove > 0) return;

//   // всё ок — ставим замок
//   confirmInProgressRef.current = true;

//   // блокируем UI на время подтверждения
//   setDisableBoardClicks(true);
//   setRollEnabled(false);

//   // локально переключаем ход и сбрасываем броски (оптимистично)
//   const nextTurn = currentTurn === 'player1' ? 'player2' : 'player1';
//   setCurrentTurn(nextTurn);
//   setFirstRollComplete(true);
//   setFirstMoveComplete(true);
//   setUsedRolls([]);
//   setRolledDice([]);
//   setFirstRolls({});
//   setHasRolledDice(false);
//   setIsMoveConfirmed(true);

//   // полезно иметь один «разблокиратор»
//   const unlock = () => {
//     confirmInProgressRef.current = false;
//     setDisableBoardClicks(false);
//     // setRollEnabled(true); // ← включай, если по UX надо
//   };

//   // таймаут на случай потери пакета/события
//   const timeoutId = setTimeout(() => {
//     console.warn('confirmMove: нет ответа от сервера — разблокирую UI');
//     unlock();
//   }, 5000);

//   // ВАЖНО: отправляем board как СТРОКУ (совместимо с твоим сервером),
//   // но сервер мы патчим, чтобы не удваивать stringify.
//   const payload = {
//     tableId,
//     player: currentTurn,
//     boardState: JSON.stringify(board),
//     capturedCheckers,
//     whiteOffBoard,
//     blackOffBoard,
//     firstRollComplete: true,
//     firstMoveComplete: true,
//   };

//   setTimeout(() => {
//   // таймаут на случай тишины уже ПОСЛЕ отправки
//   const ackTimeout = setTimeout(() => {
//     console.warn('confirmMove: нет ответа от сервера — разблокирую UI');
//     unlock();
//   }, 700);

//   // отправляем confirm после задержки
//   socket.emit('shortBackgammonBoard_confirmMove', payload, (ack) => {
//     clearTimeout(ackTimeout);
//     if (!ack || ack.ok !== true) {
//       console.warn('confirmMove: ACK отвергнут/не пришёл', ack);
//       unlock();
//     }
//     // если ok — ждём обычное серверное событие confirmed
//   });
// }, 700);
// }, [
//   tableId,
//   currentTurn,
//   board,
//   capturedCheckers,
//   whiteOffBoard,
//   blackOffBoard,
//   setDisableBoardClicks,
//   setRollEnabled,
//   setCurrentTurn,
//   setFirstRollComplete,
//   setFirstMoveComplete,
//   setUsedRolls,
//   setRolledDice,
//   setFirstRolls,
//   setHasRolledDice,
//   setIsMoveConfirmed,
//   numberMove,      // ← добавили
//   moveHistory,     // ← добавили
// ]);

  useEffect(() => {
    // Если сейчас мой ход, и я бросил кубики, и numberMove > 0, 
    // проверим, есть ли у меня шашки на баре и могу ли я их ввести.
    const isMyTurn =
      (currentTurn === 'player1' && playerColor === 'white')
      || (currentTurn === 'player2' && playerColor === 'black');

    if (isMyTurn && hasRolledDice && numberMove > 0) {
      // Попробуем вызвать проверку
      // const noMoves = tournamentCheckBarMoveAvailability(
      //   tournamentRolledDice,       // remainingRolls - можно упростить
      //   tournamentBoard,
      //   tournamentCapturedCheckers
      // );
      // Если noMoves === true, значит показали кнопку или автоконфирм
    }
  }, [
    board,
    rolledDice,
    numberMove,
    capturedCheckers,
    hasRolledDice,
    playerColor,
    currentTurn,
    confirmMove,
  ]);

  


  

function handleUndoMoveForDrag() {
  if (!moveHistory.length) {
   
    return;
  }

  // Берём последний ход
  const lastMove = moveHistory[moveHistory.length - 1];
  const {
    from,
    to,
    checker,
    capturedChecker,
    diceValuesUsed,
    board: boardAfter,      // снимок доски после хода
    updatedCapturedCheckers,
    numberMove
  } = lastMove;

  // Делаем копии текущих стейтов
  const newBoard = deepCopyBoard(boardAfter);
  const newCaptured = { ...capturedCheckers };
  let newWhiteOff = [...whiteOffBoard];
  let newBlackOff = [...blackOffBoard];

  // === (A) Случай Bear Off (to === 'off') ===
  if (to === 'off') {
    // Убираем шашку из offBoard
    let removedChecker = null;
    if (checker.color === 'white') {
      if (newWhiteOff.length > 0) {
        removedChecker = newWhiteOff.pop();
      }
    } else {
      if (newBlackOff.length > 0) {
        removedChecker = newBlackOff.pop();
      }
    }

    // Возвращаем снятую шашку на from
    if (removedChecker) {
      if (from === 25) {
        // С бара «на офф» (редкий случай): вернём обратно на бар
        newCaptured[removedChecker.color] =
          (newCaptured[removedChecker.color] || 0) + 1;
      } else {
        // Обычный индекс на доске
        if (!newBoard[from]) {
          newBoard[from] = [];
        }
        newBoard[from].push(removedChecker);
      }
    }

    // Применяем
    setWhiteOffBoard(newWhiteOff);
    setBlackOffBoard(newBlackOff);
    setBoard(newBoard);
    setCapturedCheckers(newCaptured);

    // Удаляем из истории
    setMoveHistory(prev => prev.slice(0, -1));
    setNumberMove(numberMove);

    // Откатываем usedRolls
    setUsedRolls(prev => {
      const arr = [...prev];
      if (diceValuesUsed) {
        diceValuesUsed.forEach(dVal => {
          const idx = arr.lastIndexOf(dVal);
          if (idx !== -1) arr.splice(idx, 1);
        });
      }
      return arr;
    });

    // Сообщаем оппоненту
    socket.emit('shortBackgammon_undoMove', {
      tableId: parseInt(tableId, 10),
      newBoardState: newBoard,
      capturedCheckers: newCaptured,
      whiteOffBoard: newWhiteOff,
      blackOffBoard: newBlackOff,
      numberMove
    });

    return;
  }

  // === (B) Обычный ход (to — число) ===
  {
    // Снимаем нашу шашку с точки to
    let movedChecker = null;
    if (typeof to === 'number' && newBoard[to]?.length > 0) {
      movedChecker = newBoard[to].pop();
    } else {
    
      return;
    }

    // Если ход был с бара
    if (from === 25) {
      newCaptured[movedChecker.color] =
        (newCaptured[movedChecker.color] || 0) + 1;
    } else {
      // Иначе возвращаем на исходную точку
      if (!newBoard[from]) {
        newBoard[from] = [];
      }
      newBoard[from].push(movedChecker);
    }

    // Если была сбита чужая
    if (capturedChecker) {
      const oppColor = capturedChecker.color;
      newCaptured[oppColor] = Math.max(
        (newCaptured[oppColor] || 0) - 1,
        0
      );
      if (!newBoard[to]) {
        newBoard[to] = [];
      }
      newBoard[to].push(capturedChecker);
    }

    // Применяем
    setBoard(newBoard);
    setCapturedCheckers(newCaptured);
    setWhiteOffBoard(newWhiteOff);
    setBlackOffBoard(newBlackOff);

    setMoveHistory(prev => prev.slice(0, -1));
    setNumberMove(numberMove);

    // Откатываем usedRolls
    setUsedRolls(prev => {
      const arr = [...prev];
      if (diceValuesUsed) {
        diceValuesUsed.forEach(val => {
          const idx = arr.lastIndexOf(val);
          if (idx !== -1) arr.splice(idx, 1);
        });
      }
      return arr;
    });

    // Сообщаем оппоненту
    socket.emit('tournamentMatch_undoMove', {
      tableId: parseInt(tableId, 10),
      newBoardState: newBoard,
      capturedCheckers: newCaptured,
      whiteOffBoard: newWhiteOff,
      blackOffBoard: newBlackOff,
      numberMove,
      player: (playerColor === 'white') ? 'player1' : 'player2'
    });
  }
}



function handleUndoMoveForClick() {
  




  if (moveHistory.length === 0) {
  
    return;
  }

  // 1) Берём последний ход из истории
  const lastMove = moveHistory[moveHistory.length - 1];


  const {
    from,
    to,
    checker,           // шашка, которую перемещали
    capturedChecker,   // если была сбита чужая
    diceValuesUsed,
    board: boardAfter, // снимок доски ПОСЛЕ хода
    numberMove,
  } = lastMove;

  // 2) Копируем состояние, чтобы откатить изменения
  //    "boardAfter" — это доска ПОСЛЕ сделанного хода
  const newBoard = deepCopyBoard(boardAfter);

  // Делаем копию "captured", чтобы править локально
  // Если нужно подстраховаться, что поля точно есть:
  const newCaptured = {
    white: capturedCheckers?.white || 0,
    black: capturedCheckers?.black || 0,
  };

  // Копии off-boards
  let newWhiteOff = [...whiteOffBoard];
  let newBlackOff = [...blackOffBoard];

  // === (A) Если ход был Bear Off (to==='off') ===
  if (to === 'off') {
    let removedChecker = null;

    // A.1) Убираем шашку из whiteOffBoard / blackOffBoard
    if (checker.color === 'white') {
      if (newWhiteOff.length > 0) {
        removedChecker = newWhiteOff.pop();
      }
    } else {
      if (newBlackOff.length > 0) {
        removedChecker = newBlackOff.pop();
      }
    }

    // A.2) Если мы действительно сняли шашку, возвращаем её:
    //      - Если from===25 → на бар
    //      - Иначе на точку from
    if (removedChecker) {
      if (from === 25) {
        // "С бара на off" откатываем: значит возвращаем её снова на бар
        newCaptured[removedChecker.color] =
          (newCaptured[removedChecker.color] || 0) + 1;
      } else {
        // Обычная позиция 0..23
        if (!newBoard[from]) {
          newBoard[from] = [];
        }
        newBoard[from].push(removedChecker);
      }
    }

    // A.3) Теперь одним блоком записываем стейты
    setWhiteOffBoard(newWhiteOff);
    setBlackOffBoard(newBlackOff);
    setBoard(newBoard);
    setCapturedCheckers(newCaptured);

    // Убираем ход из истории
    setMoveHistory(prev => prev.slice(0, -1));
    setNumberMove(numberMove);

    // Откатываем usedRolls
    setUsedRolls(prev => {
      const arr = [...prev];
      if (diceValuesUsed) {
        diceValuesUsed.forEach(dVal => {
          const idx = arr.lastIndexOf(dVal);
          if (idx !== -1) arr.splice(idx, 1);
        });
      }
      return arr;
    });

    // Отправляем событие оппоненту
    socket.emit('shortBackgammon_undoMove', {
      tableId: parseInt(tableId, 10),
      newBoardState: newBoard,
      capturedCheckers: newCaptured,
      whiteOffBoard: newWhiteOff,
      blackOffBoard: newBlackOff,
      numberMove,
      player: (playerColor === 'white') ? 'player1' : 'player2',
    });

    return;
  }

  // === (B) Обычный ход (или с бара), если to — число 0..23 ===
  {
    // B.1) Убираем нашу шашку с точки `to`
    if (!newBoard[to] || newBoard[to].length === 0) {
    
      return;
    }
    const movedChecker = newBoard[to].pop();

    // B.2) Если ход был с бара (from===25), возвращаем снятую шашку обратно на бар
    if (from === 25) {
      newCaptured[movedChecker.color] =
        (newCaptured[movedChecker.color] || 0) + 1;
    } else {
      // Иначе возвращаем на исходную точку "from"
      if (!newBoard[from]) {
        newBoard[from] = [];
      }
      newBoard[from].push(movedChecker);
    }

    // B.3) Если была сбита чужая шашка
    if (capturedChecker) {
      const oppColor = capturedChecker.color;
      // Уменьшаем кол-во "захваченных" у оппонента
      newCaptured[oppColor] = Math.max(
        (newCaptured[oppColor] || 0) - 1,
        0
      );

      // Возвращаем эту шашку на точку `to`
      if (!newBoard[to]) {
        newBoard[to] = [];
      }
      newBoard[to].push(capturedChecker);
    }

    // B.4) Применяем итоговое состояние одним блоком
    setWhiteOffBoard(newWhiteOff);
    const localPlayer = (playerColor === 'white') ? 'player1' : 'player2';

    setBlackOffBoard(newBlackOff);
    setBoard(newBoard);
    setCapturedCheckers(newCaptured);

    setMoveHistory(prev => prev.slice(0, -1));
    setNumberMove(numberMove);

    // Откатываем usedRolls
    setUsedRolls(prev => {
      const arr = [...prev];
      if (diceValuesUsed) {
        diceValuesUsed.forEach(val => {
          const idx = arr.lastIndexOf(val);
          if (idx !== -1) arr.splice(idx, 1);
        });
      }
      return arr;
    });

  

    // Оповещаем оппонента
    socket.emit('shortBackgammon_undoMove', {
      tableId: parseInt(tableId, 10),
      newBoardState: newBoard,
      capturedCheckers: newCaptured,
      whiteOffBoard: newWhiteOff,
      blackOffBoard: newBlackOff,
      numberMove,
      player: (playerColor === 'white') ? 'player1' : 'player2',
    });
  }
}

useEffect(() => {
  function handleMoveUndone(data) {
  
    const {
      tableId,
      newBoardState,
      capturedCheckers,
      numberMove,
      whiteOffBoard,
      blackOffBoard,

      // ВАЖНО: нужно, чтобы при undoMove
      // мы тоже получали поле 'player' (кто инициировал)
      // Иначе не сможем отличить "наш" undo от "чужого".
      player,
    } = data;

    // 1) Проверяем, что событие именно для нашего стола
    // if (String(tableId) !== String(tableId)) {
    //   return;
    // }
if (String(data.tableId) !== String(tableId)) return;

    // 2) Игнорируем, если это наше собственное undo
    //    (поскольку мы уже локально отменили).
    //    Для этого нам нужно знать, кто "player1"/"player2" 
    //    и совпадает ли с localPlayer.
    const localPlayer = (playerColor === 'white') ? 'player1' : 'player2';
    if (player === localPlayer) {
      
      return;
    }

    // 3) Если это undo оппонента — применяем
    if (data.player === localPlayer) {
      
      return;
    }

    setBoard(newBoardState);
    setCapturedCheckers(capturedCheckers);
    setNumberMove(numberMove);
    // setWhiteOffBoard(whiteOffBoard || []);
    // setBlackOffBoard(blackOffBoard || []);
 if (Array.isArray(whiteOffBoard)) setWhiteOffBoard(whiteOffBoard);
 if (Array.isArray(blackOffBoard)) setBlackOffBoard(blackOffBoard);

   
  }

  socket.on('shortBackgammon_moveUndone', handleMoveUndone);

  return () => {
    socket.off('shortBackgammon_moveUndone', handleMoveUndone);
  };
}, [
  tableId,
  playerColor,          // нужно, чтобы внутри сравнивать localPlayer
  setBoard,
  setCapturedCheckers,
  setNumberMove,
  setWhiteOffBoard,
  setBlackOffBoard,
]);


 useEffect(() => {
  const isMyTurn = currentTurn === (playerColor === 'white' ? 'player1' : 'player2');

  // Скрываем кнопку, если не ваш ход или нет ходов для отмены
  if (!isMyTurn ||  moveHistory.length === 0   || !hasRolledDice) {
   
    
    setShowUndoButton(false);
  } else {
    
    // Показываем кнопку, если есть ходы для отмены
    setShowUndoButton(true);
  }

  
   }, [currentTurn, moveHistory.length, playerColor,hasRolledDice]);



// Проверяет, можем ли мы "выбросить" (bear off) шашку с given fromIndex и значением roll
function canBearOffChecker(fromIndex, dieValue, board, playerColor) { 
  if (!allCheckersInHome(board, playerColor)) {
    return false;
  }
  if (playerColor === "white") {
    // целевой "индекс выхода" = -1, грубо говоря
    // 1) если (fromIndex+1 === dieValue) => можно
    if (fromIndex + 1 === dieValue) {
      return true;
    }
    // 2) если (dieValue > fromIndex+1) => можно, если fromIndex это самая дальняя (максимальная) занятая точка в доме
    if (dieValue > fromIndex + 1) {
      // ищем самую дальнюю (максимальный индекс) занятый в 0..5
      let maxOccupied = -1;
      for (let i = 0; i < 6; i++) {
        if (board[i]?.length && board[i][0].color === "white") {
          maxOccupied = Math.max(maxOccupied, i);
        }
      }
      // Если fromIndex = maxOccupied => ок
      return (fromIndex === maxOccupied);
    }
    return false;
  } else {
    // black
    // для чёрных "индекс выхода" = 24
    // 1) если (24 - fromIndex === dieValue) => можно
    if ((24 - fromIndex) === dieValue) {
      return true;
    }
    // 2) если (dieValue > 24 - fromIndex) => можно, если fromIndex это самая ближняя к выходу (минимальная) занятая точка в 18..23
    if (dieValue > (24 - fromIndex)) {
      let minOccupied = 999;
      for (let i = 23; i >= 18; i--) {
        if (board[i]?.length && board[i][0].color === "black") {
          minOccupied = Math.min(minOccupied, i);
        }
      }
      return (fromIndex === minOccupied);
    }
    return false;
  }
}

function allCheckersInHome(board, playerColor) {
  if (playerColor === "white") {
    for (let i = 6; i < 24; i++) {
      if (board[i]?.length && board[i][0].color === "white") {
       
        return false;
      }
    }
   
    return true;
  } else {
    // black
    for (let i = 0; i < 18; i++) {
      if (board[i]?.length && board[i][0].color === "black") {
       
        return false;
      }
    }
   
    return true;
  }
}


/**
 * Возвращает `true`, если при данных `board`, `diceValues` и `playerColor`
 * можно вывести хотя бы одну шашку (bear off).
 */
function canBearOffAny(board, diceArray, playerColor) {
 
  
  // 1) Проверяем, что ВСЕ шашки playerColor в доме.
  if (!allCheckersInHome(board, playerColor)) {
    return false; // если не все шашки в доме — нет bear off
  }

  // 2) Ищем хотя бы одну шашку, которую реально можно вынести
  //    на каком-нибудь из кубиков (из diceArray).
  for (let fromIndex = 0; fromIndex < 24; fromIndex++) {
    if (!board[fromIndex].length) continue;
    if (board[fromIndex][0].color !== playerColor) continue;

    // Для каждой шашки посмотрим, можно ли её вынести
    for (let die of diceArray) {
      if (canBearOffChecker(fromIndex, die, board, playerColor)) {
        return true;
      }
    }
  }

  // Если ничего не подошло
  return false;
} 




// Функция для вычисления реального количества доступных ходов для обычного перемещения
// Функция для вычисления реального количества доступных ходов для обычного перемещения
function calculateRealMoves(board, playerColor, remainingDice) {
  let legalMovesCount = 0;
  // Для белых предполагаем, что перемещения идут от большего индекса к меньшему
  // Для чёрных – наоборот.
  for (let from = 0; from < board.length; from++) {
    if (board[from].length > 0 && board[from][0].color === playerColor) {
      for (let die of remainingDice) {
        let target;
        if (playerColor === 'white') {
          target = from - die;
        } else {
          target = from + die;
        }
        if (target < 0 || target >= board.length) continue;
        const targetPoint = board[target];
        if (!targetPoint || targetPoint.length === 0) {
          legalMovesCount++;
        } else if (targetPoint.every(ch => ch.color === playerColor)) {
          legalMovesCount++;
        } else if (targetPoint.length === 1 && targetPoint[0].color !== playerColor) {
          legalMovesCount++;
        }
      }
    }
  }
  return legalMovesCount;
}




useEffect(() => {
  if (!hasRolledDice) return;
  
  const remainingDice = calculateRemainingRolls();
  const legalMoves = calculateRealMoves(board, playerColor, remainingDice);
  

  
  // Если число реально доступных ходов меньше, чем текущий tournamentNumberMove, обновляем его.
  if (legalMoves < numberMove) {
    // setTournamentNumberMove(legalMoves);
   
    // Если ходов нет (legalMoves === 0), вместо автоматического завершения просто отображаем кнопку.
    // Например, если у вас кнопка рендерится при tournamentNumberMove === 0,
    // то она появится автоматически.
  }
}, [hasRolledDice, board, usedRolls, playerColor]);



// Для конкретного чекера, расположенного на fromIndex, вычисляем, сколько вариантов из массива dice возможны
function calculateMovesForChecker(board, fromIndex, playerColor, dice) {
  let count = 0;
  for (let d of dice) {
    let target;
    if (playerColor === 'white') {
      target = fromIndex - d;
    } else {
      target = fromIndex + d;
    }
    // Если target выходит за пределы доски – ход невозможен
    if (target < 0 || target >= board.length) continue;
    const targetPoint = board[target];
    // Если пункт пуст или заполнен своими шашками
    if (!targetPoint || targetPoint.length === 0 || targetPoint.every(ch => ch.color === playerColor)) {
      count++;
    }
    // Или если в пункте ровно одна шашка противника (можно сбить)
    else if (targetPoint.length === 1 && targetPoint[0].color !== playerColor) {
      count++;
    }
  }
  return count;
}



useEffect(() => {
  // Если кубики ещё не брошены или мы уже начали ход (есть хотя бы один ход в истории),
  // не пересчитываем число ходов.
  if (!hasRolledDice || !initialRollPhase || moveHistory.length > 0) return;
  
  // Берём оставшиеся броски – если дубль, то расширяем до 4 копий
  let dice = rolledDice;
  if (dice[0] === dice[1]) {
    dice = Array(4).fill(dice[0]);
  }
  
}, [hasRolledDice, rolledDice, board, playerColor, initialRollPhase, moveHistory]);






// function handleBearOff(
//   fromIndex,
//   rollValue,
//   board,
//   playerColor,
//   whiteOffBoard,
//   blackOffBoard,
//   setWhiteOffBoard,
//   setBlackOffBoard
// ) {
//   // Копируем доску
//   const newBoard = deepCopyBoard(board);

//   // Забираем шашку
//   const checker = newBoard[fromIndex].pop();

//   // Кладём её в whiteOffBoard / blackOffBoard
//   if (playerColor === 'white') {
//     const updatedWhiteOff = [...whiteOffBoard, checker];
//     setWhiteOffBoard(updatedWhiteOff);
//   } else {
//     const updatedBlackOff = [...blackOffBoard, checker];
//     setBlackOffBoard(updatedBlackOff);
//   }

//   return { newBoard, checker }; // возвращаем и доску, и вынутую шашку
// } 



function handleBearOff(
  fromIndex,
  rollValue,
  board,
  playerColor,
  whiteOffBoard,
  blackOffBoard
) {
  // Копируем доску
  const newBoard = deepCopyBoard(board);

  // Забираем шашку
  const checker = newBoard[fromIndex].pop();

  // Считаем НОВЫЕ значения off-бордов
  let nextWhiteOffBoard = whiteOffBoard;
  let nextBlackOffBoard = blackOffBoard;

  if (playerColor === 'white') {
    nextWhiteOffBoard = [...whiteOffBoard, checker];
  } else {
    nextBlackOffBoard = [...blackOffBoard, checker];
  }

  // Вернём всё, что нужно вызывающему коду
  return {
    newBoard,
    checker,
    nextWhiteOffBoard,
    nextBlackOffBoard
  };
}







useEffect(() => {
  function backgammonFetchData() {
    if (socket.connected) {
      socket.emit("backgammonFetchData", tableId);
    } else {
      const handleConnect = () => {
        socket.emit("backgammonFetchData", tableId);
      };
     socket.on("connect", handleConnect);
      return () => {
        socket.off("connect", handleConnect);
      };
    }
  }

  





// Первый ход коректно обрабатывае
function handleDataResponse(data) {
  console.log("[CLIENT] backgammontDataResponse moveGame:", {data,
  hasMoveGame: Array.isArray(data?.moveGame),
  len: Array.isArray(data?.moveGame) ? data.moveGame.length : null,
  first: Array.isArray(data?.moveGame) ? data.moveGame[0] : null,
  last: Array.isArray(data?.moveGame) ? data.moveGame[data.moveGame.length - 1] : null,
});

  //------------------------------------------------------------------
  // 0) Если вообще нет данных – выходим
  //------------------------------------------------------------------
  if (!data) {
    return;
  }

  //------------------------------------------------------------------
  // 1) Проверяем, тот ли это tableId
  //------------------------------------------------------------------
  if (String(data.table_id) !== String(tableId)) {
    console.warn("[backgammon] Данные не для нашего стола:", data.table_id);
    return;
  }

  // Запрос состояния мог начаться до autobроска, а ответ прийти после него.
  // Такой ответ больше не актуален и не должен блокировать первый ход.
  const liveOpening = shortLiveOpeningRef.current;
  if (
    liveOpening?.tableId === String(tableId) &&
    (data.firstRollComplete === false || !data.current_turn)
  ) {
    console.warn('[SHORT FIRST ROLL] ignored stale backgammontDataResponse', {
      tableId, currentTurn: data.current_turn,
      firstRollComplete: data.firstRollComplete,
    });
    return;
  }
  if (data.firstMoveComplete === true) shortLiveOpeningRef.current = null;

  const mg = normalizeMoveGame(data);
setConfirmedTurns(mg);

  //------------------------------------------------------------------
  // 2) Полный сброс локального хода (делаем ОДИН раз, уже зная, что стол наш)
  //------------------------------------------------------------------
  confirmInProgressRef.current = false;
  justConfirmedRef.current = false;

  setMoveHistory([]);          // забываем локальные микро-ходы
  setLastMoveType(null);       // тип последнего хода
  setUsedRolls([]);            // локально использованные кубики
  setIsMoveConfirmed(false);   // флаг подтверждения
  setShowUndoButton(false);    // скрываем "Отмена"
  setDisableBoardClicks(false);// разблокируем доску

  //------------------------------------------------------------------
  // 3) Лимиты, счёт, цель поинтов
  //------------------------------------------------------------------
  setTableMaxBet(
    data.max_bet ?? data.Table?.max_bet ?? null
  );

  setScoreP1(Number(data.score_player1 ?? 0));
  setScoreP2(Number(data.score_player2 ?? 0));
  setTargetPoints(Number(data.target_points ?? 1));

  setLoading(false);

  //------------------------------------------------------------------
  // 4) Обновляем доску, если она отличается
  //------------------------------------------------------------------
  const serverBoard = data.board_state || [];
  const isBoardSame = JSON.stringify(serverBoard) === JSON.stringify(board);
  if (!isBoardSame) {
    setBoard(serverBoard);
  }

  //------------------------------------------------------------------
  // 5) Обновляем captured / offBoard
  //------------------------------------------------------------------
  const captured = data.captured_checkers || { white: 0, black: 0 };
  setCapturedCheckers(captured);

  const whiteOff = data.white_off_board || [];
  const blackOff = data.black_off_board || [];
  setWhiteOffBoard([...whiteOff]);
  setBlackOffBoard([...blackOff]);

  //------------------------------------------------------------------
  // 6) Имя игроков, аватары, рейтинг, текущий ход, куб удвоения
  //------------------------------------------------------------------
  setPlayer1Name(data.player1_name || null);
  setPlayer2Name(data.player2_name || null);

  setPlayer1Avatar(data.player1_avatar || null);
  setPlayer2Avatar(data.player2_avatar || null);

  if (Number.isFinite(Number(data.player1_rating))) {
    setPlayer1Rating(Number(data.player1_rating));
  }

  if (Number.isFinite(Number(data.player2_rating))) {
    setPlayer2Rating(Number(data.player2_rating));
  }

  setCurrentTurn(data.current_turn || null);

  setBetMultiplier(Number(data.bet_multiplier) || 1); // ×1/×2/×4/…
  setCubeOwner(data.cube_owner || null);              // владелец куба или null

  //------------------------------------------------------------------
  // 7) Определяем свой цвет (white/black)
  //------------------------------------------------------------------
  const username = localStorage.getItem("username") || "";
  let myColor = null;

  if (data.player1_name === username) {
    myColor = "white";
  } else if (data.player2_name === username) {
    myColor = "black";
  }

  if (myColor) {
    setPlayerColor(myColor);
    setOpponentColor(myColor === "white" ? "black" : "white");
  }

  //------------------------------------------------------------------
  // 8) Флаги первого хода
  //------------------------------------------------------------------
  setFirstRollComplete(!!data.firstRollComplete);
  setFirstMoveComplete(!!data.firstMoveComplete);

  //------------------------------------------------------------------
  // 9) Узнаём, бросал ли я уже (hasRolledDice) по данным сервера
  //------------------------------------------------------------------
  const iAmWhite = (myColor === "white");
  const hasRolledAlready = iAmWhite
    ? data.hasRolledDicePlayer1
    : data.hasRolledDicePlayer2;

  setHasRolledDice(hasRolledAlready);
console.log('retetertert',hasRolledDice);

  //------------------------------------------------------------------
  // 10) Разбираем массивы бросков player1_rolls / player2_rolls
  //------------------------------------------------------------------
  let player1Rolls = [];
  let player2Rolls = [];

  function parseRolls(rollsField) {
    if (!rollsField) return [];
    if (Array.isArray(rollsField)) return rollsField;
    if (typeof rollsField === "string" && rollsField.trim() !== "") {
      try {
        return JSON.parse(rollsField);
      } catch (e) {
        console.error("Ошибка парсинга rollsField:", e);
        return [];
      }
    }
    return [];
  }

  player1Rolls = parseRolls(data.player1_rolls);
  player2Rolls = parseRolls(data.player2_rolls);

  //------------------------------------------------------------------
  // 11) Первый ход (firstMoveComplete === false)
  //     Сравниваем первые броски player1Rolls[0], player2Rolls[0]
  //------------------------------------------------------------------
  if (!data.firstMoveComplete) {
    const p1First = (player1Rolls.length > 0) ? player1Rolls[0] : null;
    const p2First = (player2Rolls.length > 0) ? player2Rolls[0] : null;

    // сохраняем, чтобы нарисовать на экране
    setFirstRolls({
      player1Roll: p1First,
      player2Roll: p2First,
    });

    if (p1First != null && p2First != null && p1First !== p2First) {
      // есть валидные разные броски — определяем, кто ходит
      let firstMoveDice = [];

      if (p1First > p2First) {
        // победил белый
        if (myColor === "white") {
          firstMoveDice = [p1First, p2First];
        } // если я чёрный, кубики не показываем
      } else if (p2First > p1First) {
        // победил чёрный
        if (myColor === "black") {
          firstMoveDice = [p2First, p1First];
        }
      }

      setRolledDice(firstMoveDice);
      setHasRolledDice(firstMoveDice.length > 0); // если у меня есть кубики — значит я "уже бросал"
      setRollEnabled(false);                      // кнопку броска на первом ходу не даём

    } else {
      // ИХ БРОСКИ РАВНЫ ИЛИ КАКАЯ-ТО ЧАСТЬ ОТСУТСТВУЕТ
      // Тут как раз твой комментарий:
      // "нужно перекинуть заново" — сервер должен это решать,
      // локально мы НИЧЕГО не трогаем (НЕ обнуляем кости).
    }

    // numberMove берём с сервера
    const nm = iAmWhite
      ? (data.numberMovePlayer1 || 0)
      : (data.numberMovePlayer2 || 0);
    setNumberMove(nm);

  } else {
    //----------------------------------------------------------------
    // 12) Первый ход уже завершён – обычная логика бросков
    //----------------------------------------------------------------
    const lastRollP1 = player1Rolls.length > 0
      ? player1Rolls[player1Rolls.length - 1]
      : [];
    const lastRollP2 = player2Rolls.length > 0
      ? player2Rolls[player2Rolls.length - 1]
      : [];

    const itsMyTurn = (
      (myColor === "white" && data.current_turn === "player1") ||
      (myColor === "black" && data.current_turn === "player2")
    );

    if (itsMyTurn) {
      if (hasRolledAlready) {
        const myLastRoll = (myColor === "white") ? lastRollP1 : lastRollP2;
        setRolledDice(Array.isArray(myLastRoll) ? myLastRoll : []);
        setHasRolledDice(true);
      } else {
        setRolledDice([]);
        setHasRolledDice(false);
      }
    } else {
      const oppHasRolled = iAmWhite
        ? data.hasRolledDicePlayer2
        : data.hasRolledDicePlayer1;

      if (oppHasRolled) {
        const oppLastRoll = iAmWhite ? lastRollP2 : lastRollP1;
        setRolledDice(Array.isArray(oppLastRoll) ? oppLastRoll : []);
      } else {
        setRolledDice([]);
      }
      setHasRolledDice(false);
    }

    const movesLeftServer = iAmWhite
      ? (data.numberMovePlayer1 || 0)
      : (data.numberMovePlayer2 || 0);
    setNumberMove(movesLeftServer);

    const canRoll = (itsMyTurn && !hasRolledAlready);
    setRollEnabled(canRoll);
  }

  //------------------------------------------------------------------
  // 13) Здесь при желании можно вызвать updateGame(data)
  //------------------------------------------------------------------
  // updateGame(data);
}




  
  // Вызовем fetchTournamentData при монтировании
   backgammonFetchData();
  socket.on("backgammontDataResponse", handleDataResponse);

  return () => {
    socket.off("backgammontDataResponse", handleDataResponse);
  };
}, [tableId]); 

function computeRealNumberOfMoves(board, captured, offBoard, playerColor, d1, d2) {
 
  // 1) Если дубль => считаем до 4
  if (d1 === d2) {
    const movesUsed = computeFourMovesWithBarAndBearOff(
      board, captured, offBoard, playerColor, d1
    );
   
    return movesUsed;
  }
  // 2) Иначе (d1 != d2) — пробуем 2 хода
  //    (а) checkTwoMovesPossible с (d1,d2)
  const can2 = checkTwoMovesPossible(board, captured, offBoard, playerColor, d1, d2);
 
  if (can2) {
 
  return 2;
  }
  // (b) Если 2 не получается, проверяем, есть ли 1
  const can1 = checkSingleMovePossible(board, captured, offBoard, playerColor, d1, d2);
 
  if (can1){

  return 1;
  }
  // (c) Иначе 0
 
  return 0;
}

function computeFourMovesWithBarAndBearOff(board, captured, offBoard, playerColor, dieValue) {

  
  // Делать 4 раза «simulateOneMoveWithBarAndBearOff»,
  // увеличивая счётчик, если получилось.

  let usedCount = 0;

  // Копии начальные
  let tempBoard = deepCopyBoard(board);
  let tempCaptured = { ...captured };
  let tempOffBoard = JSON.parse(JSON.stringify(offBoard));

  for (let i = 0; i < 4; i++) {
    const result = simulateOneMoveWithBarAndBearOff(
      tempBoard,
      tempCaptured,
      tempOffBoard,
      dieValue,
      playerColor
    );
    if (result) {
      usedCount++;
      // Обновляем текущие "temp" для следующего цикла
      tempBoard = result.boardAfter;
      tempCaptured = result.capturedAfter;
      tempOffBoard = result.offBoardAfter;
    } else {
      // если ход не удался, пропускаем его (по классике нард)
      // ничего не делаем, просто следующая итерация
    }
  }

  return usedCount; // от 0 до 4
}




useEffect(() => {
  function handleDiceRolled(data) {
    if (data.tableId !== parseInt(tableId, 10)) return;

   // Берём цвет из уже известного состояния (props/state), а не из payload события
const myColor =
  (playerColor === "white" || playerColor === "black")
    ? playerColor
    : (
        (localStorage.getItem("username") && data.player1_name && localStorage.getItem("username") === data.player1_name)
          ? "white"
          : "black"
      );

// Нормализуем формат кубиков: поддерживаем
// 1) [d1, d2]
// 2) [[d1, d2], ...] (история бросков)
// 3) [[[d1, d2]]] (случайная лишняя вложенность)
function getLastDicePair(rolls) {
  if (!Array.isArray(rolls)) return null;

  // Вариант 1: rolls = [d1, d2]
  if (
    rolls.length === 2 &&
    rolls.every(v => Number.isFinite(Number(v)))
  ) {
    return [Number(rolls[0]), Number(rolls[1])];
  }

  // Вариант 2: rolls = [[d1, d2], ...]
  const last = rolls[rolls.length - 1];
  if (Array.isArray(last)) {
    if (
      last.length === 2 &&
      last.every(v => Number.isFinite(Number(v)))
    ) {
      return [Number(last[0]), Number(last[1])];
    }

    // Вариант 3: last = [[d1, d2]] (лишняя вложенность)
    if (
      last.length === 1 &&
      Array.isArray(last[0]) &&
      last[0].length === 2 &&
      last[0].every(v => Number.isFinite(Number(v)))
    ) {
      return [Number(last[0][0]), Number(last[0][1])];
    }
  }

  return null;
}

const rollsRaw = (data.currentPlayer === "player1")
  ? data.player1_rolls
  : data.player2_rolls;

const lastRoll = getLastDicePair(rollsRaw);

if (!lastRoll) {
  setNumberMove(0);
  return;
}

setRolledDice(lastRoll);
const [d1, d2] = lastRoll;

    // const lastRoll = (data.currentPlayer === "player1")
    //   ? data.player1_rolls[data.player1_rolls.length - 1]
    //   : data.player2_rolls[data.player2_rolls.length - 1];

    // if (!Array.isArray(lastRoll) || lastRoll.length < 2) {
    //   setNumberMove(0);
    //   return;
    // }

    // setRolledDice(lastRoll);
    // const [d1, d2] = lastRoll;

    const isMyTurn =
      (myColor === "white" && data.currentPlayer === "player1") ||
      (myColor === "black" && data.currentPlayer === "player2");

    if (isMyTurn) {
      // ✅ КУБИКИ ОФИЦИАЛЬНО ПРИШЛИ ОТ СЕРВЕРА → СТАВИМ hasRolledDice = true
      setHasRolledDice(true);

      const offBoard = {
        white: whiteOffBoard,
        black: blackOffBoard
      };

      const realMoves = computeRealNumberOfMoves(
        board,
        capturedCheckers,
        offBoard,
        myColor,
        d1,
        d2
      );

      setNumberMove(realMoves);

      socket.emit('ShortBackgammon_updateNumberMove', {
        tableId: parseInt(tableId, 10),
        currentPlayer: data.currentPlayer,
        numberMove: realMoves
      });
    } else {
      // 🔁 Чужой бросок — для нас "кубики не брошены"
      setHasRolledDice(false);
      setNumberMove(data.numberMove || 0);
    }
  }

  socket.on("ShortBackgammon_diceRolled", handleDiceRolled);
  return () => {
    socket.off("ShortBackgammon_diceRolled", handleDiceRolled);
  };
}, [
  tableId,
  board,
  capturedCheckers,
  whiteOffBoard,
  blackOffBoard,
  playerColor
]);







    useEffect(() => {
      console.log('33333333344444444',hasRolledDice);
      
    }, [hasRolledDice]);

  // useEffect(() => {
  //   function handleDiceRolled(data) {
     
      
  //     // 1) Проверка, что это наш стол
  //     if (data.tableId !== parseInt(tableId, 10)) return;

  //     // 2) Определяем мой цвет
  //     const myColor = (localStorage.getItem("username") === data.player1_name)
  //       ? "white"
  //       : "black";

  //     // 3) Извлекаем последний бросок
  //     const lastRoll = (data.currentPlayer === "player1")
  //       ? data.player1_rolls[data.player1_rolls.length - 1]
  //       : data.player2_rolls[data.player2_rolls.length - 1];

  //     if (!Array.isArray(lastRoll) || lastRoll.length < 2) {
  //       console.warn("lastRoll невалидный:", lastRoll);
  //       setNumberMove(0);
  //       return;
  //     }

  //     // Сохраняем в локальный стейт (для отображения)
  //     setRolledDice(lastRoll);
  //     const [d1, d2] = lastRoll;

  //     // 4) Мой ли это ход?
  //     const isMyTurn =
  //       (myColor === "white" && data.currentPlayer === "player1") ||
  //       (myColor === "black" && data.currentPlayer === "player2");

  //     if (isMyTurn) {
  //       // Формируем объект offBoard из ваших двух стейтов:
  //       const offBoard = {
  //         white: whiteOffBoard,
  //         black: blackOffBoard
  //       }; 

  //       // 5) Вызываем "computeRealNumberOfMoves" (расширенную)
  //       const realMoves = computeRealNumberOfMoves(
  //         board,             // board
  //         capturedCheckers,  // capturedCheckers
  //         offBoard,                    // { white: [...], black: [...] }
  //         myColor,
  //         d1,
  //         d2
  //       );

  //       setNumberMove(realMoves);
        
  //       // Отправляем на сервер
  //       socket.emit('ShortBackgammon_updateNumberMove', {
  //         tableId: parseInt(tableId, 10),
  //         currentPlayer: data.currentPlayer,
  //         numberMove: realMoves
  //       });
  //     } else {
  //       // НЕ мой ход => берём numberMove c сервера (или 0)
  //       setNumberMove(data.numberMove || 0);
  //     }
  //   }

  //   // Подписка на событие
  //  socket.on("ShortBackgammon_diceRolled", handleDiceRolled);

  //   // Отписка при размонтировании
  //   return () => {
  //    socket.off("ShortBackgammon_diceRolled", handleDiceRolled);
  //   };
  // }, [
  //   tableId,
  //   board,
  //   capturedCheckers,
  //   whiteOffBoard,
  //   blackOffBoard
  // ]);

 

 


function checkTwoMovesPossible(board, captured, offBoard, playerColor, d1, d2) {

  if (d1 === d2) {
    // здесь у вас дубль — лучше обрабатывать отдельно
    // (либо возвращать false и в computeRealNumberOfMoves обрабатывать)
    return false;
  }

  // Пробуем (d1 => d2)
 
  if (attemptTwoMovesSequence(board, captured, offBoard, playerColor, d1, d2)) {
    return true;
  }
  // Пробуем (d2 => d1)

  if (attemptTwoMovesSequence(board, captured, offBoard, playerColor, d2, d1)) {
    return true;
  }
  
  return false;
}


function simulateOneBearOffMove(board, captured, offBoard, fromIndex, moveDist, playerColor) {
  // 1) Копируем
  const tempBoard = deepCopyBoard(board);
  const tempCaptured = { ...captured };
  const tempOffBoard = JSON.parse(JSON.stringify(offBoard));

  // 2) Проверяем, можно ли действительно снять шашку
  //    - allCheckersInHome?
  if (!allCheckersInHome(tempBoard, playerColor)) {
    return null; // ещё не все в доме
  }
  //    - canBearOffChecker?
  if (!canBearOffChecker(fromIndex, moveDist, tempBoard, playerColor)) {
    return null;
  }

  // 3) Снимаем одну шашку с fromIndex
  if (!tempBoard[fromIndex] || !tempBoard[fromIndex].length) {
    return null; // нет шашки
  }
  const checker = tempBoard[fromIndex].pop();

  // 4) Кладём в offBoard
  tempOffBoard[playerColor] = tempOffBoard[playerColor] || [];
  tempOffBoard[playerColor].push(checker);

  // 5) Возвращаем
  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    offBoardAfter: tempOffBoard
  };
}


// Пример
function getAllPossibleOneMoves(board, captured, offBoard, playerColor, dieValue) {
 

  const resultStates = [];

  // 1) Если на баре есть шашки — пробуем ВВОД.
  const barCount = captured[playerColor] || 0;
  if (barCount > 0) {
   
    const barState = simulateOneEnterFromBar(board, captured, offBoard, dieValue, playerColor);
    if (barState) {
    
      resultStates.push(barState);
    } else {
     
    }
    // Сразу возвращаем, т.к. при наличии шашек на баре
    // другие (обычные) ходы делать нельзя, пока не освободим бар.
    return resultStates;
  }

  // 2) Если allCheckersInHome => пробуем bear off
  if (allCheckersInHome(board, playerColor)) {

    // Для белых дом = 0..5, для чёрных дом = 18..23
    const homeStart = (playerColor === 'white') ? 0 : 18;
    const homeEnd   = (playerColor === 'white') ? 6 : 24;

    for (let fromIndex = homeStart; fromIndex < homeEnd; fromIndex++) {
      if (!board[fromIndex]?.length) continue;
      if (board[fromIndex][0].color !== playerColor) continue;

      // Проверяем, можно ли именно с fromIndex вынести
      if (canBearOffChecker(fromIndex, dieValue, board, playerColor)) {
        const bearResult = simulateOneBearOffMove(board, captured, offBoard, fromIndex, dieValue, playerColor);
        if (bearResult) {
         
          resultStates.push(bearResult);
        } else {
        
        }
      }
    }
  }

  // 3) Обычный ход:
 
  for (let fromIndex = 0; fromIndex < 24; fromIndex++) {
    if (!board[fromIndex]?.length) continue;
    if (board[fromIndex][0].color !== playerColor) continue;

    const normalState = simulateOneNormalMove(board, captured, offBoard, fromIndex, dieValue, playerColor);
    if (normalState) {
  
      resultStates.push(normalState);
    }
  }


  return resultStates;
}










function attemptTwoMovesSequence(board, captured, offBoard, playerColor, firstDie, secondDie) {


  // 1) Список ВСЕХ возможных позиций после ПЕРВОГО хода (firstDie).
 
  const allPossibleFirst = getAllPossibleOneMoves(board, captured, offBoard, playerColor, firstDie);

  // Если вообще нет способов сходить 1-м ходом:
  if (allPossibleFirst.length === 0) {
 
    return false;
  }



  // 2) Для *каждого* результата первого хода пробуем второй
  for (let i = 0; i < allPossibleFirst.length; i++) {
    const firstResult = allPossibleFirst[i];
   

    // secondDie: getAllPossibleOneMoves на *уже обновлённой* позиции
    const allPossibleSecond = getAllPossibleOneMoves(
      firstResult.boardAfter,
      firstResult.capturedAfter,
      firstResult.offBoardAfter,
      playerColor,
      secondDie
    );

    if (allPossibleSecond.length > 0) {
    
      return true;
    } else {
     
    }
  }

  // Если перебрали все варианты первого хода — и нигде второй не получился:

  return false;
}

function simulateOneMoveWithBarAndBearOff(board, captured, offBoard, moveDist, playerColor) {


  // === Копии ===
  // Но тут можно сразу работать через «симуляторы», не нужно отдельно tempBoard.
  // Логика:
  //  1) Если bar>0 => пробуем simulateOneEnterFromBar
  //  2) Иначе, если allCheckersInHome => пробуем bearOff
  //  3) Иначе — перебираем все 24 fromIndex, и делаем simulateOneNormalMove

  // 1) BAR
  if (captured[playerColor] > 0) {
   
    const barResult = simulateOneEnterFromBar(board, captured, offBoard, moveDist, playerColor);
    // Если удалось, возвращаем. Если null => ход невозможен
    return barResult; // либо null
  }

  // 2) Если все в доме => пытаемся BearOff
  if (allCheckersInHome(board, playerColor)) {
    // Можно перебрать все fromIndex 0..5 (white) или 18..23 (black)
    // но, чтобы сохранить «логику одного» (как attemptBearOff), делаем небольшой цикл:
    for (let i = 0; i < 24; i++) {
      if (!board[i]?.length) continue;
      if (board[i][0].color !== playerColor) continue;
      // Пытаемся снять
      const bearOffResult = simulateOneBearOffMove(
        board, captured, offBoard, i, moveDist, playerColor
      );
      if (bearOffResult) {
        
        return bearOffResult; 
      }
    }
   
    // не вернули => значит не вышло => пойдём к "обычному ходу"
  }

  // 3) Обычный ход
  for (let i = 0; i < 24; i++) {
    if (!board[i]?.length) continue;
    if (board[i][0].color !== playerColor) continue;

    const normalResult = simulateOneNormalMove(
      board, captured, offBoard,
      i, moveDist,
      playerColor
    );
    if (normalResult) {
     
      return normalResult;
    }
  }

  // Если всё перебрали — вернём null

  return null;
}



function simulateOneEnterFromBar(originalBoard, originalCaptured, originalOffBoard, dieValue, playerColor) {
 

  // 1) Копии
  const tempBoard = deepCopyBoard(originalBoard);
  const tempCaptured = { ...originalCaptured };
  const tempOffBoard = JSON.parse(JSON.stringify(originalOffBoard));

  // 2) Целевой индекс
  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = 24 - dieValue;  // если die=3 => target=21
  } else {
    targetIndex = dieValue - 1;   // если die=3 => target=2
  }

  if (targetIndex < 0 || targetIndex > 23) {
   
    return null;
  }

  // Если на targetIndex 2+ чужих шашек — нельзя
  if (
    tempBoard[targetIndex]?.length > 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    
    return null;
  }

  // Если на баре нет шашек
  if (tempCaptured[playerColor] <= 0) {
   
    return null;
  }

  // 3) Снимаем 1 шашку с бара
  tempCaptured[playerColor]--;

  // Если там 1 чужая => сбиваем
  if (
    tempBoard[targetIndex]?.length === 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    const victim = tempBoard[targetIndex].pop();
    const opp = victim.color;
    tempCaptured[opp] = (tempCaptured[opp]||0) + 1;
   
  }

  // 4) Ставим нашу
  tempBoard[targetIndex] = tempBoard[targetIndex] || [];
  tempBoard[targetIndex].push({ color: playerColor });


  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    offBoardAfter: tempOffBoard
  };
}



/** Проверяем, «все ли шашки playerColor находятся в доме». */
function allCheckersInHome(board, playerColor) {
  if (playerColor === 'white') {
    // дом для белых — ячейки 0..5
    // значит не должно быть белых на 6..23
    for (let i = 6; i < 24; i++) {
      if (board[i]?.some(ch => ch.color === 'white')) {
        return false;
      }
    }
    return true;
  } else {
    // чёрный дом — ячейки 18..23
    for (let i = 0; i < 18; i++) {
      if (board[i]?.some(ch => ch.color === 'black')) {
        return false;
      }
    }
    return true;
  }
}


function simulateOneBearOffMove(originalBoard, originalCaptured, originalOffBoard, fromIndex, dieValue, playerColor) {
 

  const tempBoard = deepCopyBoard(originalBoard);
  const tempCaptured = { ...originalCaptured };
  const tempOffBoard = JSON.parse(JSON.stringify(originalOffBoard));

  // Проверим, есть ли там действительно наша шашка
  if (!tempBoard[fromIndex]?.length || tempBoard[fromIndex][0].color !== playerColor) {
   
    return null;
  }

  // Имеем ли право вынести? (canBearOffChecker + allCheckersInHome)
  if (!allCheckersInHome(tempBoard, playerColor)) {
   
    return null;
  }
  if (!canBearOffChecker(fromIndex, dieValue, tempBoard, playerColor)) {
   
    return null;
  }

  // Снимаем
  const checker = tempBoard[fromIndex].shift();
  // Кладём в offBoard
  tempOffBoard[playerColor] = tempOffBoard[playerColor]||[];
  tempOffBoard[playerColor].push(checker);


  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    offBoardAfter: tempOffBoard
  };
}






/** Проверяет, можно ли С ОДНОЙ конкретной позиции fromIndex снять шашку (bear off) при moveDist. */
function canBearOffChecker(fromIndex, moveDist, board, playerColor) {
  if (playerColor === 'white') {
    const dist = fromIndex + 1; // если fromIndex=5 => dist=6
    if (moveDist === dist) return true;
    if (moveDist > dist) {
      // проверяем, нет ли более дальних белых
      for (let i = fromIndex + 1; i <= 5; i++) {
        if (board[i]?.some(ch => ch.color === 'white')) return false;
      }
      return true;
    }
    return false;
  } else {
    // чёрные
    const dist = 24 - fromIndex; // если fromIndex=19 => dist=5
    if (moveDist === dist) return true;
    if (moveDist > dist) {
      for (let i = fromIndex - 1; i >= 18; i--) {
        if (board[i]?.some(ch => ch.color === 'black')) return false;
      }
      return true;
    }
    return false;
  }
}


function simulateOneNormalMove(originalBoard, originalCaptured, originalOffBoard, fromIndex, dieValue, playerColor) {
 

  const tempBoard = deepCopyBoard(originalBoard);
  const tempCaptured = { ...originalCaptured };
  const tempOffBoard = JSON.parse(JSON.stringify(originalOffBoard));

  // Проверяем, есть ли там наша шашка
  if (!tempBoard[fromIndex]?.length || tempBoard[fromIndex][0].color !== playerColor) {
    
    return null;
  }

  // Вычисляем targetIndex
  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = fromIndex - dieValue;
  } else {
    targetIndex = fromIndex + dieValue;
  }

  if (targetIndex < 0 || targetIndex >= 24) {
  
    return null;
  }

  // Если там >1 чужих
  if (
    tempBoard[targetIndex]?.length > 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
  
    return null;
  }

  // Снимаем нашу
  const movingChecker = tempBoard[fromIndex].shift();

  // Если 1 чужая => сбиваем
  if (
    tempBoard[targetIndex]?.length === 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    const victim = tempBoard[targetIndex].pop();
    tempCaptured[victim.color] = (tempCaptured[victim.color]||0)+1;
    
  }

  // Ставим свою
  tempBoard[targetIndex] = tempBoard[targetIndex]||[];
  tempBoard[targetIndex].push(movingChecker);


  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    offBoardAfter: tempOffBoard
  };
}

/** Простая deep-копия */
function deepCopyBoard(board) {
  return board.map(stack => stack.map(ch => ({ ...ch })));
}



 
useEffect(() => {
 

  // if (!tournamentHasRolledDice || !initialRollPhase) {
  if (!hasRolledDice) {
    
    return;
  }


  
  let dice = [...rolledDice];
  if (dice[0] === dice[1]) {
    dice = Array(4).fill(dice[0]);
  }

  const remainingRolls = calculateRemainingRolls(dice, []);
 


}, [hasRolledDice, initialRollPhase, rolledDice, board, playerColor]);




function calculateRemainingRolls(rolledDice, usedRolls) {
  // Пример (упрощённый)
  if (!rolledDice || rolledDice.length === 0) return [];

  let expanded;
  if (rolledDice[0] === rolledDice[1]) {
    // дубль => 4 копии
    expanded = [rolledDice[0], rolledDice[0], rolledDice[0], rolledDice[0]];
  } else {
    // обычный бросок => [d1,d2]
    expanded = [...rolledDice];
  }

  // Убираем уже использованные
  let remaining = [...expanded];
  for (let used of usedRolls) {
    const idx = remaining.indexOf(used);
    if (idx !== -1) {
      remaining.splice(idx, 1);
    }
  }

  return remaining;
}








// 2) Считает, для текущей доски и массива неиспользованных значений,
//    сколько *максимум* ещё ходов можно сделать.
function calculateMaxMovesOverall(board, playerColor, diceArray) {
  let totalMoves = 0;
  for (let i = 0; i < board.length; i++) {
    if (board[i]?.length && board[i][0].color === playerColor) {
      // Проверяем, сколько значений из diceArray дают *валидный* ход
      for (let die of diceArray) {
        const target = (playerColor === 'white') ? i - die : i + die;
        if (target < 0 || target >= 24) continue; // вне доски
        const targetPoint = board[target];
        // Можно ходить, если пусто, свои шашки, или 1 чужая (битие)
        if (
          !targetPoint ||
          targetPoint.length === 0 ||
          targetPoint.every(ch => ch.color === playerColor) ||
          (targetPoint.length === 1 && targetPoint[0].color !== playerColor)
        ) {
          totalMoves++;
        }
      }
    }
  }
  // Тут вопрос, складывать ли мы *все* потенциальные (totalMoves), ведь часть может пересекаться.
  // Простой вариант: вернуть totalMoves (обычно это «переоценка»). 
  // Более точный метод — проверка комбинирования. Но для упрощённой логики пойдёт.
  return totalMoves;
}



useEffect(() => {
  if (!firstRollComplete) {
    // console.log('[Tournament] Первый бросок: Сохраняем кубики для использования');
    const rolls = [firstRolls.player1Roll, firstRolls.player2Roll];
    // setTournamentRolledDice(rolls); // Устанавливаем кубики как доступные для текущего хода
    setUsedRolls([]); // Сбрасываем использованные броски
  }
}, [firstRolls, firstRollComplete]);


const handleTournamentFirstMove = (index, realIndex, rollValue) => {
  // console.log('[Tournament] Используем значение кубика для первого броска:', rollValue);

  // Ваша логика перемещения шашки
  const newBoard = [...board];
  const checker = newBoard[index].pop();
  newBoard[realIndex].push(checker);

  // setTournamentBoard(newBoard);

  // Добавляем использованный бросок
  setUsedRolls((prev) => [...prev, rollValue]);

  // Уменьшаем доступные ходы
  setNumberMove((prev) => prev - 1);
  setRolledDice([])
  
};






useEffect(() => {
  function handleTournamentMatchGameUpdated(payload) {
   

    // setTournamentBoard(payload.boardState || []);
    setCurrentTurn(payload.currentTurn || null);
    setPlayer1Name(payload.player1Name || '');
    setPlayer2Name(payload.player2Name || '');
    // берем из payload.yourColor
    if (payload.yourColor === 'white' || payload.yourColor === 'black') {
  setPlayerColor(payload.yourColor);
}


  // Определяем текущий игрок и обновляем состояние "бросил кубики"
  const isPlayer1 = payload.yourColor === 'white';
  const hasRolledDice = isPlayer1
    ? payload.hasRolledDicePlayer1
    : payload.hasRolledDicePlayer2;
  
  setHasRolledDice(hasRolledDice);
  



    // Только устанавливаем rolledDice, если оно присутствует в payload
    if (payload.hasOwnProperty('rolledDice')) {
      if (Array.isArray(payload.player2_rolls) && payload.player2_rolls.length > 0) {
        setRolledDice(payload.player2_rolls);
       
        
        // setTournamentHasRolledDice(true);
        // setTournamentNumberMove(payload.numberMove || 2); // Установите число ходов из payload, если есть
        setNumberMove(
             payload.numberMove !== undefined
               ? payload.numberMove
               : 0
           );
     
        // console.log('[TournamentMatch] Установлены rolledDice из gameUpdated:', payload.rolledDice);
        // console.log('[TournamentMatch] Установлено numberMove из gameUpdated:', payload.numberMove || 2);
      } else {
        // setTournamentHasRolledDice(payload.hasRolledDice || false);
        setNumberMove(0);
   
        // console.log('[TournamentMatch] rolledDice отсутствуют или пусты в gameUpdated');
      }
      
    }

    setLoading(false);
  }

  socket.on('tournamentMatch_gameUpdated', handleTournamentMatchGameUpdated);
  return () => {
    socket.off('tournamentMatch_gameUpdated', handleTournamentMatchGameUpdated);
  };
}, [
  setBoard,
  setCurrentTurn,
  setPlayer1Name,
  setPlayer2Name,
  setPlayerColor,
  setRolledDice,
  setHasRolledDice,
  setNumberMove
]);



  
  useEffect(() => {
    // Проверяем, мой ли ход
    const isMyTurn = (
      (playerColor === 'white' && currentTurn === 'player1')
      || (playerColor === 'black' && currentTurn === 'player2')
    );
    if (!isMyTurn || !hasRolledDice) {
      return;
    }
  
    // 1) Получаем remainingRolls
    const remainingRolls = calculateRemainingRolls(
     rolledDice,
      usedRolls
    );
  
    // Здесь вместо 'board' и 'playerColor' используем tournamentBoard и tournamentPlayerColor
    // const canNormalMove = canMakeAnyNormalMove(
    //   remainingRolls,
    //   tournamentBoard,
    //   tournamentPlayerColor
    // );
  
    // 2) Вызываем функцию проверки бара
    const noBarMoves = checkBarMoveAvailability(
      remainingRolls,
      board,
      capturedCheckers,
      playerColor
    );
  

  
    // if (!canNormalMove ) {
    //   console.log("[Tournament] Нет возможности войти с бара => вынужден пропуск");
    //   setTournamentNumberMove(0);
    //   // tournamentConfirmMove();
    // }
    if(noBarMoves){
      setNumberMove(0);
   
    }
  }, [
    playerColor,
   currentTurn,
    hasRolledDice,
    board,
    capturedCheckers,
    rolledDice, 
    usedRolls,
    firstRolls, 
    firstRollComplete
  ]);
  

  























  


  const handleRollDiceClick = () => {
  if (cubeBlockedRef.current) return;
  if (gameFinished) return; // Если игра закончена, ничего не делаем

  const isMyTurn =
    (playerColor === 'white' && currentTurn === 'player1') ||
    (playerColor === 'black' && currentTurn === 'player2');

  // 🔴 ВАЖНО: здесь БОЛЬШЕ НЕ трогаем hasRolledDice
  setRollEnabled(false);
  setInitialRollPhase(true);

  if (isMyTurn && !hasRolledDice) {
    socket.emit('ShortBackgammon_rollDice', {
      tableId: parseInt(tableId, 10),
      currentPlayer: currentTurn
    });
  }
};

  // const handleRollDiceClick = () => {
  //   if (cubeBlockedRef.current) return;
  //   if (gameFinished) return; // Если игра закончена, ничего не делаем
    
  //   const isMyTurn =
  //     (playerColor === 'white' && currentTurn === 'player1') ||
  //     (playerColor === 'black' && currentTurn === 'player2');
  //     setHasRolledDice(true); 
  //     // setRolledDice
  //     setRollEnabled(false);
  //     setInitialRollPhase(true); // Добавьте эту строку
  
  
  //   if (isMyTurn && !hasRolledDice) {
  //     socket.emit('ShortBackgammon_rollDice', {
  //       tableId: parseInt(tableId, 10),
  //       currentPlayer: currentTurn
  //     });
    
  //   }
 
  // };
  
   

  //////////////////////////////////////////////////////////////////////////
  // Рендер
  //////////////////////////////////////////////////////////////////////////
  if (loading) {
    return <div>{translate('game.common.loadingGame')}</div>;
  }
  if (error) {
    return <div style={{ color: 'red' }}>{translate('game.common.errorPrefix')} {error}</div>;
  }

 



  





function onPointClick(index, realIndex) {
  if (gameFinished) return; // Если игра завершена, не реагировать на клики
   if (!isConnected) return;
  ////////////////////////////////////////////////
  // 1) Базовые проверки
  ////////////////////////////////////////////////
  const isMyTurn =
    (currentTurn === (playerColor === 'white' ? 'player1' : 'player2'));
  if (!isMyTurn) return;

  // Если кубики не брошены (и это не самый первый ход):
  if (rolledDice.length === 0 && firstMoveComplete) {
    return;
  }
  
  if (numberMove <= 0) {
    return;
  }

  // Если есть шашки на баре – сначала вводим с бара
  const barCount =capturedCheckers[playerColor] || 0;
  if (barCount > 0) {
    alert(translate('game.short.enterFromBar'));
    return;
  }

  // Проверяем, что сверху действительно наша шашка
  const topChecker = board[index]?.[board[index].length - 1];
  if (!topChecker || topChecker.color !== playerColor) {
    return;
  }

  // Запоминаем тип хода «click» (для возможного Undo)
  setLastMoveType('click');

  ////////////////////////////////////////////////
  // 2) Собираем «оставшиеся» кубики (remainingRolls)
  ////////////////////////////////////////////////
  let remainingRolls;
  if (!firstRollComplete && !firstMoveComplete) {
    // Это самый первый ход (до confirm первого)
    // Берём по логике: если я белый, то [p1Roll, p2Roll], иначе наоборот
    const firstMoveRolls = [
      (playerColor === 'white')
        ? firstRolls.player1Roll
        : firstRolls.player2Roll,
      (playerColor === 'white')
        ? firstRolls.player2Roll
        : firstRolls.player1Roll,
    ];
    remainingRolls = firstMoveRolls.filter(r => !usedRolls.includes(r));
  } else {
    // Обычный ход
    remainingRolls = rolledDice.filter(r => !usedRolls.includes(r));
  }

  // Если выпал дубль, «раскладываем» до 4
  if (rolledDice.length === 2 && (rolledDice[0] === rolledDice[1])) {
    const dieVal = rolledDice[0];
    const usedTimes = usedRolls.filter(x => x === dieVal).length;
    const totalLeft = 4 - usedTimes; // сколько ещё раз можно использовать дубль
    for (let i = 0; i < totalLeft; i++) {
      remainingRolls.push(dieVal);
    }
  }

  // Сортируем их по убыванию,
  // чтобы приоритетным было «большее» значение кубика
  remainingRolls.sort((a, b) => b - a);

  ////////////////////////////////////////////////
  // 3) Проверка «все ли шашки в доме» (Bear Off)
  ////////////////////////////////////////////////

  ////////////////////////////////////////////////
// 3) Проверка «все ли шашки в доме» (Bear Off)
////////////////////////////////////////////////
if (allCheckersInHome(board, playerColor)) {
  // Пробуем каждый возможный leftoverRoll
  for (let dieVal of remainingRolls) {
    // можно ли снять именно с этой точки этим кубиком
    if (!canBearOffChecker(index, dieVal, board, playerColor)) continue;

    // симулируем снятие, чтобы проверить, не блокируем ли второй кубик
    const simBear = simulateOneBearOffMove(
      board,
      capturedCheckers,
      { white: whiteOffBoard, black: blackOffBoard },
      index,
      dieVal,
      playerColor
    );
    if (!simBear) continue;

    // если кубики разные и у нас ещё >= 2 ходов — запретим ход, который «ломает» второй кубик
    if (rolledDice[0] !== rolledDice[1] && numberMove >= 2) {
      const leftoverAfter = removeOneDistFromArray(remainingRolls, dieVal);

      const canSecond =
        canMakeAtLeastOneMove(
          simBear.boardAfter,
          simBear.capturedAfter,
          leftoverAfter,
          playerColor
        ) ||
        canBearOffAny(
          simBear.boardAfter,
          leftoverAfter,
          playerColor
        );

      if (!canSecond) {
        // можно заменить на свой toast/уведомление
        // alert('Этот ход блокирует второй кубик! Сыграйте иначе.');
        continue; // пробуем другой dieVal
      }
    }

    // === (A) Снимаем шашку по-настоящему
    // const { newBoard, checker } = handleBearOff(
    //   index,
    //   dieVal,
    //   board,
    //   playerColor,
    //   whiteOffBoard,
    //   blackOffBoard,
    //   setWhiteOffBoard,
    //   setBlackOffBoard
    // );
// const {
//   newBoard,
//   checker,
//   nextWhiteOffBoard,
//   nextBlackOffBoard
// } = handleBearOff(
//   index,
//   dieVal,
//   board,
//   playerColor,
//   whiteOffBoard,
//   blackOffBoard
// );

// // Обновляем off-board стейты ЯВНО значениями из handleBearOff
// setWhiteOffBoard(nextWhiteOffBoard);
// setBlackOffBoard(nextBlackOffBoard);

//     // === (B) Пишем историю для Undo
//     setMoveHistory(prev => [
//       ...prev,
//       {
//         from: index,
//         to: 'off',
//         checker,
//         capturedChecker: null,
//         board: deepCopyBoard(newBoard),
//         diceValuesUsed: [dieVal],
//         updatedCapturedCheckers: { ...capturedCheckers },
//         numberMove
//       }
//     ]);

//     // === (C) Обновляем броски и счётчик ходов
//     setUsedRolls(prev => [...prev, dieVal]);
//     setNumberMove(prev => prev - 1);
//     setBoard(newBoard);
// console.log('3453453544',{
//       tableId: parseInt(tableId, 10),
//       boardState: newBoard,
//       player: (playerColor === 'white') ? 'player1' : 'player2',
//       updatedCapturedCheckers: { ...capturedCheckers },
//       whiteOffBoard,
//       blackOffBoard,
//       ephemeral: true
//     });

//     // === (D) Эфемерно уведомляем оппонента
//     socket.emit('backgammon_updateBoardState', {
//       tableId: parseInt(tableId, 10),
//       boardState: newBoard,
//       player: (playerColor === 'white') ? 'player1' : 'player2',
//       updatedCapturedCheckers: { ...capturedCheckers },
//       whiteOffBoard,
//       blackOffBoard,
//       ephemeral: true
//     });

//     // === (E) Проверяем, остались ли после снятия ещё ходы
//     setTimeout(() => {
//       checkIfAnyMovesLeft(dieVal, newBoard, capturedCheckers);
//     }, 0);

//     return; // сходили — выходим
//   }
const {
  newBoard,
  checker,
  nextWhiteOffBoard,
  nextBlackOffBoard
} = handleBearOff(
  index,
  dieVal,
  board,
  playerColor,
  whiteOffBoard,
  blackOffBoard
);

// сначала обновляем off-board стейты
setWhiteOffBoard(nextWhiteOffBoard);
setBlackOffBoard(nextBlackOffBoard);

// === (B) Пишем историю для Undo
setMoveHistory(prev => [
  ...prev,
  {
    from: index,
    to: 'off',
    checker,
    capturedChecker: null,
    board: deepCopyBoard(newBoard),
    diceValuesUsed: [dieVal],
    updatedCapturedCheckers: { ...capturedCheckers },
    numberMove
  }
]);

// === (C) Обновляем броски и счётчик ходов
setUsedRolls(prev => [...prev, dieVal]);
setNumberMove(prev => prev - 1);
setBoard(newBoard);

// Готовим ПРАВИЛЬНЫЙ payload с НОВЫМИ off-board
const payload = {
  tableId: parseInt(tableId, 10),
  boardState: newBoard,
  player: (playerColor === 'white') ? 'player1' : 'player2',
  updatedCapturedCheckers: { ...capturedCheckers },
  whiteOffBoard: nextWhiteOffBoard,
  blackOffBoard: nextBlackOffBoard,
  ephemeral: true
};

console.log('3453453544', payload);

// === (D) Эфемерно уведомляем оппонента
socket.emit('backgammon_updateBoardState', payload);

// === (E) Проверяем, остались ли после снятия ещё ходы
setTimeout(() => {
  checkIfAnyMovesLeft(dieVal, newBoard, capturedCheckers);
}, 0);

return;
  }
}



  ////////////////////////////////////////////////
  // 4) Обычный ход (без Bear Off)
  ////////////////////////////////////////////////
  let chosenDie = null;
  let finalBoard = null;
  let finalCaptured = null;
  let finalCapturedChecker = null;
  let targetIndex = -1;
  let foundMove = false;

  // Проходим по remainingRolls (от большего к меньшему)
  for (let dieVal of remainingRolls) {
    // Целевая позиция
    const candidateTarget = (playerColor === 'white')
      ? (index - dieVal)
      : (index + dieVal);

    if (candidateTarget < 0 || candidateTarget >= 24) {
      // вне диапазона => пропускаем
      continue;
    }

    // Если там 2+ чужих => нельзя
    const stackAtTarget = board[candidateTarget] || [];
    if (
      stackAtTarget.length > 1 &&
      stackAtTarget[0].color !== playerColor
    ) {
      continue;
    }

    // Копируем и пробуем «simulateOneMove»
    const boardCopy = deepCopyBoard(board);
    const capturedCopy = { ...capturedCheckers };

    const sim = simulateOneMove(
      boardCopy,
      capturedCopy,
      { fromIndex: index, moveDist: dieVal, playerColor: playerColor }
    );
    if (!sim) {
      // Ход невозможен => ищем следующий dieVal
      continue;
    }

    // === (A) Если у нас ещё >=2 ходов и броски разные (5-6, а не дубль),
    //         нужно проверить, **не блокируем** ли мы второй ход.
    //         Т.е. есть ли возможность сыграть «оставшийся» кубик(и).
    //         При этом второй ход может оказаться Bear Off (если после первого
    //         в дом зашла последняя шашка).
    if (rolledDice[0] !== rolledDice[1] && numberMove >= 2) {
      // leftoverAfter убираем dieVal
      const leftoverAfter = removeOneDistFromArray(remainingRolls, dieVal);

      // Проверяем, есть ли хотя бы один возможный ход,
      // включая bear off, на «обновлённой» доске sim.boardAfter
      const canSecond = canMakeAtLeastOneMove(
        sim.boardAfter,
        sim.capturedAfter,
        leftoverAfter,
        playerColor
      );
      // Дополнительно проверяем, можно ли bear off (вдруг теперь все вошли в дом)
      const canBearSecond = canBearOffAny(
        sim.boardAfter,
        leftoverAfter,
        playerColor
      );

      if (!canSecond && !canBearSecond) {
        // Этот ход «блокирует» второй кубик => пропускаем
        alert(translate('game.short.blocksSecondDie'));
        continue;
      }
    }

    // Если дошли сюда => ход допустим
    chosenDie = dieVal;
    foundMove = true;
    targetIndex = candidateTarget;
    finalBoard = sim.boardAfter;
    finalCaptured = sim.capturedAfter;
    finalCapturedChecker = sim.capturedChecker;
    break; // выходим из цикла по кубикам
  }

  if (!foundMove || !finalBoard) {
    // Вообще не нашлось хода => выходим
    return;
  }

  ////////////////////////////////////////////////
  // 5) Применяем ход окончательно
  ////////////////////////////////////////////////
  // 5.1) Пишем в history для Undo
  setMoveHistory(prev => [
    ...prev,
    {
      from: index,
      to: targetIndex,
      checker: { color: playerColor },
      capturedChecker: finalCapturedChecker || null,
      board: deepCopyBoard(finalBoard),
      diceValuesUsed: [chosenDie],
      updatedCapturedCheckers: { ...finalCaptured },
      numberMove:numberMove,
    }
  ]);

  // 5.2) Уменьшаем `numberMove` и записываем usedRolls
  setUsedRolls(prev => [...prev, chosenDie]);
  setNumberMove(prev => prev - 1);

  // 5.3) Обновляем board / captured
  setBoard(finalBoard);
  setCapturedCheckers(finalCaptured);

  // 5.4) Проверяем, остались ли ещё ходы
  setTimeout(() => {
    checkIfAnyMovesLeft(chosenDie, finalBoard, finalCaptured);
  }, 0);

  // 5.5) Отправляем «эфемерное» обновление (без confirm)
  //      чтобы оппонент увидел новый расклад
  console.log('34534345',{
    tableId: parseInt(tableId, 10),
    boardState: finalBoard,
    player: (playerColor === 'white') ? 'player1' : 'player2',
    updatedCapturedCheckers: { ...finalCaptured },
    whiteOffBoard: whiteOffBoard,
    blackOffBoard: blackOffBoard,
    ephemeral: true,
  });
  
  socket.emit('backgammon_updateBoardState', {
    tableId: parseInt(tableId, 10),
    boardState: finalBoard,
    player: (playerColor === 'white') ? 'player1' : 'player2',
    updatedCapturedCheckers: { ...finalCaptured },
    whiteOffBoard: whiteOffBoard,
    blackOffBoard: blackOffBoard,
    ephemeral: true,
  });

  ////////////////////////////////////////////////
  // Вспомогательная функция checkIfAnyMovesLeft
  ////////////////////////////////////////////////
  function checkIfAnyMovesLeft(usedDie, currentBoard, currentCaptured) {
    // Если это *самый первый* ход (до confirm)
    // и мы ещё не закончили «первый бросок», можно пропустить
    if (!firstRollComplete && !firstMoveComplete) {
      return;
    }

    // leftoverDice – убираем только что использованный usedDie
    const leftoverDice = usedDie
      ? calculateRemainingRolls(
          rolledDice,
          [...usedRolls, usedDie]
        )
      : calculateRemainingRolls(
          rolledDice,
          [...usedRolls]
        );

    // Проверяем, есть ли хоть один ход
    const canMoveFurther = canMakeAtLeastOneMove(
      currentBoard || board,
      currentCaptured || capturedCheckers,
      leftoverDice,
      playerColor
    );
    const canBearFurther = canBearOffAny(
      currentBoard || board,
      leftoverDice,
      playerColor
    );

    if (!canMoveFurther && !canBearFurther) {
      // Всё, ходов нет
      setNumberMove(0);
    }
  }
}




const canUseDieShort = (board, captured, fromIndex, distance, playerColor) => {
  // если шашки на баре – ходим только с бара
  if (captured[playerColor] > 0 && fromIndex !== 25) return false;

  const sim = simulateOneMove(
    board,
    captured,
    { fromIndex, moveDist: distance, playerColor }
  );
  return !!sim;            // true, если ход возможен
};








  
// ========================
//  DragStart
// ========================
function handleDragStart(e, pointIndex, checkerIndex, isFromBar = false) {
  // Сохраняем в dataTransfer любую нужную информацию:
  const dragData = {
    pointIndex,
    checkerIndex,
    isFromBar
  };
  e.dataTransfer.setData('text', JSON.stringify(dragData));

  
}



// ========================
//  DragOver
// ========================
function handleDragOver(e) {
  e.preventDefault();
}

// ========================
//  DragDrop
// ========================
function handleDrop(e, targetIndex) {
  e.preventDefault();
  if (gameFinished) return;
  if (!isConnected) return;
  // -- 1) Проверка: мой ход, есть ли numberMove>0? --
  const isMyTurn =
    (playerColor === 'white' && currentTurn === 'player1') ||
    (playerColor === 'black' && currentTurn === 'player2');
  if (!isMyTurn) return;

  // если это не первый ход, но кубики не брошены => выходим
  if (!hasRolledDice && firstRollComplete) {
    return;
  }
  if (numberMove === 0) return;




  let baseDice;
  if (!firstRollComplete && !firstMoveComplete) {
    // Первый ход: берём из tournamentFirstRolls
    if (playerColor === 'white') {
      baseDice = [firstRolls.player1Roll, firstRolls.player2Roll];
    } else {
      baseDice = [firstRolls.player2Roll, firstRolls.player1Roll];
    }
  } else {
    // Обычный ход: берём из tournamentRolledDice
    baseDice = [...rolledDice];
  }



  // -- 2) Бар: если есть захваченные, ходим только с бара --
  if (capturedCheckers[playerColor] > 0) {
    const dragDataRaw = e.dataTransfer.getData('text');
    if (!dragDataRaw) return;
    const dragData = JSON.parse(dragDataRaw);
    if (!dragData.isFromBar) {
      alert(translate('game.short.enterFromBar'));
      return;
    }
  }

  // -- 3) Извлекаем из dataTransfer --
  const dragDataRaw = e.dataTransfer.getData('text');
  if (!dragDataRaw) return;
  const { pointIndex, checkerIndex, isFromBar } = JSON.parse(dragDataRaw);

  // -- 4) Копируем board/captured --
  const newBoard = deepCopyBoard(board);
  const updatedCaptured = { ...capturedCheckers };

  // -- 5) Считаем moveDist --
  let moveDist;
  if (isFromBar) {
    moveDist = (playerColor === 'white')
      ? (24 - targetIndex)
      : (targetIndex + 1);
  } else {
    moveDist = (playerColor === 'white')
      ? (pointIndex - targetIndex)
      : (targetIndex - pointIndex);
  }

  // -- 6) Оставшиеся кубики (например [6,3] или дубль [4,4,4,4]) --
  let remainingRolls = calculateRemainingRolls(
    // tournamentRolledDice,
    baseDice,
    usedRolls
  );
  // сортируем по убыванию, если хотите
  remainingRolls.sort((a,b)=>b-a);



// ——— Разрешение/запрет порядка кубиков (с учётом выноса) ———
if (
  remainingRolls.length === 2 &&
  remainingRolls[0] !== remainingRolls[1]   // не дубль
) {
  const [bigger, smaller] = [...remainingRolls].sort((a, b) => b - a);

  const fromIndex =
    (capturedCheckers[playerColor] > 0 || isFromBar) ? 25 : pointIndex;

  // фактическая дистанция именно этого dnd-перемещения
  const actualDistance = (fromIndex === 25)
    ? (playerColor === 'white' ? 24 - targetIndex : targetIndex + 1)
    : (playerColor === 'white' ? pointIndex - targetIndex : targetIndex - pointIndex);

  // Был ли «большой» возможен СЕЙЧАС (обычный ход ИЛИ вынос)?
  const canBiggerFromOrigin =
    canMakeAtLeastOneMove(board, capturedCheckers, [bigger], playerColor) ||
    canBearOffAny(board, [bigger], playerColor);

  // Что будет, если сначала сыграть «малый»?
  const afterSmaller = simulateOneMove(board, capturedCheckers, {
    fromIndex,
    moveDist: smaller,
    playerColor
  });

  const canBiggerAfterSmaller = !!afterSmaller && (
    canMakeAtLeastOneMove(afterSmaller.boardAfter, afterSmaller.capturedAfter, [bigger], playerColor) ||
    canBearOffAny(afterSmaller.boardAfter, [bigger], playerColor)
  );

  // Блокируем малый ТОЛЬКО если он реально убивает большой.
  if (canBiggerFromOrigin && !canBiggerAfterSmaller && actualDistance === smaller) {
    return; // надо сыграть сначала большим
  }
}

if (!isFromBar && (capturedCheckers[playerColor] || 0) === 0) {
  if (remainingRolls.length >= 2) {
    // исходная точка
    const fromIndex = pointIndex;

    // фактическая дистанция дропа (from -> target)
    const dropDist = (playerColor === 'white')
      ? (pointIndex - targetIndex)
      : (targetIndex - pointIndex);

    let comboApplied = false;

    // Перебираем упорядоченные пары значений кубиков (i != j)
    outer:
    for (let i = 0; i < remainingRolls.length; i++) {
      for (let j = 0; j < remainingRolls.length; j++) {
        if (i === j) continue;
        const a = remainingRolls[i];
        const b = remainingRolls[j];

        // финальная дистанция должна быть ровно суммой
        if (dropDist !== a + b) continue;

        // промежуточная клетка после шага на 'a'
        const midIndex = (playerColor === 'white')
          ? (fromIndex - a)
          : (fromIndex + a);

        // (страховка) финальная клетка после 'a' затем 'b' — должна совпасть с targetIndex
        const endIndex = (playerColor === 'white')
          ? (midIndex - b)
          : (midIndex + b);
        if (endIndex !== targetIndex) continue;

        // 1) симулируем шаг на 'a'
        const first = simulateOneMove(board, capturedCheckers, {
          fromIndex,
          moveDist: a,
          playerColor
        });
        if (!first) continue;

        // 2) симулируем шаг на 'b' с промежуточной клетки
        const second = simulateOneMove(first.boardAfter, first.capturedAfter, {
          fromIndex: midIndex,
          moveDist: b,
          playerColor
        });
        if (!second) continue;

        // === Ок, оба шага валидны — применяем ДВА хода «по-настоящему» ===
        // История: добавим два шага подряд (Undo вернёт по одному)
        setMoveHistory(prev => ([
          ...prev,
          {
            from: fromIndex,
            to: midIndex,
            checker: { color: playerColor },
            capturedChecker: first.capturedChecker || null,
            board: deepCopyBoard(first.boardAfter),
            diceValuesUsed: [a],
            updatedCapturedCheckers: { ...first.capturedAfter },
            numberMove: numberMove
          },
          {
            from: midIndex,
            to: targetIndex,
            checker: { color: playerColor },
            capturedChecker: second.capturedChecker || null,
            board: deepCopyBoard(second.boardAfter),
            diceValuesUsed: [b],
            updatedCapturedCheckers: { ...second.capturedAfter },
            numberMove: Math.max(numberMove - 1, 0)
          }
        ]));

        // Обновляем броски и счётчик ходов
        setUsedRolls(prev => [...prev, a, b]);
        setNumberMove(prev => Math.max(prev - 2, 0));

        // Применяем финальное состояние
        setBoard(second.boardAfter);
        setCapturedCheckers(second.capturedAfter);
        setLastMoveType('drag');

        // Эфемерное оповещение оппоненту (итоговая позиция)
        socket.emit('backgammon_updateBoardState', {
          tableId: parseInt(tableId, 10),
          boardState: second.boardAfter,
          player: (playerColor === 'white') ? 'player1' : 'player2',
          updatedCapturedCheckers: second.capturedAfter,
          ephemeral: true
        });

        comboApplied = true;
        break outer;
      }
    }

    if (comboApplied) {
      // всё сделали — выходим, чтобы не идти в ветку «одним кубиком»
      return;
    }
  }
}
// === [/КОМБО] // --- NEW: комбо-ход (перетаскивание на сумму двух кубиков a+b) //Конец полного перетаскивания на оба значения кубика ---===


  // -- 7) Проверяем, что moveDist есть в leftover --
  if (!remainingRolls.includes(moveDist)) {
    
    return;
  }

  if (mustUseTwoMoves && numberMove >= 2) {
    // 8а) Симулируем этот ход
    const firstMoveSim = simulateOneMove(newBoard, updatedCaptured, {
      fromIndex: isFromBar ? 25 : pointIndex,
      moveDist,
      playerColor: playerColor
    });
    if (!firstMoveSim) {
      // сам ход невозможен, выходим
   
      return;
    }

    // 8б) убираем moveDist из leftover
    const leftoverAfterThis = removeOneDistFromArray(remainingRolls, moveDist);

    // 8в) Проверяем, можем ли мы на `leftoverAfterThis[0]` (или все оставшиеся) сходить из newBoardAfter.
    //     Если *вообще не можем* сделать второй ход, значит блокируем.
    const canStillUseSecond = canMakeAtLeastOneMove(
      firstMoveSim.boardAfter,
      firstMoveSim.capturedAfter,
      leftoverAfterThis,
      playerColor
    );

    if (!canStillUseSecond) {
      alert(translate('game.short.blocksSecondDie'));
      return;
    }
  }

  // -- 9) Всё ок, выполняем реальный ход "по-настоящему" --
  let movingChecker;
  if (isFromBar) {
    if (updatedCaptured[playerColor] <= 0) {
      
      return;
    }
    movingChecker = { color:playerColor };
    updatedCaptured[playerColor]--;
  } else {
    if (!newBoard[pointIndex] || !newBoard[pointIndex][checkerIndex]) {
      
      return;
    }
    movingChecker = newBoard[pointIndex].splice(checkerIndex,1)[0];
  }

  // Bear-off dnd пока не рассматриваем:
  if (targetIndex < 0 || targetIndex>23) {
    
    return;
  }

  // если на targetIndex >1 чужая => нельзя
  if (
    newBoard[targetIndex]?.length > 1 &&
    newBoard[targetIndex][0].color !== playerColor
  ) {
    
    return;
  }

  // сбитие, если 1 чужая
  let capturedChecker = null;
  if (
    newBoard[targetIndex]?.length===1 &&
    newBoard[targetIndex][0].color!==playerColor
  ) {
    capturedChecker = newBoard[targetIndex].pop();
    updatedCaptured[capturedChecker.color] =
      (updatedCaptured[capturedChecker.color]||0)+1;
  }

  // ставим нашу
  newBoard[targetIndex] = newBoard[targetIndex]||[];
  newBoard[targetIndex].push(movingChecker);

  // -- 10) пишем в историю --
  const currentNumberMove = numberMove;
  setMoveHistory(prev=>[
    ...prev,
    {
      from: isFromBar?25:pointIndex,
      to: targetIndex,
      board: deepCopyBoard(newBoard),
      checker: movingChecker,
      capturedChecker,
      diceValuesUsed:[moveDist],
      updatedCapturedCheckers: {...updatedCaptured},
      numberMove: currentNumberMove
    }
  ]);

  // -- 11) Обновляем usedRolls / numberMove --
  setUsedRolls(prev=>[...prev, moveDist]);
  setNumberMove(prev=>Math.max(prev-1,0));

  // -- 12) Применяем локально --
  setBoard(newBoard);
  setCapturedCheckers(updatedCaptured);
  setLastMoveType('drag');

  // -- 13) Оповещаем сервер --
  socket.emit('backgammon_updateBoardState',{
    tableId: parseInt(tableId,10),
    boardState: newBoard,
    player: (playerColor==='white')?'player1':'player2',
    updatedCapturedCheckers: updatedCaptured,
    // whiteOffBoard: whiteOffBoard,
    // blackOffBoard: blackOffBoard,
    ephemeral: true
  });
}


function checkSingleMovePossible(board, captured, offBoard, playerColor, d1, d2) {
  // Если дубль => 4 копии
  const diceArr = (d1 === d2)
    ? [d1, d1, d1, d1]
    : [d1, d2];

  for (let dist of diceArr) {
    const result = simulateOneMoveWithBarAndBearOff(
      board,
      captured,
      offBoard,
      dist,
      playerColor
    );
    if (result) {
      return true; 
    }
  }
  return false;
}


function canMakeAtLeastOneMove(board, captured, leftoverDice, playerColor) {
  // Пробуем каждый dist из leftoverDice
  for (let dist of leftoverDice) {
    // 1) Если есть шашки на баре (captured[playerColor] > 0), пробуем ход с бара
    if (captured[playerColor] > 0) {
      const simBar = simulateOneMove(board, captured, {
        fromIndex: 25,
        moveDist: dist,
        playerColor
      });
      if (simBar) {
        return true; // нашли хоть 1 вариант
      }
    }

    // 2) Пробуем ходить со всех пунктов 0..23
    for (let i=0; i<24; i++) {
      if (board[i]?.length && board[i][board[i].length - 1].color === playerColor) {
        const sim = simulateOneMove(board, captured, {
          fromIndex: i,
          moveDist: dist,
          playerColor
        });
        if (sim) {
          return true;
        }
      }
    }
  }
  return false;
}


function removeOneDistFromArray(diceArray, val) {
  const copy = [...diceArray];
  const idx = copy.indexOf(val);
  if (idx !== -1) {
    copy.splice(idx, 1);
  }
  return copy;
}



function simulateOneMove(originalBoard, originalCaptured, { fromIndex, moveDist, playerColor }) {
  // 1) Делаем копии
  const tempBoard = deepCopyBoard(originalBoard);
  const tempCaptured = { ...originalCaptured };

  // let targetIndex;
  // if (playerColor === 'white') {
  //   targetIndex = fromIndex - moveDist;
  // } else {
  //   targetIndex = fromIndex + moveDist;
  // }
  let targetIndex;
 if (fromIndex === 25) {                        // вход с бара
   targetIndex = (playerColor === 'white')
     ? 24 - moveDist           // white: 6‑точка = die 1  ⇒ 24‑1 = 23
     : moveDist - 1;           // black: 19‑точка = die 1 ⇒ 1‑1  = 0
 } else {
   targetIndex = (playerColor === 'white')
     ? fromIndex - moveDist
     : fromIndex + moveDist;
 }

  // 2) Проверки границ
  if (targetIndex < 0 || targetIndex > 23) {
    return null;
  }

  // 3) Снимаем шашку (бар или доска)
  if (fromIndex === 25) {
    // бар
    if (tempCaptured[playerColor] <= 0) {
      return null;
    }
    tempCaptured[playerColor]--;
  } else {
    // доска
    if (!tempBoard[fromIndex]?.length) {
      return null;
    }
    const topChecker = tempBoard[fromIndex][tempBoard[fromIndex].length - 1];
    if (topChecker.color !== playerColor) {
      return null;
    }
    tempBoard[fromIndex].pop();
  }

  // 4) Если 2+ чужих на targetIndex => null
  if (
    tempBoard[targetIndex]?.length > 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    return null;
  }

  // 5) Если 1 чужая => сбиваем
  let capturedChecker = null;
  if (
    tempBoard[targetIndex]?.length === 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    capturedChecker = tempBoard[targetIndex].pop();
    const oppColor = capturedChecker.color;
    tempCaptured[oppColor] = (tempCaptured[oppColor] || 0) + 1;
  }

  // 6) Ставим свою
  tempBoard[targetIndex] = tempBoard[targetIndex] || [];
  tempBoard[targetIndex].push({ color: playerColor });

  // 7) Возвращаем объект
  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    capturedChecker // добавили
  };
}



function applyOneDieStep(tempBoard, playerColor, dieValue) {
  // Перебираем все ячейки доски (0..23)
  for (let fromIndex = 0; fromIndex < 24; fromIndex++) {
    // Проверяем, есть ли там шашка нашего цвета
    if (
      tempBoard[fromIndex] &&
      tempBoard[fromIndex].length > 0 &&
      tempBoard[fromIndex][0].color === playerColor
    ) {
      // Пытаемся сделать ход (одношаговый)
      const moved = simulateStepMove(tempBoard, fromIndex, dieValue, playerColor);
      if (moved) {
        // Если получилось, возвращаем true
        return true;
      }
    }
  }
  // Если не получилось ни одной шашкой
  return false;
}

function simulateStepMove(tempBoard, fromIndex, dieValue, playerColor) {
  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = fromIndex - dieValue;
  } else {
    targetIndex = fromIndex + dieValue;
  }

  // 1) Проверка выхода за границы
  //    (Если хотите обрабатывать bear-off, добавьте логику тут)
  if (targetIndex < 0 || targetIndex > 23) {
    return false;
  }

  // 2) Проверка, есть ли "наша" шашка сверху на fromIndex
  if (!tempBoard[fromIndex] || tempBoard[fromIndex].length === 0) {
    return false;
  }
  if (tempBoard[fromIndex][0].color !== playerColor) {
    return false;
  }

  // 3) Проверяем, не >1 ли чужих на targetIndex
  if (
    tempBoard[targetIndex]?.length > 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    return false;
  }

  // 4) Снимаем нашу шашку (верхнюю) с fromIndex
  const movingChecker = tempBoard[fromIndex].shift(); // убираем индекс 0

  // 5) Если на targetIndex ровно 1 чужая — сбиваем
  if (
    tempBoard[targetIndex]?.length === 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    // Убираем чужую шашку
    tempBoard[targetIndex].pop();
    // При необходимости capturedCheckers[oppColor]++
  }

  // 6) Ставим нашу
  tempBoard[targetIndex] = tempBoard[targetIndex] || [];
  tempBoard[targetIndex].unshift(movingChecker);

  return true;
}





function checkFourMovesPossible(board, playerColor, dieValue) {
  // 1) Делаем копию доски, чтобы не портить оригинал.
  //    У вас может называться tournamentDeepCopyBoard(...) или deepCopyBoard(...).
  const tempBoard = deepCopyBoard(board);

  let usedCount = 0; // Сколько раз удалось сходить
  // 2) Четыре раза пытаемся применить "один" ход на dieValue
  for (let i = 0; i < 4; i++) {
    // applyOneDieStep(...) — см. ниже
    const success = applyOneDieStep(tempBoard, playerColor, dieValue);
    if (success) {
      usedCount++; // Если получилось
    }
    // Если нет, пропускаем конкретный бросок — классика нард
  }

  return usedCount; // 0..4
}

// Получить индексы точек (0..23), на которых лежит *хотя бы одна* наша шашка
function getMyPoints(board, playerColor) {
  const arr = [];
  for (let i = 0; i < 24; i++) {
    if (board[i]?.length > 0 && board[i][0].color === playerColor) {
      arr.push(i);
    }
  }
  return arr;
}

// Проверяем, можно ли "двумя РАЗНЫМИ шашками" сходить
//   - сначала на distanceA,
//   - потом другой шашкой на distanceB.
function canUseTwoDifferentCheckers(board, myPoints, distanceA, distanceB, playerColor) {
  // Проходим по всем парам (p1, p2), p1 != p2
  for (let i = 0; i < myPoints.length; i++) {
    const from1 = myPoints[i];
    // 1) Пробуем сходить шашкой с from1 на distanceA
    const boardAfter1 = simulateMove(board, from1, distanceA, playerColor);
    if (!boardAfter1) continue; // ход невозможен

    // На новой доске ищем *другую* точку для хода distanceB
    for (let j = 0; j < myPoints.length; j++) {
      const from2 = myPoints[j];
      if (from2 === from1) continue; // другая шашка
      const boardAfter2 = simulateMove(boardAfter1, from2, distanceB, playerColor);
      if (boardAfter2) {
        // Ура, нашли способ сходить
        return true;
      }
    }
  }
  return false;
}

// Проверяем, можно ли ОДНОЙ и той же шашкой сходить
// сначала distanceA, потом distanceB
function canUseSameChecker(board, myPoints, distanceA, distanceB, playerColor) {
  for (let i = 0; i < myPoints.length; i++) {
    const fromIndex = myPoints[i];
    // (1) первый ход
    const boardAfter1 = simulateMove(board, fromIndex, distanceA, playerColor);
    if (!boardAfter1) continue;

    // Шашка теперь на targetIndex= fromIndex ± distanceA
    let targetIndex = (playerColor === 'white')
      ? (fromIndex - distanceA)
      : (fromIndex + distanceA);
    if (targetIndex < 0 || targetIndex >= 24) continue;

    // (2) второй ход — снова двигаем ЭТУ ЖЕ шашку
    const boardAfter2 = simulateMove(boardAfter1, targetIndex, distanceB, playerColor);
    if (boardAfter2) {
      return true;
    }
  }
  return false;
}

function simulateMove(board, fromIndex, distance, playerColor) {
  const newBoard = deepCopyBoard(board);
  // Проверим, есть ли там наша шашка
  if (!newBoard[fromIndex] || newBoard[fromIndex].length === 0) return null;
  if (newBoard[fromIndex][0].color !== playerColor) return null;

  // targetIndex
  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = fromIndex - distance;
  } else {
    targetIndex = fromIndex + distance;
  }
  if (targetIndex < 0 || targetIndex > 23) {
    return null;
  }

  // Проверяем, нет ли там 2+ чужих
  if (newBoard[targetIndex]?.length > 1 && newBoard[targetIndex][0].color !== playerColor) {
    return null;
  }

  // Двигаем
  const movingChecker = newBoard[fromIndex].shift(); // забираем верхнюю
  newBoard[targetIndex] = newBoard[targetIndex] || [];
  newBoard[targetIndex].unshift(movingChecker); // кладём наверх

  return newBoard;
}

// Копия доски (поверхностно-глубокая для массива шашек)
function deepCopyBoard(board) {
  return board.map(stack => stack.map(ch => ({ ...ch })));
}


  // скрываем визуально куб удвоения для одиночного матча без max_bet
  const isSingleMatch = targetPoints === 1;
  const hasNoMaxBet = !tableMaxBet || Number(tableMaxBet) <= 0;
  const hideCube = isSingleMatch && hasNoMaxBet;

  // =========================
  // ЧТО ПОКАЗЫВАЕМ В АНАЛИЗЕ
  // - если пришёл анализ матча: показываем выбранную партию
  // - иначе: обычное поведение (одна партия)
  // =========================
  const isMatchAnalysis =
    gnuAnalysis?.status === 'ready' &&
    String(gnuAnalysis?.analysisMode) === 'match' &&
    Array.isArray(matchGames) &&
    matchGames.length > 0;

  const activeMatchGame = isMatchAnalysis
    ? (matchGames[Math.min(Math.max(0, selectedMatchGameIndex), matchGames.length - 1)] || null)
    : null;

  const displayConfirmedTurns = isMatchAnalysis ? (activeMatchGame?.turns || []) : confirmedTurns;
  const displayCubeEvents = isMatchAnalysis ? sliceAndShiftCubeEventsForGame(cubeEvents, activeMatchGame) : cubeEvents;

  const displayGnuAnalysis = isMatchAnalysis
    ? {
        ...gnuAnalysis,
        // показываем текст только выбранной партии
        text: activeMatchGame?.analysisText || '',
        // PR — тоже по выбранной партии (если есть)
        pr: activeMatchGame?.pr ?? gnuAnalysis.pr,
        // cubeMoves — локальные (1..N) для выбранной партии
        cubeMoves: Array.isArray(activeMatchGame?.cubeMoves) ? activeMatchGame.cubeMoves : [],
      }
    : gnuAnalysis;





  return (
    <div>
        <div>
    {/* Контроллер таймера — ничего не рисует, только обновляет стейт по сокету */}
        <ShortTimerController
        tableId={tableId}
        onCurrentTurnChange={setCurrentTurn}
        player1TimeRefs={{
          rail: player1TimeRef,
          mobile: mobilePlayer1TimeRef,
        }}
        player2TimeRefs={{
          rail: player2TimeRef,
          mobile: mobilePlayer2TimeRef,
        }}
      />

       <BoardDisplay
    
    
      canConfirmMove={canConfirmMove}
      confirmInProgress={confirmInProgressUi}

       board={board}
        currentTurn={currentTurn}
       firstRolls={firstRolls}
        // handleFirstMove = {handleFirstMove}
        confirmMove = {confirmMove}
       hasRolledDice = {hasRolledDice}
        player1Roll={firstRolls?.player1Roll}
        player2Roll={firstRolls?.player2Roll}
        countdown={countdown}
        // tournamentHandleReadyClick={handleTournamentReadyClick}
     
        showReadyButton={!rollButtonEnabled && countdown !== null}
        // tournamentShowReadyButton = {tournamentShowReadyButton}
        player1Name = {player1Name}
        player2Name = {player2Name}
        // currentTurn={currentTurn}
        countdownMessage = {countdownMessage}
        handleRollDiceClick={handleRollDiceClick}  
        showUndoButton={showUndoButton} // Настройте при необходимости
        numberMove={numberMove}
        // tournamentConfirmMove={() => {}} // Настройте при необходимости
        whiteOffBoard={whiteOffBoard}
        setWhiteOffBoard={setWhiteOffBoard}
        blackOffBoard={blackOffBoard}
        setBlackOffBoard={setBlackOffBoard}
        // handleDragStart={() => {}} // Настройте при необходимости
        handleDragStart = {handleDragStart} 
        
        handleDrop = {handleDrop}
        onPointClick = {onPointClick}
        handleDragOver = {handleDragOver}
        firstRollComplete = {firstRollComplete}
        firstMoveComplete = {firstMoveComplete}
         handleUndoMove = {handleUndoMove}
         onCheckerClick = {onCheckerClick}
         handleCloseResultModal = {handleCloseResultModal}
         showResultModal = {showResultModal}
         gameResult = {gameResult}
         gameFinished = {gameFinished}
         handleLeaveTable = {handleLeaveTable}
        //  player1Time = {player1Time}
        //  player2Time = {player2Time}
        player1TimeRef={player1TimeRef}
  player2TimeRef={player2TimeRef}
  mobilePlayer1TimeRef={mobilePlayer1TimeRef}
  mobilePlayer2TimeRef={mobilePlayer2TimeRef}
         canOfferDouble={canOfferDouble}
         betMultiplier={betMultiplier}
         onOfferDouble={handleOfferDouble}
         hideCube={hideCube}
         isCrawford={isCrawford}

        showDoubleDialog={showDoubleDialog}
        doubleOffer={doubleOffer}
        onAcceptDouble={acceptDouble}     // <--   ⚠ переименовали
        onDeclineDouble={declineDouble}
        cubeOwner = {cubeOwner}
        readOnly={isSpectator}
        onSurrenderClick = {onSurrenderClick}

         player1Avatar={player1Avatar}
        player2Avatar={player2Avatar}   
        player1Rating = {player1Rating}
        player2Rating = {player2Rating}
      
         scoreP1 = {scoreP1}
         scoreP2 = {scoreP2}
         targetPoints = {targetPoints}
         autoRoll={autoRoll}
         toggleAutoRoll = {toggleAutoRoll}
         autoConfirm={autoConfirm}
         toggleAutoConfirm={toggleAutoConfirm}
         // В режиме анализа матча показываем только выбранную партию
         cubeEvents={displayCubeEvents}
        // 🔒 во время партии GNU-анализ не передаём (иначе подсказки)
        gnuAnalysis={gameFinished ? displayGnuAnalysis : {
          status: 'idle',
          text: '',
          error: '',
          stderr: '',
          gameId: null,
          analysisMode: 'game',
          pr: null,
          equity: null,
          cubeMoves: [],
          prByGame: null,
          move_game: null,
        }}
        confirmedTurns={displayConfirmedTurns}

        // Навигация по партиям матча (только когда GNU прислал analysisMode: 'match')
        matchGames={(gameFinished && isMatchAnalysis) ? matchGames : null}
        selectedMatchGameIndex={selectedMatchGameIndex}
        onSelectMatchGame={setSelectedMatchGameIndex}
        matchGameKey={(gameFinished && isMatchAnalysis) ? `match-${selectedMatchGameIndex}` : null}
      />
      {gameFinished && displayGnuAnalysis.status === 'ready' && displayGnuAnalysis.text && (
  <GnuAnalysisViewer
    analysisText={displayGnuAnalysis.text}
    pr={displayGnuAnalysis.pr}
    cubeMoves={displayGnuAnalysis.cubeMoves}
    onShowBestMove={(bestMove) => {
      console.log('[BEST MOVE] >>>', bestMove);
      // сюда потом добавим стрелки
    }}
  />
)}

    </div>
    </div>
  ); 
};

export default ShortBackgammonBoard;
